// // import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
// // import { createPortal } from "react-dom";

// // import {
// //   ResponsiveContainer,
// //   AreaChart,
// //   Area,
// //   LineChart,
// //   Line,
// //   PieChart,
// //   Pie,
// //   Cell,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip,
// //   Legend,
// // } from "recharts";
// // import {
// //   Users,
// //   GraduationCap,
// //   Wallet,
// //   CreditCard,
// //   Search,
// //   RefreshCw,
// //   Download,
// //   X,
// //   Calendar,
// //   Building2,
// //   FileText,
// //   BookOpen,
// //   Bell,
// //   Landmark,
// //   Newspaper,
// //   ShieldCheck,
// //   ArrowUpRight,
// //   ArrowDownRight,
// //   Loader2,
// //   AlertTriangle,
// //   LayoutGrid,
// //   BarChart3,
// //   UserSearch,
// //   ClipboardList,
// //   ChevronRight,
// //   Video,
// //   HandHelping,
// //   CalendarClock,
// //   Clock,
// //   Sparkles,
// //   Minimize2,
// //   Maximize2,
// // } from "lucide-react";

// // /* =========================================================================
// //    CONFIG
// //    ========================================================================= */

// // const API_BASE = process.env.REACT_APP_API_BASEURL;

// // const REPORT_TYPES = [
// //   { key: "students", label: "All Students", icon: Users },
// //   { key: "homeTutor", label: "Home Tutor", icon: HandHelping },
// //   { key: "homeWork", label: "Homework Assistance", icon: BookOpen },
// //   { key: "subjective", label: "Subjective Exams", icon: FileText },
// //   { key: "payments", label: "Payments", icon: CreditCard },
// //   { key: "notes", label: "Exam Notes", icon: Newspaper },
// //   { key: "subadmins", label: "Sub Admins", icon: ShieldCheck },
// //   { key: "appointments", label: "Appointments", icon: CalendarClock },
// // ];

// // const TIMELINE_META = {
// //   assignment_subscription: { label: "Assignment subscription", color: "#0284C7", icon: ClipboardList },
// //   exam_notes_purchase: { label: "Exam notes purchase", color: "#16A34A", icon: BookOpen },
// //   subjective_exam_purchase: { label: "Subjective exam purchase", color: "#F59E0B", icon: FileText },
// //   live_class_purchase: { label: "Live class purchase", color: "#8B5CF6", icon: Video },
// //   home_tutor_request: { label: "Home tutor request", color: "#0EA5E9", icon: HandHelping },
// //   home_work_request: { label: "Homework request", color: "#0D9488", icon: BookOpen },
// //   appointment: { label: "Appointment", color: "#DB2777", icon: CalendarClock },
// //   payment: { label: "Payment", color: "#0F172A", icon: CreditCard },
// // };

// // const PIE_COLORS = ["#0284C7", "#16A34A", "#F59E0B", "#8B5CF6", "#0EA5E9", "#0D9488", "#DB2777", "#64748B"];

// // const NAV_ITEMS = [
// //   { key: "overview", label: "Overview", icon: LayoutGrid },
// //   { key: "analytics", label: "Analytics", icon: BarChart3 },
// //   { key: "students", label: "Students", icon: UserSearch },
// //   { key: "reports", label: "Reports", icon: ClipboardList },
// // ];

// // /* =========================================================================
// //    HELPERS
// //    ========================================================================= */

// // const authHeaders = () => {
// //   const token = localStorage.getItem("token");
// //   return token ? { Authorization: `Bearer ${token}` } : {};
// // };

// // const apiGet = async (path) => {
// //   const res = await fetch(`${API_BASE}${path}`, { headers: authHeaders() });
// //   const json = await res.json().catch(() => ({}));
// //   if (!res.ok || json?.success === false) {
// //     throw new Error(json?.message || `Request failed (${res.status})`);
// //   }
// //   return json;
// // };

// // const formatMoney = (v) => {
// //   const num = Number(v || 0);
// //   if (Number.isNaN(num)) return "\u20b90";
// //   if (Math.abs(num) >= 100000) return `\u20b9${(num / 100000).toFixed(2)}L`;
// //   return `\u20b9${num.toLocaleString("en-IN")}`;
// // };

// // const formatNum = (v) => Number(v || 0).toLocaleString("en-IN");

// // const formatDate = (d) => {
// //   if (!d) return "\u2014";
// //   try {
// //     return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
// //   } catch {
// //     return "\u2014";
// //   }
// // };

// // const formatDateTime = (d) => {
// //   if (!d) return "\u2014";
// //   try {
// //     return new Date(d).toLocaleString("en-IN", {
// //       day: "2-digit",
// //       month: "short",
// //       hour: "2-digit",
// //       minute: "2-digit",
// //     });
// //   } catch {
// //     return "\u2014";
// //   }
// // };

// // const isoDate = (d) => d.toISOString().slice(0, 10);

// // // Merge N labeled trend arrays into one recharts-friendly dataset
// // const mergeTrends = (series) => {
// //   const labels = new Set();
// //   Object.values(series).forEach((arr) => (arr || []).forEach((p) => labels.add(p.label)));
// //   const sorted = Array.from(labels).sort();
// //   return sorted.map((label) => {
// //     const row = { label };
// //     Object.entries(series).forEach(([key, arr]) => {
// //       const found = (arr || []).find((p) => p.label === label);
// //       row[key] = found ? found.count ?? found.total ?? 0 : 0;
// //     });
// //     return row;
// //   });
// // };

// // const statusTone = (status) => {
// //   const s = (status || "").toLowerCase();
// //   if (["success", "completed", "approved", "active"].includes(s)) return "success";
// //   if (["failed", "rejected", "cancelled", "expired"].includes(s)) return "danger";
// //   return "warning";
// // };

// // const downloadCSV = (data, filename) => {
// //   if (!data?.length) return;
// //   const headers = Object.keys(data[0]);
// //   const csv = [headers.join(","), ...data.map((row) => headers.map((h) => JSON.stringify(row[h] ?? "")).join(","))].join(
// //     "\n"
// //   );
// //   const blob = new Blob([csv], { type: "text/csv" });
// //   const url = window.URL.createObjectURL(blob);
// //   const a = document.createElement("a");
// //   a.href = url;
// //   a.download = filename + ".csv";
// //   a.click();
// //   window.URL.revokeObjectURL(url);
// // };

// // /* =========================================================================
// //    ROOT COMPONENT
// //    ========================================================================= */

// // export default function AdminDashboardStats() {
// //   useInjectFonts();

// //   const [tab, setTab] = useState("overview");

// //   // Global date range — drives overview + analytics + students
// //   const today = useMemo(() => new Date(), []);
// //   const monthAgo = useMemo(() => new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000), [today]);
// //   const [from, setFrom] = useState(isoDate(monthAgo));
// //   const [to, setTo] = useState(isoDate(today));
// //   const [granularity, setGranularity] = useState("day");

// //   const [overview, setOverview] = useState(null);
// //   const [overviewLoading, setOverviewLoading] = useState(true);
// //   const [overviewErr, setOverviewErr] = useState("");

// //   const [analytics, setAnalytics] = useState(null);
// //   const [analyticsLoading, setAnalyticsLoading] = useState(true);
// //   const [analyticsErr, setAnalyticsErr] = useState("");

// //   const qs = useMemo(() => `?from=${from}&to=${to}`, [from, to]);

// //   const fetchOverview = useCallback(async () => {
// //     setOverviewLoading(true);
// //     setOverviewErr("");
// //     try {
// //       const json = await apiGet(`/admin/overview${qs}`);
// //       setOverview(json.data);
// //     } catch (e) {
// //       setOverviewErr(e.message || "Something went wrong");
// //       setOverview(null);
// //     } finally {
// //       setOverviewLoading(false);
// //     }
// //   }, [qs]);

// //   const fetchAnalytics = useCallback(async () => {
// //     setAnalyticsLoading(true);
// //     setAnalyticsErr("");
// //     try {
// //       const json = await apiGet(`/admin/analytics${qs}&granularity=${granularity}`);
// //       setAnalytics(json.data);
// //     } catch (e) {
// //       setAnalyticsErr(e.message || "Something went wrong");
// //       setAnalytics(null);
// //     } finally {
// //       setAnalyticsLoading(false);
// //     }
// //   }, [qs, granularity]);

// //   useEffect(() => {
// //     fetchOverview();
// //     fetchAnalytics();
// //   }, [fetchOverview, fetchAnalytics]);

// //   const refreshAll = () => {
// //     fetchOverview();
// //     fetchAnalytics();
// //   };

// //   const loading = overviewLoading || analyticsLoading;

// //   return (
// //     <div style={S.shell}>
// //       <header style={S.header}>
// //         <div style={S.headerTop}>
// //           <div style={S.brand}>
// //             <div style={S.brandMark}>P4U</div>
// //             <div>
// //               <div style={S.brandName}>Path4U</div>
// //               <div style={S.brandSub}>Admin console</div>
// //             </div>
// //           </div>

// //           <div style={S.headerControls}>
// //             <div style={S.dateRangePill}>
// //               <Calendar size={14} color="#0369A1" />
// //               <input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} style={S.dateInput} />
// //               <span style={S.dateArrow}>&rarr;</span>
// //               <input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} style={S.dateInput} />
// //             </div>

// //             <div style={S.segmentGroup}>
// //               {["day", "month"].map((g) => (
// //                 <button
// //                   key={g}
// //                   onClick={() => setGranularity(g)}
// //                   style={{ ...S.segmentBtn, ...(granularity === g ? S.segmentBtnActive : {}) }}
// //                 >
// //                   {g === "day" ? "Daily" : "Monthly"}
// //                 </button>
// //               ))}
// //             </div>

// //             <button onClick={refreshAll} style={S.refreshBtn} disabled={loading}>
// //               <RefreshCw size={14} style={{ animation: loading ? "p4u-spin 0.9s linear infinite" : "none" }} />
// //               Refresh
// //             </button>
// //           </div>
// //         </div>

// //         <nav style={S.navRow}>
// //           {NAV_ITEMS.map((item) => {
// //             const Icon = item.icon;
// //             const active = tab === item.key;
// //             return (
// //               <button
// //                 key={item.key}
// //                 onClick={() => setTab(item.key)}
// //                 style={{ ...S.navPill, ...(active ? S.navPillActive : {}) }}
// //               >
// //                 <Icon size={15} strokeWidth={2} />
// //                 {item.label}
// //               </button>
// //             );
// //           })}
// //         </nav>
// //       </header>

// //       <main style={S.content}>
// //         {tab === "overview" && (
// //           <OverviewTab
// //             overview={overview}
// //             loading={overviewLoading}
// //             err={overviewErr}
// //             onRetry={fetchOverview}
// //             analytics={analytics}
// //           />
// //         )}
// //         {tab === "analytics" && (
// //           <AnalyticsTab analytics={analytics} loading={analyticsLoading} err={analyticsErr} onRetry={fetchAnalytics} />
// //         )}
// //         {tab === "students" && <StudentsTab from={from} to={to} />}
// //         {tab === "reports" && <ReportsTab />}
// //       </main>
// //     </div>
// //   );
// // }

// // /* =========================================================================
// //    OVERVIEW TAB
// //    ========================================================================= */

// // const OverviewTab = ({ overview, loading, err, onRetry, analytics }) => {
// //   if (loading) return <PageLoader label="Loading overview\u2026" />;
// //   if (err) return <ErrorState err={err} onRetry={onRetry} />;
// //   if (!overview) return <ErrorState err="No data available." onRetry={onRetry} />;

// //   const { company, users, masters, content, services, cms, purchases, revenue, payments, recent } = overview;

// //   const revenueSpark = (analytics?.revenueTrend || []).map((p) => p.total ?? 0);
// //   const studentSpark = (analytics?.signups?.students || []).map((p) => p.count ?? 0);
// //   const teacherSpark = (analytics?.signups?.teachers || []).map((p) => p.count ?? 0);

// //   return (
// //     <>
// //       <CompanyCard company={company} />

// //       <div style={S.kpiGrid}>
// //         <KpiCard
// //           icon={Wallet}
// //           accent="#0284C7"
// //           title="Revenue in range"
// //           value={formatMoney(revenue?.totalInRange)}
// //           footNote={`${formatMoney(revenue?.totalAllTime)} all time`}
// //           spark={revenueSpark}
// //         />
// //         <KpiCard
// //           icon={Users}
// //           accent="#16A34A"
// //           title="Students"
// //           value={formatNum(users?.students?.total)}
// //           footNote={`+${formatNum(users?.students?.newInRange)} in range \u00b7 ${formatNum(users?.students?.verified)} verified`}
// //           spark={studentSpark}
// //         />
// //         <KpiCard
// //           icon={GraduationCap}
// //           accent="#8B5CF6"
// //           title="Teachers"
// //           value={formatNum(users?.teachers?.total)}
// //           footNote={`${formatNum(users?.teachers?.pendingApproval)} pending approval`}
// //           spark={teacherSpark}
// //         />
// //         <KpiCard
// //           icon={CreditCard}
// //           accent="#0D9488"
// //           title="Payments in range"
// //           value={formatNum(payments?.totalInRange)}
// //           footNote={`${formatNum(payments?.success)} success \u00b7 ${formatNum(payments?.failed)} failed`}
// //           spark={null}
// //         />
// //       </div>

// //       <SectionTitle title="Purchases" eyebrow="Subscriptions across every product line" />
// //       <div style={S.grid5}>
// //         <MiniStat label="Assignment subs" value={purchases?.assignmentSubscriptions?.total} delta={purchases?.assignmentSubscriptions?.newInRange} />
// //         <MiniStat label="Exam notes" value={purchases?.examNotesPurchases?.total} delta={purchases?.examNotesPurchases?.newInRange} />
// //         <MiniStat label="Home tutor subs" value={purchases?.homeTutorSubscriptions?.total} delta={purchases?.homeTutorSubscriptions?.newInRange} />
// //         <MiniStat label="Homework purchases" value={purchases?.homeWorkPurchases} />
// //         <MiniStat label="Subjective exam subs" value={purchases?.subjectiveExamSubscriptions?.total} delta={purchases?.subjectiveExamSubscriptions?.newInRange} />
// //       </div>

// //       <SectionTitle title="Services" eyebrow="Requests awaiting action" />
// //       <div style={S.grid3}>
// //         <StatCard title="Home tutor" icon={HandHelping} rows={[["Total", services?.homeTutorRequests?.total], ["Pending", services?.homeTutorRequests?.pending]]} />
// //         <StatCard title="Homework assistance" icon={BookOpen} rows={[["Total", services?.homeWorkAssistance?.total], ["Pending", services?.homeWorkAssistance?.pending]]} />
// //         <StatCard title="Appointments" icon={CalendarClock} rows={[["Total", services?.appointments?.total], ["Pending", services?.appointments?.pending]]} />
// //       </div>

// //       <SectionTitle title="Content moderation" eyebrow="Exam checking pipeline" />
// //       <div style={S.grid3}>
// //         <StatCard
// //           title="Checked exams"
// //           icon={FileText}
// //           rows={[
// //             ["Total", content?.checkedExams?.total],
// //             ["Pending", content?.checkedExams?.pending],
// //             ["Approved", content?.checkedExams?.approved],
// //             ["Rejected", content?.checkedExams?.rejected],
// //           ]}
// //         />
// //         <StatCard title="Notes & exams" icon={BookOpen} rows={[["Notes", content?.notes], ["Subjective exams", content?.subjectiveExams], ["Submitted exams", content?.submittedExams]]} />
// //         <StatCard title="Live classes" icon={Video} rows={[["Total", services?.liveClasses?.total], ["Purchases", services?.liveClasses?.purchases], ["New in range", services?.liveClasses?.newInRange]]} />
// //       </div>

// //       <SectionTitle title="Masters & CMS" eyebrow="Reference data and content" />
// //       <div style={S.grid2}>
// //         <StatCard
// //           title="Master data"
// //           icon={Landmark}
// //           rows={[
// //             ["States", masters?.states],
// //             ["Cities", masters?.cities],
// //             ["Boards", masters?.boards],
// //             ["Classes", masters?.classes],
// //             ["Subjects", masters?.subjects],
// //             ["Competitions", masters?.competitions],
// //             ["Universities", masters?.universities],
// //             ["Courses", masters?.courses],
// //             ["Semesters", masters?.semesters],
// //             ["College subjects", masters?.collegeSubjects],
// //             ["NIOS classes", masters?.niosClasses],
// //             ["NIOS subjects", masters?.niosSubjects],
// //           ]}
// //         />
// //         <StatCard
// //           title="CMS"
// //           icon={Bell}
// //           rows={[
// //             ["Sliders", cms?.sliders],
// //             ["Notifications", cms?.notifications],
// //             ["Coupons (total)", cms?.coupons?.total],
// //             ["Coupons (active)", cms?.coupons?.active],
// //             ["Councils", cms?.councils],
// //             ["Jobs (total)", cms?.jobs?.total],
// //             ["Jobs (active)", cms?.jobs?.active],
// //             ["Scholarships", cms?.scholarships],
// //             ["Career categories", cms?.chooseCareer?.categories],
// //             ["Blogs", cms?.chooseCareer?.blogs],
// //           ]}
// //         />
// //       </div>

// //       <SectionTitle title="Recent activity" eyebrow="Newest entries first" />
// //       <div style={S.grid2}>
// //         <RecentTable
// //           title="Recent students"
// //           columns={["Name", "Mobile", "Email", "Joined"]}
// //           rows={(recent?.students || []).map((s) => [s.fullName || "\u2014", s.mobile || "\u2014", s.email || "\u2014", formatDateTime(s.createdAt)])}
// //         />
// //         <RecentTable
// //           title="Recent teachers"
// //           columns={["Mobile", "Approval", "Verified", "Joined"]}
// //           rows={(recent?.teachers || []).map((t) => [t.mobile || "\u2014", t.approvalStatus || "\u2014", String(t.isVerified ?? false), formatDateTime(t.createdAt)])}
// //         />
// //       </div>
// //       <div style={S.grid2}>
// //         <RecentTable
// //           title="Recent jobs"
// //           columns={["Job", "Company", "Status", "Apply till"]}
// //           rows={(recent?.jobs || []).map((j) => [j.jobTitle || "\u2014", j.companyName || "\u2014", j.status || "\u2014", formatDate(j.lastDateToApply)])}
// //         />
// //         <RecentTable
// //           title="Recent payments"
// //           columns={["Purpose", "Gateway", "Amount", "Status", "When"]}
// //           rows={(recent?.payments || []).map((p) => [p.purpose || "\u2014", p.gateway || "\u2014", formatMoney(p.amount), p.status || "\u2014", formatDateTime(p.createdAt)])}
// //         />
// //       </div>

// //       <div style={{ height: 8 }} />
// //     </>
// //   );
// // };

// // /* =========================================================================
// //    ANALYTICS TAB
// //    ========================================================================= */

// // const AnalyticsTab = ({ analytics, loading, err, onRetry }) => {
// //   if (loading) return <PageLoader label="Crunching analytics\u2026" />;
// //   if (err) return <ErrorState err={err} onRetry={onRetry} />;
// //   if (!analytics) return <ErrorState err="No analytics available." onRetry={onRetry} />;

// //   const signupData = mergeTrends({ students: analytics.signups?.students, teachers: analytics.signups?.teachers });
// //   const purchaseData = mergeTrends(analytics.purchaseTrends || {});

// //   return (
// //     <>
// //       <SectionTitle title="Revenue" eyebrow="Successful payments over time" />
// //       <div style={S.chartCard}>
// //         <ResponsiveContainer width="100%" height={300}>
// //           <AreaChart data={analytics.revenueTrend || []} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
// //             <defs>
// //               <linearGradient id="revFill" x1="0" y1="0" x2="0" y2="1">
// //                 <stop offset="5%" stopColor="#0284C7" stopOpacity={0.3} />
// //                 <stop offset="95%" stopColor="#0284C7" stopOpacity={0} />
// //               </linearGradient>
// //             </defs>
// //             <CartesianGrid strokeDasharray="3 4" stroke="#E4EEF7" vertical={false} />
// //             <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748B", fontFamily: "JetBrains Mono, monospace" }} axisLine={{ stroke: "#E4EEF7" }} tickLine={false} />
// //             <YAxis tick={{ fontSize: 11, fill: "#64748B", fontFamily: "JetBrains Mono, monospace" }} axisLine={false} tickLine={false} tickFormatter={(v) => formatMoney(v)} width={70} />
// //             <Tooltip content={<ChartTooltip moneyKeys={["total"]} />} />
// //             <Area type="monotone" dataKey="total" stroke="#0284C7" strokeWidth={2.5} fill="url(#revFill)" name="Revenue" />
// //           </AreaChart>
// //         </ResponsiveContainer>
// //       </div>

// //       <div style={S.grid2}>
// //         <DonutCard title="Revenue by purpose" data={analytics.revenueByPurpose} valueKey="total" nameKey="_id" money />
// //         <DonutCard title="Revenue by gateway" data={analytics.revenueByGateway} valueKey="total" nameKey="_id" money />
// //       </div>

// //       <SectionTitle title="Growth" eyebrow="Signups over time" />
// //       <div style={S.chartCard}>
// //         <ResponsiveContainer width="100%" height={280}>
// //           <LineChart data={signupData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
// //             <CartesianGrid strokeDasharray="3 4" stroke="#E4EEF7" vertical={false} />
// //             <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748B", fontFamily: "JetBrains Mono, monospace" }} axisLine={{ stroke: "#E4EEF7" }} tickLine={false} />
// //             <YAxis tick={{ fontSize: 11, fill: "#64748B", fontFamily: "JetBrains Mono, monospace" }} axisLine={false} tickLine={false} width={40} />
// //             <Tooltip content={<ChartTooltip />} />
// //             <Legend wrapperStyle={{ fontSize: 12, fontFamily: "Inter, sans-serif" }} />
// //             <Line type="monotone" dataKey="students" stroke="#0284C7" strokeWidth={2.5} dot={false} name="Students" />
// //             <Line type="monotone" dataKey="teachers" stroke="#16A34A" strokeWidth={2.5} dot={false} name="Teachers" />
// //           </LineChart>
// //         </ResponsiveContainer>
// //       </div>

// //       <SectionTitle title="Purchases" eyebrow="Volume by product line, over time" />
// //       <div style={S.chartCard}>
// //         <ResponsiveContainer width="100%" height={300}>
// //           <LineChart data={purchaseData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
// //             <CartesianGrid strokeDasharray="3 4" stroke="#E4EEF7" vertical={false} />
// //             <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748B", fontFamily: "JetBrains Mono, monospace" }} axisLine={{ stroke: "#E4EEF7" }} tickLine={false} />
// //             <YAxis tick={{ fontSize: 11, fill: "#64748B", fontFamily: "JetBrains Mono, monospace" }} axisLine={false} tickLine={false} width={40} />
// //             <Tooltip content={<ChartTooltip />} />
// //             <Legend wrapperStyle={{ fontSize: 11, fontFamily: "Inter, sans-serif" }} />
// //             <Line type="monotone" dataKey="assignmentSubscriptions" stroke="#0284C7" strokeWidth={2} dot={false} name="Assignment subs" />
// //             <Line type="monotone" dataKey="examNotesPurchases" stroke="#16A34A" strokeWidth={2} dot={false} name="Exam notes" />
// //             <Line type="monotone" dataKey="subjectiveExamPurchases" stroke="#F59E0B" strokeWidth={2} dot={false} name="Subjective exams" />
// //             <Line type="monotone" dataKey="liveClassPurchases" stroke="#8B5CF6" strokeWidth={2} dot={false} name="Live classes" />
// //           </LineChart>
// //         </ResponsiveContainer>
// //       </div>

// //       <SectionTitle title="Payment health" eyebrow="Status breakdown across the range" />
// //       <div style={S.grid2}>
// //         <DonutCard title="Payment status" data={analytics.paymentStatusBreakdown} valueKey="count" nameKey="_id" />
// //         <div style={S.card}>
// //           <div style={S.cardTitleRow}>
// //             <AlertTriangle size={15} color="#64748B" />
// //             <span style={S.cardTitle}>Reading this data</span>
// //           </div>
// //           <p style={S.helpText}>
// //             Revenue only counts payments with status <b>SUCCESS</b>. Failed and pending attempts show up in the status
// //             breakdown but are excluded from revenue totals. Switch the range or granularity from the header \u2014 every
// //             chart on this tab reacts to it.
// //           </p>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // /* =========================================================================
// //    STUDENTS TAB
// //    ========================================================================= */

// // const StudentsTab = ({ from, to }) => {
// //   const [q, setQ] = useState("");
// //   const [students, setStudents] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [err, setErr] = useState("");
// //   const [selected, setSelected] = useState(null);
// //   const debounceRef = useRef(null);

// //   const runSearch = useCallback(async (query) => {
// //     setLoading(true);
// //     setErr("");
// //     try {
// //       const json = await apiGet(`/admin/students/search?q=${encodeURIComponent(query || "")}&limit=25`);
// //       setStudents(json.data.students || []);
// //     } catch (e) {
// //       setErr(e.message || "Search failed");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     runSearch("");
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const onChangeQuery = (val) => {
// //     setQ(val);
// //     if (debounceRef.current) clearTimeout(debounceRef.current);
// //     debounceRef.current = setTimeout(() => runSearch(val), 350);
// //   };

// //   return (
// //     <>
// //       <SectionTitle title="Find a student" eyebrow="Search by name, email or mobile" />

// //       <div style={S.searchBar}>
// //         <Search size={16} color="#64748B" />
// //         <input
// //           value={q}
// //           onChange={(e) => onChangeQuery(e.target.value)}
// //           placeholder="Search students\u2026"
// //           style={S.searchInput}
// //         />
// //         {loading && <Loader2 size={16} color="#64748B" style={{ animation: "p4u-spin 0.9s linear infinite" }} />}
// //       </div>

// //       {err && <div style={S.inlineError}>{err}</div>}

// //       <div style={S.card} className="p4u-notouch">
// //         <table style={S.table}>
// //           <thead>
// //             <tr>
// //               <th style={S.th}>Name</th>
// //               <th style={S.th}>Mobile</th>
// //               <th style={S.th}>Email</th>
// //               <th style={S.th}>Verified</th>
// //               <th style={S.th}>Joined</th>
// //               <th style={S.th}></th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {students.length === 0 ? (
// //               <tr>
// //                 <td style={S.tdEmpty} colSpan={6}>
// //                   No students found.
// //                 </td>
// //               </tr>
// //             ) : (
// //               students.map((s) => (
// //                 <tr key={s._id} className="p4u-row" onClick={() => setSelected(s._id)} style={S.rowClickable}>
// //                   <td style={S.td}>{s.fullName || "\u2014"}</td>
// //                   <td style={{ ...S.td, ...S.mono }}>{s.mobile || "\u2014"}</td>
// //                   <td style={S.td}>{s.email || "\u2014"}</td>
// //                   <td style={S.td}>
// //                     <Badge tone={s.isVerified ? "success" : "warning"}>{s.isVerified ? "Verified" : "Unverified"}</Badge>
// //                   </td>
// //                   <td style={{ ...S.td, ...S.mono }}>{formatDate(s.createdAt)}</td>
// //                   <td style={{ ...S.td, textAlign: "right" }}>
// //                     <ChevronRight size={16} color="#94A3B8" />
// //                   </td>
// //                 </tr>
// //               ))
// //             )}
// //           </tbody>
// //         </table>
// //       </div>

// //       {selected && <StudentDrawer studentId={selected} from={from} to={to} onClose={() => setSelected(null)} />}
// //     </>
// //   );
// // };

// // const DETAIL_TABS = [
// //   { key: "overview", label: "Overview" },
// //   { key: "purchases", label: "Purchases", countKey: "purchases" },
// //   { key: "requests", label: "Requests", countKey: "serviceRequests" },
// //   { key: "payments", label: "Payments", countKey: "payments" },
// //   { key: "timeline", label: "Timeline", countKey: "timeline" },
// // ];

// // const StudentDrawer = ({ studentId, from, to, onClose }) => {
// //   const [detail, setDetail] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [err, setErr] = useState("");
// //   const [tab, setTab] = useState("overview");

// //   useEffect(() => {
// //     let cancelled = false;
// //     setLoading(true);
// //     setErr("");
// //     apiGet(`/admin/students/${studentId}/detail?from=${from || ""}&to=${to || ""}`)
// //       .then((json) => !cancelled && setDetail(json.data))
// //       .catch((e) => !cancelled && setErr(e.message || "Failed to load student"))
// //       .finally(() => !cancelled && setLoading(false));
// //     return () => {
// //       cancelled = true;
// //     };
// //   }, [studentId, from, to]);

// //   const counts = detail?.counts || {};

// //   return createPortal(
// //     <div style={S.overlay} onClick={onClose}>
// //       <div style={S.panel} onClick={(e) => e.stopPropagation()}>
// //         <div style={S.panelHead}>
// //           <span style={S.eyebrow}>Student profile</span>
// //           <button onClick={onClose} style={S.iconBtn} className="p4u-icon-btn">
// //             <X size={16} />
// //           </button>
// //         </div>

// //         <div style={S.panelBody}>
// //           {loading && <PageLoader label="Loading student\u2026" compact />}
// //           {!loading && err && <ErrorState err={err} onRetry={() => { }} compact />}

// //           {!loading && !err && detail && (
// //             <>
// //               <div style={S.hero}>
// //                 <div style={S.avatar}>{(detail.profile?.fullName || "?").slice(0, 1).toUpperCase()}</div>
// //                 <div style={S.heroText}>
// //                   <div style={S.name}>{detail.profile?.fullName || "Unnamed student"}</div>
// //                   <div style={S.metaLine}>
// //                     {detail.profile?.mobile || "\u2014"} \u00b7 {detail.profile?.email || "\u2014"}
// //                   </div>
// //                   <div style={S.metaLine}>Joined {formatDate(detail.joinedOn)}</div>
// //                 </div>
// //               </div>

// //               {/* <div style={S.spendRow}>
// //                 <div style={S.spendCard}>
// //                   <div style={S.kpiLabel}>Lifetime spend</div>
// //                   <div style={S.kpiValueSm}>{formatMoney(detail.spend?.allTime)}</div>
// //                 </div>
// //                 <div style={{ ...S.spendCard, ...S.spendCardAccent }}>
// //                   <div style={S.kpiLabel}>Spend in range</div>
// //                   <div style={{ ...S.kpiValueSm, color: "#0284C7" }}>{formatMoney(detail.spend?.inRange)}</div>
// //                 </div>
// //               </div> */}

// //               <div style={S.tabBar}>
// //                 {DETAIL_TABS.map((t) => (
// //                   <button
// //                     key={t.key}
// //                     onClick={() => setTab(t.key)}
// //                     style={{ ...S.tabBtn, ...(tab === t.key ? S.tabBtnActive : {}) }}
// //                   >
// //                     {t.label}
// //                     {t.countKey && counts[t.countKey] != null && (
// //                       <span style={S.tabCount}>{counts[t.countKey]}</span>
// //                     )}
// //                   </button>
// //                 ))}
// //               </div>

// //               <div style={S.tabContent}>
// //                 {tab === "overview" && (
// //                   <div style={S.overviewGrid}>
// //                     <SummaryStat label="Purchases" value={counts.purchases ?? 0} />
// //                     <SummaryStat label="Service requests" value={counts.serviceRequests ?? 0} />
// //                     <SummaryStat label="Payments" value={counts.payments ?? 0} />
// //                   </div>
// //                 )}

// //                 {tab === "purchases" && (
// //                   <CategoryTable rows={detail.purchasesFlat || []} emptyText="No purchases in this range." showAmount />
// //                 )}

// //                 {tab === "requests" && (
// //                   <CategoryTable rows={detail.serviceRequestsFlat || []} emptyText="No service requests in this range." />
// //                 )}

// //                 {tab === "payments" && (
// //                   <div style={S.tableScroll}>
// //                     <table style={S.table}>
// //                       <thead>
// //                         <tr>
// //                           <th style={S.th}>Purpose</th>
// //                           <th style={S.th}>Gateway</th>
// //                           <th style={S.th}>Amount</th>
// //                           <th style={S.th}>Status</th>
// //                           <th style={S.th}>Date</th>
// //                         </tr>
// //                       </thead>
// //                       <tbody>
// //                         {(detail.payments || []).length === 0 ? (
// //                           <tr>
// //                             <td style={S.tdEmpty} colSpan={5}>No payments in this range.</td>
// //                           </tr>
// //                         ) : (
// //                           detail.payments.map((p) => (
// //                             <tr key={p._id}>
// //                               <td style={S.td}>{p.purpose}</td>
// //                               <td style={S.td}>{p.gateway}</td>
// //                               <td style={{ ...S.td, ...S.mono }}>{formatMoney(p.amount)}</td>
// //                               <td style={S.td}>
// //                                 <Badge tone={statusTone(p.status)}>{p.status}</Badge>
// //                               </td>
// //                               <td style={{ ...S.td, ...S.mono }}>{formatDateTime(p.createdAt)}</td>
// //                             </tr>
// //                           ))
// //                         )}
// //                       </tbody>
// //                     </table>
// //                   </div>
// //                 )}

// //                 {tab === "timeline" && (
// //                   <div style={S.timelineWrap}>
// //                     <div style={S.timelineRail} />
// //                     {(detail.timeline || []).length === 0 && <div style={S.helpText}>No activity in this range.</div>}
// //                     {(detail.timeline || []).map((entry, i) => {
// //                       const meta = TIMELINE_META[entry.type] || { label: entry.type, color: "#64748B", icon: Clock };
// //                       const Icon = meta.icon;
// //                       return (
// //                         <div key={i} style={S.timelineItem}>
// //                           <span style={{ ...S.timelineNode, background: meta.color }} />
// //                           <div style={S.timelineCard}>
// //                             <div style={S.timelineTop}>
// //                               <span style={S.timelineLabel}>
// //                                 <Icon size={13} color={meta.color} /> {meta.label}
// //                               </span>
// //                               <span style={S.timelineDate}>{formatDateTime(entry.date)}</span>
// //                             </div>
// //                             {entry.status && <Badge tone={statusTone(entry.status)}>{entry.status}</Badge>}
// //                             {entry.type === "payment" && (
// //                               <div style={S.timelineSub}>
// //                                 {formatMoney(entry.data?.amount)} \u00b7 {entry.data?.purpose} \u00b7 {entry.data?.gateway}
// //                               </div>
// //                             )}
// //                           </div>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 )}
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </div>
// //     </div>,
// //     document.body
// //   );
// // };

// // const SummaryStat = ({ label, value }) => (
// //   <div style={S.statCard}>
// //     <div style={S.statValue}>{value}</div>
// //     <div style={S.statLabel}>{label}</div>
// //   </div>
// // );

// // const CategoryTable = ({ rows, emptyText, showAmount = false }) => (
// //   <div style={S.tableScroll}>
// //     <table style={S.table}>
// //       <thead>
// //         <tr>
// //           <th style={S.th}>Category</th>
// //           <th style={S.th}>Detail</th>
// //           {showAmount && <th style={S.th}>Amount</th>}
// //           <th style={S.th}>Status</th>
// //           <th style={S.th}>Date</th>
// //         </tr>
// //       </thead>
// //       <tbody>
// //         {rows.length === 0 ? (
// //           <tr>
// //             <td style={S.tdEmpty} colSpan={showAmount ? 5 : 4}>{emptyText}</td>
// //           </tr>
// //         ) : (
// //           rows.map((r) => (
// //             <tr key={r.id}>
// //               <td style={S.td}>{r.category}</td>
// //               <td style={S.td}>{r.title}</td>
// //               {showAmount && <td style={{ ...S.td, ...S.mono }}>{formatMoney(r.amount)}</td>}
// //               <td style={S.td}>{r.status ? <Badge tone={statusTone(r.status)}>{r.status}</Badge> : "\u2014"}</td>
// //               <td style={{ ...S.td, ...S.mono }}>{formatDateTime(r.date)}</td>
// //             </tr>
// //           ))
// //         )}
// //       </tbody>
// //     </table>
// //   </div>
// // );

// // /* =========================================================================
// //    REPORTS TAB
// //    ========================================================================= */

// // const ReportsTab = () => {
// //   const [reportType, setReportType] = useState(null);
// //   const [reportData, setReportData] = useState([]);
// //   const [show, setShow] = useState(false);
// //   const [full, setFull] = useState(false);
// //   const [loading, setLoading] = useState(false);
// //   const [err, setErr] = useState("");
// //   const [fromDate, setFromDate] = useState("");
// //   const [toDate, setToDate] = useState("");
// //   const [singleDate, setSingleDate] = useState("");
// //   const [filterMode, setFilterMode] = useState("range"); // range | single

// //   const buildParams = () => {
// //     const params = new URLSearchParams();
// //     if (filterMode === "single" && singleDate) params.append("date", singleDate);
// //     if (filterMode === "range") {
// //       if (fromDate) params.append("from", fromDate);
// //       if (toDate) params.append("to", toDate);
// //     }
// //     return params;
// //   };

// //   const openReport = async (type) => {
// //     setLoading(true);
// //     setErr("");
// //     try {
// //       let url = `/admin/report/${type}`;
// //       const params = buildParams();
// //       if (params.toString()) url += `?${params.toString()}`;
// //       const json = await apiGet(url);
// //       setReportType(type);
// //       setReportData(json.data || []);
// //       setShow(true);
// //     } catch (e) {
// //       setErr(e.message || "Failed to load report");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const applyFilters = () => {
// //     if (reportType) openReport(reportType);
// //   };

// //   const clearFilters = () => {
// //     setFromDate("");
// //     setToDate("");
// //     setSingleDate("");
// //     if (reportType) setTimeout(() => openReport(reportType), 0);
// //   };

// //   const hasActiveFilter =
// //     (filterMode === "single" && singleDate) || (filterMode === "range" && (fromDate || toDate));

// //   return (
// //     <>
// //       <SectionTitle title="Export reports" eyebrow="Pull a full table and download it as CSV" />

// //       <div style={S.filterBar}>
// //         <div style={S.segmented}>
// //           <button
// //             type="button"
// //             onClick={() => setFilterMode("range")}
// //             style={{ ...S.segmentedBtn, ...(filterMode === "range" ? S.segmentedBtnActive : {}) }}
// //           >
// //             Range
// //           </button>
// //           <button
// //             type="button"
// //             onClick={() => setFilterMode("single")}
// //             style={{ ...S.segmentedBtn, ...(filterMode === "single" ? S.segmentedBtnActive : {}) }}
// //           >
// //             Single date
// //           </button>
// //         </div>

// //         {filterMode === "range" ? (
// //           <div style={S.dateGroup}>
// //             <label style={S.dateField}>
// //               <span style={S.dateLabelSm}>From</span>
// //               <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={S.dateInputBox} />
// //             </label>
// //             <span style={S.dateSep}>\u2013</span>
// //             <label style={S.dateField}>
// //               <span style={S.dateLabelSm}>To</span>
// //               <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={S.dateInputBox} />
// //             </label>
// //           </div>
// //         ) : (
// //           <div style={S.dateGroup}>
// //             <label style={S.dateField}>
// //               <span style={S.dateLabelSm}>Date</span>
// //               <input type="date" value={singleDate} onChange={(e) => setSingleDate(e.target.value)} style={S.dateInputBox} />
// //             </label>
// //           </div>
// //         )}

// //         <div style={S.filterActions}>
// //           {hasActiveFilter && (
// //             <button type="button" onClick={clearFilters} style={S.ghostBtn}>
// //               Clear
// //             </button>
// //           )}
// //           <button
// //             type="button"
// //             onClick={applyFilters}
// //             disabled={!reportType || loading}
// //             style={{ ...S.applyBtn, opacity: !reportType || loading ? 0.4 : 1, cursor: !reportType || loading ? "not-allowed" : "pointer" }}
// //           >
// //             Apply
// //           </button>
// //         </div>
// //       </div>

// //       <div style={S.grid4}>
// //         {REPORT_TYPES.map(({ key, label, icon: Icon }) => (
// //           <button
// //             key={key}
// //             onClick={() => openReport(key)}
// //             style={{ ...S.reportTile, ...(reportType === key && show ? S.reportTileActive : {}) }}
// //           >
// //             <Icon size={18} color="#0284C7" strokeWidth={1.75} />
// //             <span>{label}</span>
// //           </button>
// //         ))}
// //       </div>

// //       {loading && <PageLoader label="Fetching report\u2026" />}
// //       {err && <div style={S.inlineError}>{err}</div>}

// //       {show &&
// //         createPortal(
// //           <div style={S.overlay} onClick={() => setShow(false)}>
// //             <div
// //               style={{
// //                 ...S.modal,
// //                 width: full ? "94vw" : 800,
// //                 maxWidth: full ? "94vw" : 800,
// //                 height: full ? "88vh" : "auto",
// //               }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div style={S.modalHead}>
// //                 <div>
// //                   <h3 style={S.modalTitle}>{reportType} report</h3>
// //                   <span style={S.modalCount}>
// //                     {reportData.length} record{reportData.length === 1 ? "" : "s"}
// //                   </span>
// //                 </div>
// //                 <div style={{ display: "flex", gap: 6 }}>
// //                   <button onClick={() => setFull((f) => !f)} style={S.iconBtn} className="p4u-icon-btn">
// //                     {full ? <Minimize2 size={15} /> : <Maximize2 size={15} />}
// //                   </button>
// //                   <button onClick={() => setShow(false)} style={S.iconBtn} className="p4u-icon-btn">
// //                     <X size={15} />
// //                   </button>
// //                 </div>
// //               </div>

// //               <div style={{ maxHeight: full ? "70vh" : 420, overflow: "auto", borderTop: "1px solid #E4EEF7" }}>
// //                 {reportData.length === 0 ? (
// //                   <div style={S.emptyState}>No records match the current filters.</div>
// //                 ) : (
// //                   <div style={S.tableScroll}>
// //                     <table style={S.table}>
// //                       <thead>
// //                         <tr>
// //                           {Object.keys(reportData[0]).map((col) => (
// //                             <th key={col} style={S.th}>{col}</th>
// //                           ))}
// //                         </tr>
// //                       </thead>
// //                       <tbody>
// //                         {reportData.map((row, i) => (
// //                           <tr key={i}>
// //                             {Object.values(row).map((val, j) => (
// //                               <td key={j} style={S.td}>{String(val)}</td>
// //                             ))}
// //                           </tr>
// //                         ))}
// //                       </tbody>
// //                     </table>
// //                   </div>
// //                 )}
// //               </div>

// //               <div style={S.modalFooter}>
// //                 <span style={S.modalFooterHint}>{hasActiveFilter ? "Filtered results" : "Showing all records"}</span>
// //                 <button
// //                   onClick={() => downloadCSV(reportData, reportType)}
// //                   disabled={reportData.length === 0}
// //                   style={{ ...S.downloadBtn, opacity: reportData.length === 0 ? 0.4 : 1, cursor: reportData.length === 0 ? "not-allowed" : "pointer" }}
// //                 >
// //                   <Download size={14} /> Download CSV
// //                 </button>
// //               </div>
// //             </div>
// //           </div>,
// //           document.body
// //         )}
// //     </>
// //   );
// // };

// // /* =========================================================================
// //    SHARED UI PIECES
// //    ========================================================================= */

// // const Badge = ({ tone = "neutral", children }) => {
// //   const tones = {
// //     success: { bg: "#ECFDF5", fg: "#16A34A" },
// //     danger: { bg: "#FEF2F2", fg: "#E11D48" },
// //     warning: { bg: "#FFFBEB", fg: "#D97706" },
// //     neutral: { bg: "#F1F5F9", fg: "#64748B" },
// //   };
// //   const t = tones[tone] || tones.neutral;
// //   return <span style={{ ...S.badge, background: t.bg, color: t.fg }}>{children}</span>;
// // };

// // const SectionTitle = ({ title, eyebrow }) => (
// //   <div style={S.sectionTitleWrap}>
// //     <div>
// //       <div style={S.sectionEyebrow}>{eyebrow}</div>
// //       <div style={S.sectionTitle}>{title}</div>
// //     </div>
// //   </div>
// // );

// // const CompanyCard = ({ company }) => (
// //   <div style={S.companyCard}>
// //     <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
// //       <div style={S.companyBadge}>
// //         <Building2 size={20} color="#0284C7" />
// //       </div>
// //       <div>
// //         <div style={S.companyName}>{company?.name || "Company"}</div>
// //         <div style={S.companyAddr}>{company?.address || "\u2014"}</div>
// //       </div>
// //     </div>
// //     <div style={S.companyMeta}>
// //       <MetaChip label="Phone" value={company?.phone} />
// //       <MetaChip label="Email" value={company?.email} />
// //       <MetaChip label="Website" value={company?.website} />
// //       <MetaChip label="GSTIN" value={company?.gstin} />
// //     </div>
// //   </div>
// // );

// // const MetaChip = ({ label, value }) => (
// //   <div style={S.metaChip}>
// //     <span style={{ color: "#64748B", fontWeight: 700 }}>{label}:</span>
// //     <span style={{ marginLeft: 6, color: "#0F172A", fontWeight: 700 }}>{value || "\u2014"}</span>
// //   </div>
// // );

// // const KpiCard = ({ icon: Icon, accent, title, value, footNote, spark }) => (
// //   <div style={S.kpiCard}>
// //     <div style={S.kpiTop}>
// //       <span style={{ ...S.kpiIcon, background: `${accent}17`, color: accent }}>
// //         <Icon size={16} />
// //       </span>
// //       {spark && spark.length > 1 && <Sparkline data={spark} color={accent} />}
// //     </div>
// //     <div style={S.kpiTitleLabel}>{title}</div>
// //     <div style={S.kpiValue}>{value ?? 0}</div>
// //     <div style={S.kpiFoot}>{footNote}</div>
// //   </div>
// // );

// // const Sparkline = ({ data, color }) => {
// //   const w = 64;
// //   const h = 24;
// //   const max = Math.max(...data, 1);
// //   const min = Math.min(...data, 0);
// //   const range = max - min || 1;
// //   const points = data
// //     .map((v, i) => {
// //       const x = (i / (data.length - 1)) * w;
// //       const y = h - ((v - min) / range) * h;
// //       return `${x.toFixed(1)},${y.toFixed(1)}`;
// //     })
// //     .join(" ");
// //   return (
// //     <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
// //       <polyline points={points} fill="none" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
// //     </svg>
// //   );
// // };

// // const MiniStat = ({ label, value, delta }) => (
// //   <div style={S.miniStat}>
// //     <div style={S.miniStatLabel}>{label}</div>
// //     <div style={S.miniStatValue}>{formatNum(value)}</div>
// //     {typeof delta === "number" && (
// //       <div style={{ ...S.miniStatDelta, color: delta >= 0 ? "#16A34A" : "#E11D48" }}>
// //         {delta >= 0 ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
// //         {formatNum(Math.abs(delta))} in range
// //       </div>
// //     )}
// //   </div>
// // );

// // const StatCard = ({ title, icon: Icon, rows }) => (
// //   <div style={S.card}>
// //     <div style={S.cardTitleRow}>
// //       {Icon && <Icon size={15} color="#64748B" />}
// //       <span style={S.cardTitle}>{title}</span>
// //     </div>
// //     <div style={{ marginTop: 10, display: "grid", gap: 2 }}>
// //       {rows.map(([k, v], idx) => (
// //         <div key={idx} style={S.statRow}>
// //           <div style={S.statRowKey}>{k}</div>
// //           <div style={S.statRowVal}>{formatNum(v)}</div>
// //         </div>
// //       ))}
// //     </div>
// //   </div>
// // );

// // const RecentTable = ({ title, columns, rows }) => (
// //   <div style={S.card}>
// //     <div style={S.cardTitle}>{title}</div>
// //     <div style={{ ...S.tableScrollBare, marginTop: 10 }}>
// //       <table style={S.table}>
// //         <thead>
// //           <tr>
// //             {columns.map((c) => (
// //               <th key={c} style={S.th}>{c}</th>
// //             ))}
// //           </tr>
// //         </thead>
// //         <tbody>
// //           {rows.length === 0 ? (
// //             <tr>
// //               <td style={S.tdEmpty} colSpan={columns.length}>No data</td>
// //             </tr>
// //           ) : (
// //             rows.map((r, i) => (
// //               <tr key={i}>
// //                 {r.map((cell, j) => (
// //                   <td key={j} style={S.td}>{cell}</td>
// //                 ))}
// //               </tr>
// //             ))
// //           )}
// //         </tbody>
// //       </table>
// //     </div>
// //   </div>
// // );

// // const DonutCard = ({ title, data, valueKey, nameKey, money }) => {
// //   const clean = (data || []).map((d) => ({ name: d[nameKey] || "Unknown", value: d[valueKey] || 0 }));
// //   return (
// //     <div style={S.card}>
// //       <div style={S.cardTitle}>{title}</div>
// //       {clean.length === 0 ? (
// //         <div style={S.helpText}>No data for this range.</div>
// //       ) : (
// //         <ResponsiveContainer width="100%" height={260}>
// //           <PieChart>
// //             <Pie data={clean} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={2}>
// //               {clean.map((_, i) => (
// //                 <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
// //               ))}
// //             </Pie>
// //             <Tooltip formatter={(v) => (money ? formatMoney(v) : formatNum(v))} />
// //             <Legend wrapperStyle={{ fontSize: 12, fontFamily: "Inter, sans-serif" }} />
// //           </PieChart>
// //         </ResponsiveContainer>
// //       )}
// //     </div>
// //   );
// // };

// // const ChartTooltip = ({ active, payload, label, moneyKeys = [] }) => {
// //   if (!active || !payload?.length) return null;
// //   return (
// //     <div style={S.tooltip}>
// //       <div style={S.tooltipLabel}>{label}</div>
// //       {payload.map((p, i) => (
// //         <div key={i} style={S.tooltipRow}>
// //           <span style={{ ...S.tooltipDot, background: p.color || p.stroke }} />
// //           <span>{p.name}:</span>
// //           <b>{moneyKeys.includes(p.dataKey) ? formatMoney(p.value) : formatNum(p.value)}</b>
// //         </div>
// //       ))}
// //     </div>
// //   );
// // };

// // const PageLoader = ({ label, compact }) => (
// //   <div style={compact ? S.centerCompact : S.center}>
// //     <div style={S.loaderBox}>
// //       <Loader2 size={20} color="#0284C7" style={{ animation: "p4u-spin 0.9s linear infinite" }} />
// //       <div style={S.loaderText}>{label || "Loading\u2026"}</div>
// //     </div>
// //   </div>
// // );

// // const ErrorState = ({ err, onRetry, compact }) => (
// //   <div style={compact ? S.centerCompact : S.center}>
// //     <div style={S.errorBox}>
// //       <AlertTriangle size={22} color="#E11D48" />
// //       <div style={S.errorTitle}>Something went wrong</div>
// //       <div style={S.errorMsg}>{err}</div>
// //       <button onClick={onRetry} style={S.retryBtn}>
// //         Try again
// //       </button>
// //     </div>
// //   </div>
// // );

// // /* =========================================================================
// //    FONT + GLOBAL STYLE INJECTION
// //    ========================================================================= */

// // const useInjectFonts = () => {
// //   useEffect(() => {
// //     if (document.getElementById("p4u-admin-fonts")) return;

// //     const link = document.createElement("link");
// //     link.id = "p4u-admin-fonts";
// //     link.rel = "stylesheet";
// //     link.href =
// //       "https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap";
// //     document.head.appendChild(link);

// //     const style = document.createElement("style");
// //     style.id = "p4u-admin-style-tag";
// //     style.innerHTML = `
// //       @keyframes p4u-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
// //       .p4u-row:hover { background: #F5FAFF; }
// //       .p4u-icon-btn:hover { background: #E0F2FE !important; border-color: #BAE6FD !important; }
// //       input[type="date"]::-webkit-calendar-picker-indicator { opacity: 0.55; cursor: pointer; }
// //       ::-webkit-scrollbar { width: 8px; height: 8px; }
// //       ::-webkit-scrollbar-thumb { background: #CBE7F8; border-radius: 8px; }
// //       @media (max-width: 900px) {
// //         .p4u-header-top { flex-direction: column !important; align-items: flex-start !important; }
// //       }
// //     `;
// //     document.head.appendChild(style);
// //   }, []);
// // };

// // /* =========================================================================
// //    STYLES — single source of truth
// //    ========================================================================= */

// // const ACCENT = "#0284C7"; // interactive sky-600, derived from the brand's #E0F2FE
// // const ACCENT_SOFT = "#E0F2FE"; // brand primary — soft fills / highlights
// // const INK = "#0F172A";
// // const MUTED = "#64748B";
// // const BORDER = "#E1EEF7";

// // const S = {
// //   // ---------- layout ----------
// //   shell: {
// //     minHeight: "100vh",
// //     background: "#F6FBFF",
// //     fontFamily: "'Inter', sans-serif",
// //     color: INK,
// //   },
// //   header: {
// //     position: "sticky",
// //     top: 0,
// //     zIndex: 30,
// //     background: "#FFFFFF",
// //     borderBottom: `1px solid ${BORDER}`,
// //     padding: "10px 28px",
// //     height:"0%",
// //   },
// //   headerTop: {
// //     display: "flex",
// //     justifyContent: "space-between",
// //     alignItems: "center",
// //     flexWrap: "wrap",
// //     gap: 14,
// //     paddingBottom: 14,
// //   },
// //   brand: { display: "flex", alignItems: "center", gap: 10 },
// //   brandMark: {
// //     width: 38,
// //     height: 38,
// //     borderRadius: 11,
// //     background: `linear-gradient(135deg, ${ACCENT}, #38BDF8)`,
// //     color: "#fff",
// //     fontFamily: "'Manrope', sans-serif",
// //     fontWeight: 800,
// //     fontSize: 12.5,
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "center",
// //   },
// //   brandName: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15.5, color: INK },
// //   brandSub: { fontSize: 11, color: MUTED, marginTop: 1 },

// //   headerControls: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
// //   dateRangePill: {
// //     display: "flex",
// //     alignItems: "center",
// //     gap: 8,
// //     background: ACCENT_SOFT,
// //     border: `1px solid #BAE6FD`,
// //     borderRadius: 999,
// //     padding: "7px 14px",
// //   },
// //   dateInput: {
// //     border: "none",
// //     background: "transparent",
// //     fontSize: 12.5,
// //     fontFamily: "'JetBrains Mono', monospace",
// //     color: INK,
// //     outline: "none",
// //   },
// //   dateArrow: { color: "#0369A1", fontSize: 12 },

// //   segmentGroup: { display: "flex", background: "#F0F8FF", border: `1px solid ${BORDER}`, borderRadius: 10, padding: 3 },
// //   segmentBtn: { border: "none", background: "transparent", padding: "6px 12px", fontSize: 12.5, fontWeight: 600, color: MUTED, borderRadius: 8, cursor: "pointer" },
// //   segmentBtnActive: { background: INK, color: "#fff" },

// //   refreshBtn: {
// //     display: "flex",
// //     alignItems: "center",
// //     gap: 7,
// //     background: INK,
// //     color: "#fff",
// //     border: "none",
// //     padding: "9px 16px",
// //     borderRadius: 10,
// //     fontWeight: 700,
// //     fontSize: 13,
// //     cursor: "pointer",
// //   },

// //   // navRow: { display: "flex", gap: 6, overflowX: "auto", paddingBottom: 12 },
// //   navRow: {
// //     display: "flex",
// //     gap: 10,
// //     overflowX: "auto",

// //     padding: "12px 14px",
// //     marginBottom: 24,

// //     background: "rgba(255,255,255,0.55)",
// //     backdropFilter: "blur(30px) saturate(180%)",
// //     WebkitBackdropFilter: "blur(30px) saturate(180%)",

// //     border: "1px solid rgba(255,255,255,0.45)",
// //     borderRadius: 22,

// //     boxShadow:
// //       "0 10px 40px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.6)",

// //     scrollbarWidth: "none",
// //     msOverflowStyle: "none",
// //   },
// //   navPill: {
// //     flexShrink: 0,
// //     display: "flex",
// //     alignItems: "center",
// //     gap: 7,
// //     border: `1px solid transparent`,
// //     background: "transparent",
// //     color: MUTED,
// //     padding: "8px 16px",
// //     borderRadius: 999,
// //     fontSize: 13,
// //     fontWeight: 600,
// //     cursor: "pointer",
// //     whiteSpace: "nowrap",
// //     transition: "all 150ms ease",
// //   },
// //   navPillActive: {
// //     background: ACCENT_SOFT,
// //     borderColor: "#BAE6FD",
// //     color: "#0369A1",
// //   },

// //   content: { padding: "24px 28px 60px", maxWidth: 1360, width: "100%", margin: "0 auto", boxSizing: "border-box" },

// //   // ---------- company card ----------
// //   companyCard: {
// //     background: "#FFFFFF",
// //     border: `1px solid ${BORDER}`,
// //     borderRadius: 16,
// //     padding: 18,
// //     display: "flex",
// //     justifyContent: "space-between",
// //     flexWrap: "wrap",
// //     gap: 14,
// //   },
// //   companyBadge: { width: 44, height: 44, borderRadius: 12, background: ACCENT_SOFT, display: "flex", alignItems: "center", justifyContent: "center" },
// //   companyName: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15, color: INK },
// //   companyAddr: { color: MUTED, fontWeight: 500, fontSize: 12.5, marginTop: 2 },
// //   companyMeta: { display: "flex", flexWrap: "wrap", gap: 8 },
// //   metaChip: { background: "#F6FBFF", border: `1px solid ${BORDER}`, padding: "6px 10px", borderRadius: 999, fontSize: 12 },

// //   // ---------- section title ----------
// //   sectionTitleWrap: { display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: "30px 0 12px" },
// //   sectionEyebrow: { fontSize: 11, fontWeight: 600, color: "#0369A1", textTransform: "uppercase", letterSpacing: 0.4 },
// //   sectionTitle: { fontFamily: "'Manrope', sans-serif", fontSize: 17, fontWeight: 700, marginTop: 2, color: INK },

// //   // ---------- grids ----------
// //   kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 14, marginTop: 18 },
// //   grid5: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 },
// //   grid4: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 },
// //   grid3: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 14 },
// //   grid2: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 14 },

// //   // ---------- kpi / stat cards ----------
// //   kpiCard: { background: "#FFFFFF", border: `1px solid ${BORDER}`, borderRadius: 16, padding: 18 },
// //   kpiTop: { display: "flex", justifyContent: "space-between", alignItems: "center" },
// //   kpiIcon: { width: 32, height: 32, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center" },
// //   kpiTitleLabel: { color: MUTED, fontSize: 12, fontWeight: 600, marginTop: 14 },
// //   kpiValue: { fontFamily: "'Manrope', sans-serif", fontSize: 26, fontWeight: 700, marginTop: 4, color: INK },
// //   kpiFoot: { color: "#475569", fontSize: 11.5, marginTop: 6, fontFamily: "'JetBrains Mono', monospace" },

// //   miniStat: { background: "#FFFFFF", border: `1px solid ${BORDER}`, borderRadius: 14, padding: 14 },
// //   miniStatLabel: { fontSize: 11.5, color: MUTED, fontWeight: 600 },
// //   miniStatValue: { fontFamily: "'Manrope', sans-serif", fontSize: 19, fontWeight: 700, marginTop: 4 },
// //   miniStatDelta: { display: "flex", alignItems: "center", gap: 3, fontSize: 11, fontWeight: 700, marginTop: 6 },

// //   card: { background: "#FFFFFF", border: `1px solid ${BORDER}`, borderRadius: 16, padding: 18 },
// //   cardTitleRow: { display: "flex", alignItems: "center", gap: 8 },
// //   cardTitle: { fontSize: 14, fontWeight: 700, color: INK },

// //   statRow: { display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "1px dashed #E9F3FA" },
// //   statRowKey: { color: MUTED, fontSize: 13, fontWeight: 500 },
// //   statRowVal: { fontWeight: 700, fontFamily: "'JetBrains Mono', monospace", fontSize: 13 },

// //   // ---------- tables (single shared system) ----------
// //   table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
// //   th: {
// //     textAlign: "left",
// //     padding: "10px 14px",
// //     fontSize: 11,
// //     background: "#F6FBFF",
// //     color: "#64748B",
// //     fontWeight: 700,
// //     textTransform: "uppercase",
// //     letterSpacing: 0.3,
// //     borderBottom: `1px solid ${BORDER}`,
// //     whiteSpace: "nowrap",
// //   },
// //   td: { padding: "11px 14px", fontSize: 13, fontWeight: 500, borderTop: "1px solid #F0F7FC", color: INK, whiteSpace: "nowrap" },
// //   tdEmpty: { padding: "28px 14px", textAlign: "center", color: MUTED, fontSize: 13 },
// //   mono: { fontFamily: "'JetBrains Mono', monospace", fontSize: 12.5 },
// //   rowClickable: { cursor: "pointer" },
// //   tableScroll: { overflowX: "auto", border: `1px solid ${BORDER}`, borderRadius: 10 },
// //   tableScrollBare: { overflowX: "auto" },

// //   // ---------- charts ----------
// //   chartCard: { background: "#FFFFFF", border: `1px solid ${BORDER}`, borderRadius: 16, padding: "18px 8px 10px" },
// //   tooltip: { background: INK, color: "#fff", borderRadius: 10, padding: "10px 12px", fontSize: 12, boxShadow: "0 10px 30px rgba(0,0,0,0.2)" },
// //   tooltipLabel: { fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: "#94A3B8", marginBottom: 6 },
// //   tooltipRow: { display: "flex", alignItems: "center", gap: 6, marginTop: 2 },
// //   tooltipDot: { width: 7, height: 7, borderRadius: "50%" },

// //   // ---------- search ----------
// //   searchBar: { display: "flex", alignItems: "center", gap: 10, background: "#FFFFFF", border: `1px solid ${BORDER}`, borderRadius: 12, padding: "12px 16px", marginBottom: 14 },
// //   searchInput: { flex: 1, border: "none", outline: "none", fontSize: 14, fontFamily: "'Inter', sans-serif", background: "transparent", color: INK },
// //   inlineError: { background: "#FEF2F2", color: "#E11D48", borderRadius: 10, padding: "10px 14px", fontSize: 13, marginBottom: 12, fontWeight: 600 },

// //   badge: { display: "inline-block", padding: "3px 9px", borderRadius: 999, fontSize: 11, fontWeight: 700 },

// //   // ---------- report tiles ----------
// //   reportTile: {
// //     display: "flex",
// //     alignItems: "center",
// //     gap: 10,
// //     background: "#FFFFFF",
// //     border: `1px solid ${BORDER}`,
// //     borderRadius: 14,
// //     padding: 16,
// //     cursor: "pointer",
// //     fontSize: 13,
// //     fontWeight: 700,
// //     color: INK,
// //     transition: "all 0.15s ease",
// //   },
// //   reportTileActive: { borderColor: ACCENT, background: ACCENT_SOFT },

// //   // ---------- filter bar (reports) ----------
// //   filterBar: {
// //     display: "flex",
// //     alignItems: "center",
// //     flexWrap: "wrap",
// //     gap: 14,
// //     padding: "12px 16px",
// //     marginBottom: 16,
// //     background: "#F6FBFF",
// //     border: `1px solid ${BORDER}`,
// //     borderRadius: 12,
// //   },
// //   segmented: { display: "flex", background: "#EAF4FB", borderRadius: 9, padding: 3, gap: 2 },
// //   segmentedBtn: { border: "none", background: "transparent", padding: "6px 12px", fontSize: 12.5, fontWeight: 500, color: MUTED, borderRadius: 7, cursor: "pointer", transition: "all 150ms ease" },
// //   segmentedBtnActive: { background: "#FFFFFF", color: INK, boxShadow: "0 1px 2px rgba(2,132,199,0.15)" },
// //   dateGroup: { display: "flex", alignItems: "flex-end", gap: 10 },
// //   dateField: { display: "flex", flexDirection: "column", gap: 4 },
// //   dateLabelSm: { fontSize: 11, color: MUTED, fontWeight: 500, letterSpacing: "0.02em", textTransform: "uppercase" },
// //   dateInputBox: { border: `1px solid #CFE7F7`, borderRadius: 7, padding: "6px 9px", fontSize: 13, color: INK, background: "#FFFFFF", outline: "none" },
// //   dateSep: { color: "#94A3B8", paddingBottom: 7, fontSize: 13 },
// //   filterActions: { display: "flex", gap: 8, marginLeft: "auto" },
// //   ghostBtn: { border: "1px solid transparent", background: "transparent", color: MUTED, fontSize: 12.5, fontWeight: 500, padding: "8px 12px", borderRadius: 7, cursor: "pointer" },
// //   applyBtn: { border: "none", background: ACCENT, color: "#FFFFFF", fontSize: 12.5, fontWeight: 600, padding: "8px 16px", borderRadius: 7 },
// //   emptyState: { padding: "40px 20px", textAlign: "center", fontSize: 13, color: MUTED },

// //   // ---------- overlay / modal / drawer (all portal-based, always topmost) ----------
// //   overlay: {
// //     position: "fixed",
// //     inset: 0,
// //     background: "rgba(8,20,35,0.45)",
// //     zIndex: 9999,
// //     display: "flex",
// //     justifyContent: "center",
// //     alignItems: "center",
// //   },
// //   modal: {
// //     background: "#FFFFFF",
// //     borderRadius: 16,
// //     boxShadow: "0 30px 60px rgba(2,60,90,0.22)",
// //     overflow: "hidden",
// //     display: "flex",
// //     flexDirection: "column",
// //   },
// //   modalHead: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px" },
// //   modalTitle: { margin: 0, fontFamily: "'Manrope', sans-serif", fontSize: 15, fontWeight: 700, textTransform: "capitalize" },
// //   modalCount: { fontSize: 12, color: MUTED },
// //   modalFooter: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 18px", borderTop: `1px solid ${BORDER}` },
// //   modalFooterHint: { fontSize: 12, color: MUTED },
// //   downloadBtn: { display: "flex", alignItems: "center", gap: 6, border: "none", background: "#16A34A", color: "#FFFFFF", fontSize: 12.5, fontWeight: 700, padding: "9px 16px", borderRadius: 9 },

// //   iconBtn: { border: `1px solid ${BORDER}`, background: "#FFFFFF", borderRadius: 8, width: 30, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: MUTED, transition: "background 120ms ease" },

// //   panel: {
// //     width: 460,
// //     maxWidth: "100vw",
// //     height: "100vh",
// //     background: "#FFFFFF",
// //     boxShadow: "-16px 0 44px rgba(2,60,90,0.16)",
// //     display: "flex",
// //     flexDirection: "column",
// //     boxSizing: "border-box",
// //     marginLeft: "auto",
// //   },
// //   panelHead: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: `1px solid ${BORDER}`, flexShrink: 0 },
// //   eyebrow: { fontSize: 11.5, fontWeight: 600, color: "#0369A1", letterSpacing: "0.03em", textTransform: "uppercase" },
// //   panelBody: { flex: 1, overflowY: "auto", padding: 20, boxSizing: "border-box" },

// //   // ---------- student identity ----------
// //   hero: { display: "flex", alignItems: "center", gap: 12, marginBottom: 18 },
// //   avatar: { width: 44, height: 44, flexShrink: 0, borderRadius: "50%", background: INK, color: "#FFFFFF", fontSize: 17, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center" },
// //   heroText: { minWidth: 0 },
// //   name: { fontSize: 16, fontWeight: 700, fontFamily: "'Manrope', sans-serif", color: INK, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
// //   metaLine: { fontSize: 12.5, color: MUTED, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },

// //   spendRow: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18 },
// //   spendCard: { border: `1px solid ${BORDER}`, borderRadius: 12, padding: "12px 14px", background: "#F6FBFF", minWidth: 0 },
// //   spendCardAccent: { background: ACCENT_SOFT, borderColor: "#BAE6FD" },
// //   kpiLabel: { fontSize: 11.5, color: MUTED, marginBottom: 4 },
// //   kpiValueSm: { fontSize: 18, fontWeight: 700, color: INK, fontFamily: "'Manrope', sans-serif" },

// //   // ---------- detail tabs ----------
// //   tabBar: { display: "flex", gap: 2, background: "#F0F8FF", borderRadius: 10, padding: 3, marginBottom: 16, overflowX: "auto" },
// //   tabBtn: { flexShrink: 0, display: "flex", alignItems: "center", gap: 5, border: "none", background: "transparent", padding: "7px 11px", fontSize: 12.5, fontWeight: 500, color: MUTED, borderRadius: 7, cursor: "pointer", whiteSpace: "nowrap" },
// //   tabBtnActive: { background: "#FFFFFF", color: INK, boxShadow: "0 1px 2px rgba(2,132,199,0.15)" },
// //   tabCount: { fontSize: 10, fontWeight: 700, color: "#0369A1", background: ACCENT_SOFT, borderRadius: 999, padding: "1px 6px" },
// //   tabContent: { minWidth: 0 },

// //   overviewGrid: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 },
// //   statCard: { border: `1px solid ${BORDER}`, borderRadius: 10, padding: "12px 10px", background: "#F6FBFF", textAlign: "center" },
// //   statValue: { fontSize: 19, fontWeight: 700, color: INK, fontFamily: "'Manrope', sans-serif" },
// //   statLabel: { fontSize: 11, color: MUTED, marginTop: 2 },

// //   // ---------- timeline ----------
// //   timelineWrap: { position: "relative", paddingLeft: 18 },
// //   timelineRail: { position: "absolute", left: 4, top: 4, bottom: 4, width: 1, background: BORDER },
// //   timelineItem: { position: "relative", marginBottom: 14 },
// //   timelineNode: { position: "absolute", left: -18, top: 4, width: 8, height: 8, borderRadius: "50%" },
// //   timelineCard: { border: `1px solid ${BORDER}`, borderRadius: 10, padding: "10px 12px", background: "#FFFFFF" },
// //   timelineTop: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 4, flexWrap: "wrap" },
// //   timelineLabel: { display: "flex", alignItems: "center", gap: 5, fontSize: 12.5, fontWeight: 600, color: INK },
// //   timelineDate: { fontSize: 11, color: MUTED, whiteSpace: "nowrap", fontFamily: "'JetBrains Mono', monospace" },
// //   timelineSub: { fontSize: 12, color: MUTED, marginTop: 4, fontFamily: "'JetBrains Mono', monospace" },
// //   helpText: { fontSize: 13, color: MUTED, lineHeight: 1.6, padding: "8px 0" },

// //   // ---------- loaders / errors ----------
// //   center: { minHeight: "50vh", display: "grid", placeItems: "center" },
// //   centerCompact: { minHeight: 200, display: "grid", placeItems: "center" },
// //   loaderBox: { display: "flex", gap: 10, alignItems: "center" },
// //   loaderText: { fontWeight: 600, color: MUTED, fontSize: 13.5 },

// //   errorBox: { textAlign: "center", maxWidth: 320 },
// //   errorTitle: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15, marginTop: 10 },
// //   errorMsg: { color: MUTED, fontSize: 13, marginTop: 6 },
// //   retryBtn: { marginTop: 14, background: INK, color: "#fff", border: "none", padding: "9px 18px", borderRadius: 10, fontWeight: 700, cursor: "pointer" },
// // };
// import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
// import { createPortal } from "react-dom";

// import {
//   ResponsiveContainer,
//   AreaChart,
//   Area,
//   LineChart,
//   Line,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";
// import {
//   Users,
//   GraduationCap,
//   Wallet,
//   CreditCard,
//   Search,
//   RefreshCw,
//   Download,
//   X,
//   Calendar,
//   Building2,
//   FileText,
//   BookOpen,
//   Bell,
//   Landmark,
//   Newspaper,
//   ShieldCheck,
//   ArrowUpRight,
//   ArrowDownRight,
//   Loader2,
//   AlertTriangle,
//   LayoutGrid,
//   BarChart3,
//   UserSearch,
//   ClipboardList,
//   ChevronRight,
//   Video,
//   HandHelping,
//   CalendarClock,
//   Clock,
//   Sparkles,
//   Minimize2,
//   Maximize2,
//   Menu,
//   MessageSquare,
//   Maximize,
//   ChevronDown,
//   ChevronLeft,
//   Plus,
//   MoreHorizontal,
//   MapPin,
// } from "lucide-react";

// /* =========================================================================
//    CONFIG
//    ========================================================================= */

// const API_BASE = process.env.REACT_APP_API_BASEURL;

// const REPORT_TYPES = [
//   { key: "students", label: "All Students", icon: Users },
//   { key: "homeTutor", label: "Home Tutor", icon: HandHelping },
//   { key: "homeWork", label: "Homework Assistance", icon: BookOpen },
//   { key: "subjective", label: "Subjective Exams", icon: FileText },
//   { key: "payments", label: "Payments", icon: CreditCard },
//   { key: "notes", label: "Exam Notes", icon: Newspaper },
//   { key: "subadmins", label: "Sub Admins", icon: ShieldCheck },
//   { key: "appointments", label: "Appointments", icon: CalendarClock },
// ];

// const TIMELINE_META = {
//   assignment_subscription: { label: "Assignment subscription", color: "#0284C7", icon: ClipboardList },
//   exam_notes_purchase: { label: "Exam notes purchase", color: "#16A34A", icon: BookOpen },
//   subjective_exam_purchase: { label: "Subjective exam purchase", color: "#F59E0B", icon: FileText },
//   live_class_purchase: { label: "Live class purchase", color: "#8B5CF6", icon: Video },
//   home_tutor_request: { label: "Home tutor request", color: "#0EA5E9", icon: HandHelping },
//   home_work_request: { label: "Homework request", color: "#0D9488", icon: BookOpen },
//   appointment: { label: "Appointment", color: "#DB2777", icon: CalendarClock },
//   payment: { label: "Payment", color: "#0F172A", icon: CreditCard },
// };

// const PIE_COLORS = ["#6C5CE7", "#16A34A", "#F59E0B", "#EC4899", "#0EA5E9", "#0D9488", "#DB2777", "#64748B"];

// const NAV_ITEMS = [
//   { key: "overview", label: "Overview", icon: LayoutGrid },
//   { key: "analytics", label: "Analytics", icon: BarChart3 },
//   { key: "students", label: "Students", icon: UserSearch },
//   { key: "reports", label: "Reports", icon: ClipboardList },
// ];

// /* =========================================================================
//    HELPERS
//    ========================================================================= */

// const authHeaders = () => {
//   const token = localStorage.getItem("token");
//   return token ? { Authorization: `Bearer ${token}` } : {};
// };

// const apiGet = async (path) => {
//   const res = await fetch(`${API_BASE}${path}`, { headers: authHeaders() });
//   const json = await res.json().catch(() => ({}));
//   if (!res.ok || json?.success === false) {
//     throw new Error(json?.message || `Request failed (${res.status})`);
//   }
//   return json;
// };

// const formatMoney = (v) => {
//   const num = Number(v || 0);
//   if (Number.isNaN(num)) return "\u20b90";
//   if (Math.abs(num) >= 100000) return `\u20b9${(num / 100000).toFixed(2)}L`;
//   return `\u20b9${num.toLocaleString("en-IN")}`;
// };

// const formatNum = (v) => Number(v || 0).toLocaleString("en-IN");

// const formatDate = (d) => {
//   if (!d) return "\u2014";
//   try {
//     return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
//   } catch {
//     return "\u2014";
//   }
// };

// const formatDateTime = (d) => {
//   if (!d) return "\u2014";
//   try {
//     return new Date(d).toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   } catch {
//     return "\u2014";
//   }
// };

// const isoDate = (d) => d.toISOString().slice(0, 10);

// // Merge N labeled trend arrays into one recharts-friendly dataset
// const mergeTrends = (series) => {
//   const labels = new Set();
//   Object.values(series).forEach((arr) => (arr || []).forEach((p) => labels.add(p.label)));
//   const sorted = Array.from(labels).sort();
//   return sorted.map((label) => {
//     const row = { label };
//     Object.entries(series).forEach(([key, arr]) => {
//       const found = (arr || []).find((p) => p.label === label);
//       row[key] = found ? found.count ?? found.total ?? 0 : 0;
//     });
//     return row;
//   });
// };

// const statusTone = (status) => {
//   const s = (status || "").toLowerCase();
//   if (["success", "completed", "approved", "active"].includes(s)) return "success";
//   if (["failed", "rejected", "cancelled", "expired"].includes(s)) return "danger";
//   return "warning";
// };

// const downloadCSV = (data, filename) => {
//   if (!data?.length) return;
//   const headers = Object.keys(data[0]);
//   const csv = [headers.join(","), ...data.map((row) => headers.map((h) => JSON.stringify(row[h] ?? "")).join(","))].join(
//     "\n"
//   );
//   const blob = new Blob([csv], { type: "text/csv" });
//   const url = window.URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = filename + ".csv";
//   a.click();
//   window.URL.revokeObjectURL(url);
// };

// /* =========================================================================
//    ROOT COMPONENT
//    ========================================================================= */

// export default function AdminDashboardStats() {
//   useInjectFonts();

//   const [tab, setTab] = useState("overview");

//   // Global date range — drives overview + analytics + students
//   const today = useMemo(() => new Date(), []);
//   const monthAgo = useMemo(() => new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000), [today]);
//   const [from, setFrom] = useState(isoDate(monthAgo));
//   const [to, setTo] = useState(isoDate(today));
//   const [granularity, setGranularity] = useState("day");

//   const [overview, setOverview] = useState(null);
//   const [overviewLoading, setOverviewLoading] = useState(true);
//   const [overviewErr, setOverviewErr] = useState("");

//   const [analytics, setAnalytics] = useState(null);
//   const [analyticsLoading, setAnalyticsLoading] = useState(true);
//   const [analyticsErr, setAnalyticsErr] = useState("");

//   const qs = useMemo(() => `?from=${from}&to=${to}`, [from, to]);

//   const fetchOverview = useCallback(async () => {
//     setOverviewLoading(true);
//     setOverviewErr("");
//     try {
//       const json = await apiGet(`/admin/overview${qs}`);
//       setOverview(json.data);
//     } catch (e) {
//       setOverviewErr(e.message || "Something went wrong");
//       setOverview(null);
//     } finally {
//       setOverviewLoading(false);
//     }
//   }, [qs]);

//   const fetchAnalytics = useCallback(async () => {
//     setAnalyticsLoading(true);
//     setAnalyticsErr("");
//     try {
//       const json = await apiGet(`/admin/analytics${qs}&granularity=${granularity}`);
//       setAnalytics(json.data);
//     } catch (e) {
//       setAnalyticsErr(e.message || "Something went wrong");
//       setAnalytics(null);
//     } finally {
//       setAnalyticsLoading(false);
//     }
//   }, [qs, granularity]);

//   useEffect(() => {
//     fetchOverview();
//     fetchAnalytics();
//   }, [fetchOverview, fetchAnalytics]);

//   const refreshAll = () => {
//     fetchOverview();
//     fetchAnalytics();
//   };

//   const loading = overviewLoading || analyticsLoading;

//   const [navOpenKey, setNavOpenKey] = useState(null);
//   const [globalQuery, setGlobalQuery] = useState("");

//   return (
//     // <div style={S.frame}>
//       <div style={S.shell}>
//         <header style={S.header}>
//           <div style={S.headerTop} className="p4u-header-top">
//             <button style={S.menuBtn} className="p4u-icon-btn" aria-label="Menu">
//               <Menu size={18} color="#5B6472" />
//             </button>

//             <div style={S.searchPill}>
//               <Search size={15} color="#8A93A8" />
//               <input
//                 value={globalQuery}
//                 onChange={(e) => setGlobalQuery(e.target.value)}
//                 placeholder="Search..."
//                 style={S.searchPillInput}
//               />
//             </div>

//             <div style={S.navTextRow}>
//               {NAV_ITEMS.slice(0, 2).map((item) => (
//                 <button
//                   key={item.key}
//                   onClick={() => setTab(item.key)}
//                   onMouseEnter={() => setNavOpenKey(item.key)}
//                   onMouseLeave={() => setNavOpenKey(null)}
//                   style={{ ...S.navTextBtn, ...(tab === item.key ? S.navTextBtnActive : {}) }}
//                 >
//                   {item.key === "overview" ? "Mega Menu" : "Resources"}
//                   <ChevronDown size={14} />
//                   {navOpenKey === item.key && (
//                     <div style={S.navDropdown}>
//                       {NAV_ITEMS.map((sub) => {
//                         const SubIcon = sub.icon;
//                         return (
//                           <div
//                             key={sub.key}
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setTab(sub.key);
//                             }}
//                             style={{ ...S.navDropdownItem, ...(tab === sub.key ? S.navDropdownItemActive : {}) }}
//                           >
//                             <SubIcon size={14} />
//                             {sub.label}
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </button>
//               ))}
//             </div>

//             <div style={S.headerRight}>
//               <div style={S.dateRangePill}>
//                 <Calendar size={13} color="#6C5CE7" />
//                 <input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} style={S.dateInput} />
//                 <span style={S.dateArrow}>&rarr;</span>
//                 <input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} style={S.dateInput} />
//               </div>

//               <button onClick={refreshAll} style={S.roundIconBtn} className="p4u-icon-btn" aria-label="Refresh" disabled={loading}>
//                 <RefreshCw size={16} style={{ animation: loading ? "p4u-spin 0.9s linear infinite" : "none" }} />
//               </button>
//               <button style={S.roundIconBtn} className="p4u-icon-btn" aria-label="Notifications">
//                 <Bell size={16} />
//                 <span style={S.notifDot}>4</span>
//               </button>
//               <button style={S.roundIconBtn} className="p4u-icon-btn" aria-label="Messages">
//                 <MessageSquare size={16} />
//               </button>
//               <button style={S.roundIconBtn} className="p4u-icon-btn" aria-label="Region">
//                 <span style={{ fontSize: 14, lineHeight: 1 }}>{"\ud83c\uddee\ud83c\uddf3"}</span>
//               </button>
//               <button style={S.roundIconBtn} className="p4u-icon-btn" aria-label="Fullscreen" onClick={() => document.documentElement.requestFullscreen?.()}>
//                 <Maximize size={15} />
//               </button>
//               <div style={S.avatarSm}>{(overview?.company?.name || "P4U").slice(0, 2).toUpperCase()}</div>
//             </div>
//           </div>

//           <nav style={S.navRow}>
//             {NAV_ITEMS.map((item) => {
//               const Icon = item.icon;
//               const active = tab === item.key;
//               return (
//                 <button
//                   key={item.key}
//                   onClick={() => setTab(item.key)}
//                   style={{ ...S.navPill, ...(active ? S.navPillActive : {}) }}
//                 >
//                   <Icon size={15} strokeWidth={2} />
//                   {item.label}
//                 </button>
//               );
//             })}
//           </nav>
//         </header>

//         <main style={S.content}>
//           {tab === "overview" && (
//             <OverviewTab
//               overview={overview}
//               loading={overviewLoading}
//               err={overviewErr}
//               onRetry={fetchOverview}
//               analytics={analytics}
//               granularity={granularity}
//               setGranularity={setGranularity}
//               onOpenReports={() => setTab("reports")}
//               onRefresh={refreshAll}
//               refreshing={loading}
//             />
//           )}
//           {tab === "analytics" && (
//             <AnalyticsTab analytics={analytics} loading={analyticsLoading} err={analyticsErr} onRetry={fetchAnalytics} />
//           )}
//           {tab === "students" && <StudentsTab from={from} to={to} />}
//           {tab === "reports" && <ReportsTab />}
//         </main>
//       </div>
//     // </div>
//   );
// }

// /* =========================================================================
//    OVERVIEW TAB
//    ========================================================================= */

// const OverviewTab = ({ overview, loading, err, onRetry, analytics, granularity, setGranularity, onOpenReports, onRefresh, refreshing }) => {
//   if (loading) return <PageLoader label="Loading overview\u2026" />;
//   if (err) return <ErrorState err={err} onRetry={onRetry} />;
//   if (!overview) return <ErrorState err="No data available." onRetry={onRetry} />;

//   const { company, users, masters, content, services, cms, purchases, revenue, payments, recent } = overview;

//   const revenueSpark = (analytics?.revenueTrend || []).map((p) => p.total ?? 0);
//   const studentSpark = (analytics?.signups?.students || []).map((p) => p.count ?? 0);
//   const teacherSpark = (analytics?.signups?.teachers || []).map((p) => p.count ?? 0);

//   const studentDelta = users?.students?.total ? Math.round(((users?.students?.newInRange || 0) / users.students.total) * 1000) / 10 : 0;
//   const teacherDelta = users?.teachers?.total ? Math.round(((users?.teachers?.pendingApproval || 0) / users.teachers.total) * 1000) / 10 : 0;
//   const paySuccessRate = payments?.totalInRange ? Math.round(((payments?.success || 0) / payments.totalInRange) * 1000) / 10 : 0;
//   const totalOrders =
//     (purchases?.assignmentSubscriptions?.total || 0) +
//     (purchases?.examNotesPurchases?.total || 0) +
//     (purchases?.homeTutorSubscriptions?.total || 0) +
//     (purchases?.subjectiveExamSubscriptions?.total || 0) +
//     (purchases?.homeWorkPurchases || 0);
//   const ordersDelta =
//     (purchases?.assignmentSubscriptions?.newInRange || 0) +
//     (purchases?.examNotesPurchases?.newInRange || 0) +
//     (purchases?.homeTutorSubscriptions?.newInRange || 0) +
//     (purchases?.subjectiveExamSubscriptions?.newInRange || 0);
//   const ordersDeltaPct = totalOrders ? Math.round((ordersDelta / totalOrders) * 1000) / 10 : 0;

//   return (
//     <>
//       <div style={S.pageHeadRow}>
//         <div>
//           <h1 style={S.pageTitle}>
//             Analytics <span style={{ fontWeight: 400 }}>Dashboard</span>
//           </h1>
//         </div>
//         <div style={{ display: "flex", gap: 10 }}>
//           <button style={S.ghostPillBtn} onClick={onRefresh} disabled={refreshing}>
//             <RefreshCw size={13} style={{ marginRight: 6, animation: refreshing ? "p4u-spin 0.9s linear infinite" : "none" }} />
//             Refresh data
//           </button>
//           <button style={S.primaryPillBtn} onClick={onOpenReports}>
//             <Plus size={14} style={{ marginRight: 4 }} />
//             New report
//           </button>
//         </div>
//       </div>

//       <CompanyCard company={company} />

//       <div style={S.overviewTopGrid} className="p4u-top-grid">
//         <div style={S.kpi2x2}>
//           <KpiCard
//             icon={Wallet}
//             accent="#3B82F6"
//             accentSoft="#DBEAFE"
//             title="Earnings"
//             value={formatMoney(revenue?.totalInRange)}
//             delta={null}
//             footNote={`${formatMoney(revenue?.totalAllTime)} all time`}
//           />
//           <KpiCard
//             icon={CreditCard}
//             accent="#F97316"
//             accentSoft="#FFEDD5"
//             title="Sales"
//             value={formatNum(payments?.totalInRange)}
//             delta={paySuccessRate}
//             footNote={`${formatNum(payments?.success)} success \u00b7 ${formatNum(payments?.failed)} failed`}
//           />
//           <KpiCard
//             icon={Users}
//             accent="#10B981"
//             accentSoft="#D1FAE5"
//             title="Visitors"
//             value={formatNum(users?.students?.total)}
//             delta={studentDelta}
//             footNote={`+${formatNum(users?.students?.newInRange)} in range`}
//           />
//           <KpiCard
//             icon={CreditCard}
//             accent="#8B5CF6"
//             accentSoft="#EDE9FE"
//             title="Orders"
//             value={formatNum(totalOrders)}
//             delta={ordersDeltaPct}
//             footNote={`${formatNum(ordersDelta)} in range`}
//           />
//         </div>

//         <div style={S.chartCard}>
//           <div style={S.chartCardHead}>
//             <span style={S.cardTitle}>Recent Movement</span>
//             <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//               <div style={S.segmentGroup}>
//                 {["day", "month"].map((g) => (
//                   <button
//                     key={g}
//                     onClick={() => setGranularity(g)}
//                     style={{ ...S.segmentBtn, ...(granularity === g ? S.segmentBtnActive : {}) }}
//                   >
//                     {g === "day" ? "Daily" : "Monthly"}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>
//           <ResponsiveContainer width="100%" height={300}>
//             <AreaChart data={analytics?.revenueTrend || []} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
//               <defs>
//                 <linearGradient id="movementFill" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.25} />
//                   <stop offset="95%" stopColor="#3B82F6" stopOpacity={0} />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="3 4" stroke="#EEF0FB" vertical={false} />
//               <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#94A0B8" }} axisLine={{ stroke: "#EEF0FB" }} tickLine={false} />
//               <YAxis tick={{ fontSize: 11, fill: "#94A0B8" }} axisLine={false} tickLine={false} tickFormatter={(v) => formatMoney(v)} width={64} />
//               <Tooltip content={<ChartTooltip moneyKeys={["total"]} />} />
//               <Area
//                 type="monotone"
//                 dataKey="total"
//                 stroke="#3B82F6"
//                 strokeWidth={3}
//                 fill="url(#movementFill)"
//                 name="Revenue"
//                 dot={{ r: 4, fill: "#3B82F6", strokeWidth: 2, stroke: "#fff" }}
//                 activeDot={{ r: 6 }}
//               />
//             </AreaChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       <div style={S.widgetRow}>
//         <MiniCalendarCard />
//         <LiveActivityCard recent={recent} />
//         <PaymentStatusDonut payments={payments} paymentStatusBreakdown={analytics?.paymentStatusBreakdown} />
//       </div>

//       <SectionTitle title="Purchases" eyebrow="Subscriptions across every product line" />
//       <div style={S.grid5}>
//         <MiniStat label="Assignment subs" value={purchases?.assignmentSubscriptions?.total} delta={purchases?.assignmentSubscriptions?.newInRange} />
//         <MiniStat label="Exam notes" value={purchases?.examNotesPurchases?.total} delta={purchases?.examNotesPurchases?.newInRange} />
//         <MiniStat label="Home tutor subs" value={purchases?.homeTutorSubscriptions?.total} delta={purchases?.homeTutorSubscriptions?.newInRange} />
//         <MiniStat label="Homework purchases" value={purchases?.homeWorkPurchases} />
//         <MiniStat label="Subjective exam subs" value={purchases?.subjectiveExamSubscriptions?.total} delta={purchases?.subjectiveExamSubscriptions?.newInRange} />
//       </div>

//       <SectionTitle title="Services" eyebrow="Requests awaiting action" />
//       <div style={S.grid3}>
//         <StatCard title="Home tutor" icon={HandHelping} rows={[["Total", services?.homeTutorRequests?.total], ["Pending", services?.homeTutorRequests?.pending]]} />
//         <StatCard title="Homework assistance" icon={BookOpen} rows={[["Total", services?.homeWorkAssistance?.total], ["Pending", services?.homeWorkAssistance?.pending]]} />
//         <StatCard title="Appointments" icon={CalendarClock} rows={[["Total", services?.appointments?.total], ["Pending", services?.appointments?.pending]]} />
//       </div>

//       <SectionTitle title="Content moderation" eyebrow="Exam checking pipeline" />
//       <div style={S.grid3}>
//         <StatCard
//           title="Checked exams"
//           icon={FileText}
//           rows={[
//             ["Total", content?.checkedExams?.total],
//             ["Pending", content?.checkedExams?.pending],
//             ["Approved", content?.checkedExams?.approved],
//             ["Rejected", content?.checkedExams?.rejected],
//           ]}
//         />
//         <StatCard title="Notes & exams" icon={BookOpen} rows={[["Notes", content?.notes], ["Subjective exams", content?.subjectiveExams], ["Submitted exams", content?.submittedExams]]} />
//         <StatCard title="Live classes" icon={Video} rows={[["Total", services?.liveClasses?.total], ["Purchases", services?.liveClasses?.purchases], ["New in range", services?.liveClasses?.newInRange]]} />
//       </div>

//       <SectionTitle title="Masters & CMS" eyebrow="Reference data and content" />
//       <div style={S.grid2}>
//         <StatCard
//           title="Master data"
//           icon={Landmark}
//           rows={[
//             ["States", masters?.states],
//             ["Cities", masters?.cities],
//             ["Boards", masters?.boards],
//             ["Classes", masters?.classes],
//             ["Subjects", masters?.subjects],
//             ["Competitions", masters?.competitions],
//             ["Universities", masters?.universities],
//             ["Courses", masters?.courses],
//             ["Semesters", masters?.semesters],
//             ["College subjects", masters?.collegeSubjects],
//             ["NIOS classes", masters?.niosClasses],
//             ["NIOS subjects", masters?.niosSubjects],
//           ]}
//         />
//         <StatCard
//           title="CMS"
//           icon={Bell}
//           rows={[
//             ["Sliders", cms?.sliders],
//             ["Notifications", cms?.notifications],
//             ["Coupons (total)", cms?.coupons?.total],
//             ["Coupons (active)", cms?.coupons?.active],
//             ["Councils", cms?.councils],
//             ["Jobs (total)", cms?.jobs?.total],
//             ["Jobs (active)", cms?.jobs?.active],
//             ["Scholarships", cms?.scholarships],
//             ["Career categories", cms?.chooseCareer?.categories],
//             ["Blogs", cms?.chooseCareer?.blogs],
//           ]}
//         />
//       </div>

//       <SectionTitle title="Recent activity" eyebrow="Newest entries first" />
//       <div style={S.grid2}>
//         <RecentTable
//           title="Recent students"
//           columns={["Name", "Mobile", "Email", "Joined"]}
//           rows={(recent?.students || []).map((s) => [s.fullName || "\u2014", s.mobile || "\u2014", s.email || "\u2014", formatDateTime(s.createdAt)])}
//         />
//         <RecentTable
//           title="Recent teachers"
//           columns={["Mobile", "Approval", "Verified", "Joined"]}
//           rows={(recent?.teachers || []).map((t) => [t.mobile || "\u2014", t.approvalStatus || "\u2014", String(t.isVerified ?? false), formatDateTime(t.createdAt)])}
//         />
//       </div>
//       <div style={S.grid2}>
//         <RecentTable
//           title="Recent jobs"
//           columns={["Job", "Company", "Status", "Apply till"]}
//           rows={(recent?.jobs || []).map((j) => [j.jobTitle || "\u2014", j.companyName || "\u2014", j.status || "\u2014", formatDate(j.lastDateToApply)])}
//         />
//         <RecentTable
//           title="Recent payments"
//           columns={["Purpose", "Gateway", "Amount", "Status", "When"]}
//           rows={(recent?.payments || []).map((p) => [p.purpose || "\u2014", p.gateway || "\u2014", formatMoney(p.amount), p.status || "\u2014", formatDateTime(p.createdAt)])}
//         />
//       </div>

//       <div style={{ height: 8 }} />
//     </>
//   );
// };

// /* =========================================================================
//    ANALYTICS TAB
//    ========================================================================= */

// const AnalyticsTab = ({ analytics, loading, err, onRetry }) => {
//   if (loading) return <PageLoader label="Crunching analytics\u2026" />;
//   if (err) return <ErrorState err={err} onRetry={onRetry} />;
//   if (!analytics) return <ErrorState err="No analytics available." onRetry={onRetry} />;

//   const signupData = mergeTrends({ students: analytics.signups?.students, teachers: analytics.signups?.teachers });
//   const purchaseData = mergeTrends(analytics.purchaseTrends || {});

//   return (
//     <>
//       <SectionTitle title="Revenue" eyebrow="Successful payments over time" />
//       <div style={S.chartCard}>
//         <ResponsiveContainer width="100%" height={300}>
//           <AreaChart data={analytics.revenueTrend || []} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
//             <defs>
//               <linearGradient id="revFill" x1="0" y1="0" x2="0" y2="1">
//                 <stop offset="5%" stopColor="#6C5CE7" stopOpacity={0.28} />
//                 <stop offset="95%" stopColor="#6C5CE7" stopOpacity={0} />
//               </linearGradient>
//             </defs>
//             <CartesianGrid strokeDasharray="3 4" stroke="#EEF0FB" vertical={false} />
//             <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#94A0B8", fontFamily: "JetBrains Mono, monospace" }} axisLine={{ stroke: "#EEF0FB" }} tickLine={false} />
//             <YAxis tick={{ fontSize: 11, fill: "#94A0B8", fontFamily: "JetBrains Mono, monospace" }} axisLine={false} tickLine={false} tickFormatter={(v) => formatMoney(v)} width={70} />
//             <Tooltip content={<ChartTooltip moneyKeys={["total"]} />} />
//             <Area type="monotone" dataKey="total" stroke="#6C5CE7" strokeWidth={2.75} fill="url(#revFill)" name="Revenue" dot={{ r: 3, fill: "#6C5CE7", strokeWidth: 2, stroke: "#fff" }} activeDot={{ r: 5 }} />
//           </AreaChart>
//         </ResponsiveContainer>
//       </div>

//       <div style={S.grid2}>
//         <DonutCard title="Revenue by purpose" data={analytics.revenueByPurpose} valueKey="total" nameKey="_id" money />
//         <DonutCard title="Revenue by gateway" data={analytics.revenueByGateway} valueKey="total" nameKey="_id" money />
//       </div>

//       <SectionTitle title="Growth" eyebrow="Signups over time" />
//       <div style={S.chartCard}>
//         <ResponsiveContainer width="100%" height={280}>
//           <LineChart data={signupData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
//             <CartesianGrid strokeDasharray="3 4" stroke="#EEF0FB" vertical={false} />
//             <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#94A0B8", fontFamily: "JetBrains Mono, monospace" }} axisLine={{ stroke: "#EEF0FB" }} tickLine={false} />
//             <YAxis tick={{ fontSize: 11, fill: "#94A0B8", fontFamily: "JetBrains Mono, monospace" }} axisLine={false} tickLine={false} width={40} />
//             <Tooltip content={<ChartTooltip />} />
//             <Legend wrapperStyle={{ fontSize: 12, fontFamily: "Inter, sans-serif" }} />
//             <Line type="monotone" dataKey="students" stroke="#3B82F6" strokeWidth={2.75} dot={false} name="Students" />
//             <Line type="monotone" dataKey="teachers" stroke="#10B981" strokeWidth={2.75} dot={false} name="Teachers" />
//           </LineChart>
//         </ResponsiveContainer>
//       </div>

//       <SectionTitle title="Purchases" eyebrow="Volume by product line, over time" />
//       <div style={S.chartCard}>
//         <ResponsiveContainer width="100%" height={300}>
//           <LineChart data={purchaseData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
//             <CartesianGrid strokeDasharray="3 4" stroke="#EEF0FB" vertical={false} />
//             <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#94A0B8", fontFamily: "JetBrains Mono, monospace" }} axisLine={{ stroke: "#EEF0FB" }} tickLine={false} />
//             <YAxis tick={{ fontSize: 11, fill: "#94A0B8", fontFamily: "JetBrains Mono, monospace" }} axisLine={false} tickLine={false} width={40} />
//             <Tooltip content={<ChartTooltip />} />
//             <Legend wrapperStyle={{ fontSize: 11, fontFamily: "Inter, sans-serif" }} />
//             <Line type="monotone" dataKey="assignmentSubscriptions" stroke="#3B82F6" strokeWidth={2} dot={false} name="Assignment subs" />
//             <Line type="monotone" dataKey="examNotesPurchases" stroke="#10B981" strokeWidth={2} dot={false} name="Exam notes" />
//             <Line type="monotone" dataKey="subjectiveExamPurchases" stroke="#F59E0B" strokeWidth={2} dot={false} name="Subjective exams" />
//             <Line type="monotone" dataKey="liveClassPurchases" stroke="#8B5CF6" strokeWidth={2} dot={false} name="Live classes" />
//           </LineChart>
//         </ResponsiveContainer>
//       </div>

//       <SectionTitle title="Payment health" eyebrow="Status breakdown across the range" />
//       <div style={S.grid2}>
//         <DonutCard title="Payment status" data={analytics.paymentStatusBreakdown} valueKey="count" nameKey="_id" />
//         <div style={S.card}>
//           <div style={S.cardTitleRow}>
//             <AlertTriangle size={15} color="#94A0B8" />
//             <span style={S.cardTitle}>Reading this data</span>
//           </div>
//           <p style={S.helpText}>
//             Revenue only counts payments with status <b>SUCCESS</b>. Failed and pending attempts show up in the status
//             breakdown but are excluded from revenue totals. Switch the range or granularity from the header \u2014 every
//             chart on this tab reacts to it.
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// /* =========================================================================
//    STUDENTS TAB
//    ========================================================================= */

// const StudentsTab = ({ from, to }) => {
//   const [q, setQ] = useState("");
//   const [students, setStudents] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [err, setErr] = useState("");
//   const [selected, setSelected] = useState(null);
//   const debounceRef = useRef(null);

//   const runSearch = useCallback(async (query) => {
//     setLoading(true);
//     setErr("");
//     try {
//       const json = await apiGet(`/admin/students/search?q=${encodeURIComponent(query || "")}&limit=25`);
//       setStudents(json.data.students || []);
//     } catch (e) {
//       setErr(e.message || "Search failed");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     runSearch("");
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const onChangeQuery = (val) => {
//     setQ(val);
//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(() => runSearch(val), 350);
//   };

//   return (
//     <>
//       <SectionTitle title="Find a student" eyebrow="Search by name, email or mobile" />

//       <div style={S.searchBar}>
//         <Search size={16} color="#94A0B8" />
//         <input
//           value={q}
//           onChange={(e) => onChangeQuery(e.target.value)}
//           placeholder="Search students\u2026"
//           style={S.searchInput}
//         />
//         {loading && <Loader2 size={16} color="#94A0B8" style={{ animation: "p4u-spin 0.9s linear infinite" }} />}
//       </div>

//       {err && <div style={S.inlineError}>{err}</div>}

//       <div style={S.card} className="p4u-notouch">
//         <table style={S.table}>
//           <thead>
//             <tr>
//               <th style={S.th}>Name</th>
//               <th style={S.th}>Mobile</th>
//               <th style={S.th}>Email</th>
//               <th style={S.th}>Verified</th>
//               <th style={S.th}>Joined</th>
//               <th style={S.th}></th>
//             </tr>
//           </thead>
//           <tbody>
//             {students.length === 0 ? (
//               <tr>
//                 <td style={S.tdEmpty} colSpan={6}>
//                   No students found.
//                 </td>
//               </tr>
//             ) : (
//               students.map((s) => (
//                 <tr key={s._id} className="p4u-row" onClick={() => setSelected(s._id)} style={S.rowClickable}>
//                   <td style={S.td}>{s.fullName || "\u2014"}</td>
//                   <td style={{ ...S.td, ...S.mono }}>{s.mobile || "\u2014"}</td>
//                   <td style={S.td}>{s.email || "\u2014"}</td>
//                   <td style={S.td}>
//                     <Badge tone={s.isVerified ? "success" : "warning"}>{s.isVerified ? "Verified" : "Unverified"}</Badge>
//                   </td>
//                   <td style={{ ...S.td, ...S.mono }}>{formatDate(s.createdAt)}</td>
//                   <td style={{ ...S.td, textAlign: "right" }}>
//                     <ChevronRight size={16} color="#B4BDD1" />
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {selected && <StudentDrawer studentId={selected} from={from} to={to} onClose={() => setSelected(null)} />}
//     </>
//   );
// };

// const DETAIL_TABS = [
//   { key: "overview", label: "Overview" },
//   { key: "purchases", label: "Purchases", countKey: "purchases" },
//   { key: "requests", label: "Requests", countKey: "serviceRequests" },
//   { key: "payments", label: "Payments", countKey: "payments" },
//   { key: "timeline", label: "Timeline", countKey: "timeline" },
// ];

// const StudentDrawer = ({ studentId, from, to, onClose }) => {
//   const [detail, setDetail] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [err, setErr] = useState("");
//   const [tab, setTab] = useState("overview");

//   useEffect(() => {
//     let cancelled = false;
//     setLoading(true);
//     setErr("");
//     apiGet(`/admin/students/${studentId}/detail?from=${from || ""}&to=${to || ""}`)
//       .then((json) => !cancelled && setDetail(json.data))
//       .catch((e) => !cancelled && setErr(e.message || "Failed to load student"))
//       .finally(() => !cancelled && setLoading(false));
//     return () => {
//       cancelled = true;
//     };
//   }, [studentId, from, to]);

//   const counts = detail?.counts || {};

//   return createPortal(
//     <div style={S.overlay} onClick={onClose}>
//       <div style={S.panel} onClick={(e) => e.stopPropagation()}>
//         <div style={S.panelHead}>
//           <span style={S.eyebrow}>Student profile</span>
//           <button onClick={onClose} style={S.iconBtn} className="p4u-icon-btn">
//             <X size={16} />
//           </button>
//         </div>

//         <div style={S.panelBody}>
//           {loading && <PageLoader label="Loading student\u2026" compact />}
//           {!loading && err && <ErrorState err={err} onRetry={() => { }} compact />}

//           {!loading && !err && detail && (
//             <>
//               <div style={S.hero}>
//                 <div style={S.avatar}>{(detail.profile?.fullName || "?").slice(0, 1).toUpperCase()}</div>
//                 <div style={S.heroText}>
//                   <div style={S.name}>{detail.profile?.fullName || "Unnamed student"}</div>
//                   <div style={S.metaLine}>
//                     {detail.profile?.mobile || "\u2014"} \u00b7 {detail.profile?.email || "\u2014"}
//                   </div>
//                   <div style={S.metaLine}>Joined {formatDate(detail.joinedOn)}</div>
//                 </div>
//               </div>

//               <div style={S.tabBar}>
//                 {DETAIL_TABS.map((t) => (
//                   <button
//                     key={t.key}
//                     onClick={() => setTab(t.key)}
//                     style={{ ...S.tabBtn, ...(tab === t.key ? S.tabBtnActive : {}) }}
//                   >
//                     {t.label}
//                     {t.countKey && counts[t.countKey] != null && (
//                       <span style={S.tabCount}>{counts[t.countKey]}</span>
//                     )}
//                   </button>
//                 ))}
//               </div>

//               <div style={S.tabContent}>
//                 {tab === "overview" && (
//                   <div style={S.overviewGrid}>
//                     <SummaryStat label="Purchases" value={counts.purchases ?? 0} />
//                     <SummaryStat label="Service requests" value={counts.serviceRequests ?? 0} />
//                     <SummaryStat label="Payments" value={counts.payments ?? 0} />
//                   </div>
//                 )}

//                 {tab === "purchases" && (
//                   <CategoryTable rows={detail.purchasesFlat || []} emptyText="No purchases in this range." showAmount />
//                 )}

//                 {tab === "requests" && (
//                   <CategoryTable rows={detail.serviceRequestsFlat || []} emptyText="No service requests in this range." />
//                 )}

//                 {tab === "payments" && (
//                   <div style={S.tableScroll}>
//                     <table style={S.table}>
//                       <thead>
//                         <tr>
//                           <th style={S.th}>Purpose</th>
//                           <th style={S.th}>Gateway</th>
//                           <th style={S.th}>Amount</th>
//                           <th style={S.th}>Status</th>
//                           <th style={S.th}>Date</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {(detail.payments || []).length === 0 ? (
//                           <tr>
//                             <td style={S.tdEmpty} colSpan={5}>No payments in this range.</td>
//                           </tr>
//                         ) : (
//                           detail.payments.map((p) => (
//                             <tr key={p._id}>
//                               <td style={S.td}>{p.purpose}</td>
//                               <td style={S.td}>{p.gateway}</td>
//                               <td style={{ ...S.td, ...S.mono }}>{formatMoney(p.amount)}</td>
//                               <td style={S.td}>
//                                 <Badge tone={statusTone(p.status)}>{p.status}</Badge>
//                               </td>
//                               <td style={{ ...S.td, ...S.mono }}>{formatDateTime(p.createdAt)}</td>
//                             </tr>
//                           ))
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 )}

//                 {tab === "timeline" && (
//                   <div style={S.timelineWrap}>
//                     <div style={S.timelineRail} />
//                     {(detail.timeline || []).length === 0 && <div style={S.helpText}>No activity in this range.</div>}
//                     {(detail.timeline || []).map((entry, i) => {
//                       const meta = TIMELINE_META[entry.type] || { label: entry.type, color: "#94A0B8", icon: Clock };
//                       const Icon = meta.icon;
//                       return (
//                         <div key={i} style={S.timelineItem}>
//                           <span style={{ ...S.timelineNode, background: meta.color }} />
//                           <div style={S.timelineCard}>
//                             <div style={S.timelineTop}>
//                               <span style={S.timelineLabel}>
//                                 <Icon size={13} color={meta.color} /> {meta.label}
//                               </span>
//                               <span style={S.timelineDate}>{formatDateTime(entry.date)}</span>
//                             </div>
//                             {entry.status && <Badge tone={statusTone(entry.status)}>{entry.status}</Badge>}
//                             {entry.type === "payment" && (
//                               <div style={S.timelineSub}>
//                                 {formatMoney(entry.data?.amount)} \u00b7 {entry.data?.purpose} \u00b7 {entry.data?.gateway}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// };

// const SummaryStat = ({ label, value }) => (
//   <div style={S.statCard}>
//     <div style={S.statValue}>{value}</div>
//     <div style={S.statLabel}>{label}</div>
//   </div>
// );

// const CategoryTable = ({ rows, emptyText, showAmount = false }) => (
//   <div style={S.tableScroll}>
//     <table style={S.table}>
//       <thead>
//         <tr>
//           <th style={S.th}>Category</th>
//           <th style={S.th}>Detail</th>
//           {showAmount && <th style={S.th}>Amount</th>}
//           <th style={S.th}>Status</th>
//           <th style={S.th}>Date</th>
//         </tr>
//       </thead>
//       <tbody>
//         {rows.length === 0 ? (
//           <tr>
//             <td style={S.tdEmpty} colSpan={showAmount ? 5 : 4}>{emptyText}</td>
//           </tr>
//         ) : (
//           rows.map((r) => (
//             <tr key={r.id}>
//               <td style={S.td}>{r.category}</td>
//               <td style={S.td}>{r.title}</td>
//               {showAmount && <td style={{ ...S.td, ...S.mono }}>{formatMoney(r.amount)}</td>}
//               <td style={S.td}>{r.status ? <Badge tone={statusTone(r.status)}>{r.status}</Badge> : "\u2014"}</td>
//               <td style={{ ...S.td, ...S.mono }}>{formatDateTime(r.date)}</td>
//             </tr>
//           ))
//         )}
//       </tbody>
//     </table>
//   </div>
// );

// /* =========================================================================
//    REPORTS TAB
//    ========================================================================= */

// const ReportsTab = () => {
//   const [reportType, setReportType] = useState(null);
//   const [reportData, setReportData] = useState([]);
//   const [show, setShow] = useState(false);
//   const [full, setFull] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [err, setErr] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [singleDate, setSingleDate] = useState("");
//   const [filterMode, setFilterMode] = useState("range"); // range | single

//   const buildParams = () => {
//     const params = new URLSearchParams();
//     if (filterMode === "single" && singleDate) params.append("date", singleDate);
//     if (filterMode === "range") {
//       if (fromDate) params.append("from", fromDate);
//       if (toDate) params.append("to", toDate);
//     }
//     return params;
//   };

//   const openReport = async (type) => {
//     setLoading(true);
//     setErr("");
//     try {
//       let url = `/admin/report/${type}`;
//       const params = buildParams();
//       if (params.toString()) url += `?${params.toString()}`;
//       const json = await apiGet(url);
//       setReportType(type);
//       setReportData(json.data || []);
//       setShow(true);
//     } catch (e) {
//       setErr(e.message || "Failed to load report");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const applyFilters = () => {
//     if (reportType) openReport(reportType);
//   };

//   const clearFilters = () => {
//     setFromDate("");
//     setToDate("");
//     setSingleDate("");
//     if (reportType) setTimeout(() => openReport(reportType), 0);
//   };

//   const hasActiveFilter =
//     (filterMode === "single" && singleDate) || (filterMode === "range" && (fromDate || toDate));

//   return (
//     <>
//       <SectionTitle title="Export reports" eyebrow="Pull a full table and download it as CSV" />

//       <div style={S.filterBar}>
//         <div style={S.segmented}>
//           <button
//             type="button"
//             onClick={() => setFilterMode("range")}
//             style={{ ...S.segmentedBtn, ...(filterMode === "range" ? S.segmentedBtnActive : {}) }}
//           >
//             Range
//           </button>
//           <button
//             type="button"
//             onClick={() => setFilterMode("single")}
//             style={{ ...S.segmentedBtn, ...(filterMode === "single" ? S.segmentedBtnActive : {}) }}
//           >
//             Single date
//           </button>
//         </div>

//         {filterMode === "range" ? (
//           <div style={S.dateGroup}>
//             <label style={S.dateField}>
//               <span style={S.dateLabelSm}>From</span>
//               <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={S.dateInputBox} />
//             </label>
//             <span style={S.dateSep}>\u2013</span>
//             <label style={S.dateField}>
//               <span style={S.dateLabelSm}>To</span>
//               <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={S.dateInputBox} />
//             </label>
//           </div>
//         ) : (
//           <div style={S.dateGroup}>
//             <label style={S.dateField}>
//               <span style={S.dateLabelSm}>Date</span>
//               <input type="date" value={singleDate} onChange={(e) => setSingleDate(e.target.value)} style={S.dateInputBox} />
//             </label>
//           </div>
//         )}

//         <div style={S.filterActions}>
//           {hasActiveFilter && (
//             <button type="button" onClick={clearFilters} style={S.ghostBtn}>
//               Clear
//             </button>
//           )}
//           <button
//             type="button"
//             onClick={applyFilters}
//             disabled={!reportType || loading}
//             style={{ ...S.applyBtn, opacity: !reportType || loading ? 0.4 : 1, cursor: !reportType || loading ? "not-allowed" : "pointer" }}
//           >
//             Apply
//           </button>
//         </div>
//       </div>

//       <div style={S.grid4}>
//         {REPORT_TYPES.map(({ key, label, icon: Icon }) => (
//           <button
//             key={key}
//             onClick={() => openReport(key)}
//             style={{ ...S.reportTile, ...(reportType === key && show ? S.reportTileActive : {}) }}
//           >
//             <span style={S.reportTileIcon}>
//               <Icon size={18} color="#6C5CE7" strokeWidth={1.75} />
//             </span>
//             <span>{label}</span>
//           </button>
//         ))}
//       </div>

//       {loading && <PageLoader label="Fetching report\u2026" />}
//       {err && <div style={S.inlineError}>{err}</div>}

//       {show &&
//         createPortal(
//           <div style={S.overlay} onClick={() => setShow(false)}>
//             <div
//               style={{
//                 ...S.modal,
//                 width: full ? "94vw" : 800,
//                 maxWidth: full ? "94vw" : 800,
//                 height: full ? "88vh" : "auto",
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div style={S.modalHead}>
//                 <div>
//                   <h3 style={S.modalTitle}>{reportType} report</h3>
//                   <span style={S.modalCount}>
//                     {reportData.length} record{reportData.length === 1 ? "" : "s"}
//                   </span>
//                 </div>
//                 <div style={{ display: "flex", gap: 6 }}>
//                   <button onClick={() => setFull((f) => !f)} style={S.iconBtn} className="p4u-icon-btn">
//                     {full ? <Minimize2 size={15} /> : <Maximize2 size={15} />}
//                   </button>
//                   <button onClick={() => setShow(false)} style={S.iconBtn} className="p4u-icon-btn">
//                     <X size={15} />
//                   </button>
//                 </div>
//               </div>

//               <div style={{ maxHeight: full ? "70vh" : 420, overflow: "auto", borderTop: "1px solid #EEF0FB" }}>
//                 {reportData.length === 0 ? (
//                   <div style={S.emptyState}>No records match the current filters.</div>
//                 ) : (
//                   <div style={S.tableScroll}>
//                     <table style={S.table}>
//                       <thead>
//                         <tr>
//                           {Object.keys(reportData[0]).map((col) => (
//                             <th key={col} style={S.th}>{col}</th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {reportData.map((row, i) => (
//                           <tr key={i}>
//                             {Object.values(row).map((val, j) => (
//                               <td key={j} style={S.td}>{String(val)}</td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 )}
//               </div>

//               <div style={S.modalFooter}>
//                 <span style={S.modalFooterHint}>{hasActiveFilter ? "Filtered results" : "Showing all records"}</span>
//                 <button
//                   onClick={() => downloadCSV(reportData, reportType)}
//                   disabled={reportData.length === 0}
//                   style={{ ...S.downloadBtn, opacity: reportData.length === 0 ? 0.4 : 1, cursor: reportData.length === 0 ? "not-allowed" : "pointer" }}
//                 >
//                   <Download size={14} /> Download CSV
//                 </button>
//               </div>
//             </div>
//           </div>,
//           document.body
//         )}
//     </>
//   );
// };

// /* =========================================================================
//    SHARED UI PIECES
//    ========================================================================= */

// const Badge = ({ tone = "neutral", children }) => {
//   const tones = {
//     success: { bg: "#E7FBF2", fg: "#0EA968" },
//     danger: { bg: "#FEECEE", fg: "#E5484D" },
//     warning: { bg: "#FFF6E5", fg: "#D08700" },
//     neutral: { bg: "#F1F2F9", fg: "#6B7280" },
//   };
//   const t = tones[tone] || tones.neutral;
//   return <span style={{ ...S.badge, background: t.bg, color: t.fg }}>{children}</span>;
// };

// const SectionTitle = ({ title, eyebrow }) => (
//   <div style={S.sectionTitleWrap}>
//     <div>
//       <div style={S.sectionEyebrow}>{eyebrow}</div>
//       <div style={S.sectionTitle}>{title}</div>
//     </div>
//   </div>
// );

// const CompanyCard = ({ company }) => (
//   <div style={S.companyCard}>
//     <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
//       <div style={S.companyBadge}>
//         <Building2 size={20} color="#6C5CE7" />
//       </div>
//       <div>
//         <div style={S.companyName}>{company?.name || "Company"}</div>
//         <div style={S.companyAddr}>{company?.address || "\u2014"}</div>
//       </div>
//     </div>
//     <div style={S.companyMeta}>
//       <MetaChip label="Phone" value={company?.phone} />
//       <MetaChip label="Email" value={company?.email} />
//       <MetaChip label="Website" value={company?.website} />
//       <MetaChip label="GSTIN" value={company?.gstin} />
//     </div>
//   </div>
// );

// const MetaChip = ({ label, value }) => (
//   <div style={S.metaChip}>
//     <span style={{ color: "#94A0B8", fontWeight: 700 }}>{label}:</span>
//     <span style={{ marginLeft: 6, color: "#151A30", fontWeight: 700 }}>{value || "\u2014"}</span>
//   </div>
// );

// const KpiCard = ({ icon: Icon, accent, accentSoft, title, value, footNote, spark, delta }) => (
//   <div style={S.kpiCard}>
//     <div style={S.kpiTop}>
//       <span style={{ ...S.kpiIcon, background: accentSoft || `${accent}17`, color: accent }}>
//         <Icon size={18} strokeWidth={2} />
//       </span>
//       {spark && spark.length > 1 && <Sparkline data={spark} color={accent} />}
//     </div>
//     <div style={S.kpiTitleLabel}>{title}</div>
//     <div style={S.kpiValue}>{value ?? 0}</div>
//     <div style={S.kpiFootRow}>
//       {typeof delta === "number" && !Number.isNaN(delta) && (
//         <span style={{ ...S.deltaPill, ...(delta >= 0 ? S.deltaPillUp : S.deltaPillDown) }}>
//           {delta >= 0 ? <ArrowUpRight size={11} /> : <ArrowDownRight size={11} />}
//           {Math.abs(delta)}%
//         </span>
//       )}
//       <span style={S.kpiFoot}>{footNote}</span>
//     </div>
//   </div>
// );

// const Sparkline = ({ data, color }) => {
//   const w = 64;
//   const h = 24;
//   const max = Math.max(...data, 1);
//   const min = Math.min(...data, 0);
//   const range = max - min || 1;
//   const points = data
//     .map((v, i) => {
//       const x = (i / (data.length - 1)) * w;
//       const y = h - ((v - min) / range) * h;
//       return `${x.toFixed(1)},${y.toFixed(1)}`;
//     })
//     .join(" ");
//   return (
//     <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
//       <polyline points={points} fill="none" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   );
// };

// const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// const MiniCalendarCard = () => {
//   const [cursor, setCursor] = useState(() => {
//     const d = new Date();
//     return new Date(d.getFullYear(), d.getMonth(), 1);
//   });
//   const today = useMemo(() => new Date(), []);

//   const year = cursor.getFullYear();
//   const month = cursor.getMonth();
//   const firstDow = new Date(year, month, 1).getDay();
//   const daysInMonth = new Date(year, month + 1, 0).getDate();
//   const daysInPrevMonth = new Date(year, month, 0).getDate();

//   const cells = [];
//   for (let i = firstDow - 1; i >= 0; i--) cells.push({ day: daysInPrevMonth - i, dim: true });
//   for (let d = 1; d <= daysInMonth; d++) cells.push({ day: d, dim: false });
//   while (cells.length % 7 !== 0) cells.push({ day: cells.length, dim: true });

//   const isToday = (day, dim) => !dim && day === today.getDate() && month === today.getMonth() && year === today.getFullYear();

//   return (
//     <div style={S.card}>
//       <div style={S.widgetHeadRow}>
//         <span style={S.cardTitle}>Calendar</span>
//         <MoreHorizontal size={16} color="#B4BDD1" />
//       </div>
//       <div style={S.calNavRow}>
//         <button style={S.calNavBtn} onClick={() => setCursor(new Date(year, month - 1, 1))}>
//           <ChevronLeft size={14} />
//         </button>
//         <span style={S.calMonthLabel}>
//           {cursor.toLocaleString("en-IN", { month: "long" })} {year}
//         </span>
//         <button style={S.calNavBtn} onClick={() => setCursor(new Date(year, month + 1, 1))}>
//           <ChevronRight size={14} />
//         </button>
//       </div>
//       <div style={S.calGrid}>
//         {WEEKDAYS.map((w) => (
//           <div key={w} style={S.calWeekday}>{w}</div>
//         ))}
//         {cells.map((c, i) => (
//           <div key={i} style={{ ...S.calCell, ...(c.dim ? S.calCellDim : {}), ...(isToday(c.day, c.dim) ? S.calCellToday : {}) }}>
//             {c.day}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const MAP_PINS = [
//   { top: "28%", left: "18%" }, { top: "34%", left: "24%" }, { top: "30%", left: "27%" },
//   { top: "38%", left: "46%" }, { top: "32%", left: "48%" },
//   { top: "58%", left: "60%" }, { top: "62%", left: "63%" }, { top: "60%", left: "68%" },
//   { top: "70%", left: "58%" }, { top: "48%", left: "72%" },
// ];

// const LiveActivityCard = ({ recent }) => {
//   const activeCount = (recent?.students?.length || 0) + (recent?.teachers?.length || 0);
//   return (
//     <div style={S.card}>
//       <div style={S.widgetHeadRow}>
//         <span style={S.cardTitle}>Live Activity</span>
//         <MoreHorizontal size={16} color="#B4BDD1" />
//       </div>
//       <div style={S.mapWrap}>
//         <div style={S.mapZoomGroup}>
//           <button style={S.mapZoomBtn}>+</button>
//           <button style={S.mapZoomBtn}>&minus;</button>
//         </div>
//         <svg viewBox="0 0 300 160" style={S.mapSvg}>
//           {Array.from({ length: 12 }).map((_, row) =>
//             Array.from({ length: 24 }).map((_, col) => {
//               const x = col * 13 + 4;
//               const y = row * 14 + 6;
//               const on = (row * 7 + col * 3) % 5 !== 0;
//               return on ? <circle key={`${row}-${col}`} cx={x} cy={y} r={1.2} fill="#DCE1EE" /> : null;
//             })
//           )}
//         </svg>
//         {MAP_PINS.map((p, i) => (
//           <span key={i} style={{ ...S.mapPin, top: p.top, left: p.left }} />
//         ))}
//       </div>
//       <div style={S.liveActivityFoot}>
//         <MapPin size={13} color="#6C5CE7" />
//         <span>{formatNum(activeCount)} recent signups across active regions</span>
//       </div>
//     </div>
//   );
// };

// const PaymentStatusDonut = ({ payments, paymentStatusBreakdown }) => {
//   const rows = (paymentStatusBreakdown && paymentStatusBreakdown.length > 0)
//     ? paymentStatusBreakdown.map((d) => ({ name: d._id || "Unknown", value: d.count || 0 }))
//     : [
//       { name: "Success", value: payments?.success || 0 },
//       { name: "Failed", value: payments?.failed || 0 },
//     ];
//   const total = rows.reduce((s, r) => s + r.value, 0) || 1;

//   return (
//     <div style={S.card}>
//       <div style={S.widgetHeadRow}>
//         <span style={S.cardTitle}>Payment Status</span>
//         <MoreHorizontal size={16} color="#B4BDD1" />
//       </div>
//       <div style={{ position: "relative" }}>
//         <ResponsiveContainer width="100%" height={190}>
//           <PieChart>
//             <Pie data={rows} dataKey="value" nameKey="name" innerRadius={54} outerRadius={78} paddingAngle={3} stroke="none">
//               {rows.map((_, i) => (
//                 <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//               ))}
//             </Pie>
//           </PieChart>
//         </ResponsiveContainer>
//         <div style={S.donutCenter}>
//           <div style={S.donutCenterValue}>{formatNum(total)}</div>
//           <div style={S.donutCenterLabel}>payments</div>
//         </div>
//       </div>
//       <div style={{ marginTop: 6 }}>
//         {rows.map((r, i) => {
//           const pct = Math.round((r.value / total) * 1000) / 10;
//           return (
//             <div key={i} style={S.legendRow}>
//               <span style={{ ...S.legendDot, background: PIE_COLORS[i % PIE_COLORS.length] }} />
//               <span style={S.legendName}>{r.name}</span>
//               <span style={{ ...S.legendPct, color: PIE_COLORS[i % PIE_COLORS.length] }}>+{pct}%</span>
//               <span style={S.legendValue}>{formatNum(r.value)}</span>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// const MiniStat = ({ label, value, delta }) => (
//   <div style={S.miniStat}>
//     <div style={S.miniStatLabel}>{label}</div>
//     <div style={S.miniStatValue}>{formatNum(value)}</div>
//     {typeof delta === "number" && (
//       <div style={{ ...S.miniStatDelta, color: delta >= 0 ? "#0EA968" : "#E5484D" }}>
//         {delta >= 0 ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
//         {formatNum(Math.abs(delta))} in range
//       </div>
//     )}
//   </div>
// );

// const StatCard = ({ title, icon: Icon, rows }) => (
//   <div style={S.card}>
//     <div style={S.cardTitleRow}>
//       {Icon && (
//         <span style={S.cardIconBadge}>
//           <Icon size={15} color="#6C5CE7" />
//         </span>
//       )}
//       <span style={S.cardTitle}>{title}</span>
//     </div>
//     <div style={{ marginTop: 10, display: "grid", gap: 2 }}>
//       {rows.map(([k, v], idx) => (
//         <div key={idx} style={S.statRow}>
//           <div style={S.statRowKey}>{k}</div>
//           <div style={S.statRowVal}>{formatNum(v)}</div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// const RecentTable = ({ title, columns, rows }) => (
//   <div style={S.card}>
//     <div style={S.cardTitle}>{title}</div>
//     <div style={{ ...S.tableScrollBare, marginTop: 10 }}>
//       <table style={S.table}>
//         <thead>
//           <tr>
//             {columns.map((c) => (
//               <th key={c} style={S.th}>{c}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {rows.length === 0 ? (
//             <tr>
//               <td style={S.tdEmpty} colSpan={columns.length}>No data</td>
//             </tr>
//           ) : (
//             rows.map((r, i) => (
//               <tr key={i}>
//                 {r.map((cell, j) => (
//                   <td key={j} style={S.td}>{cell}</td>
//                 ))}
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );

// const DonutCard = ({ title, data, valueKey, nameKey, money }) => {
//   const clean = (data || []).map((d) => ({ name: d[nameKey] || "Unknown", value: d[valueKey] || 0 }));
//   return (
//     <div style={S.card}>
//       <div style={S.cardTitle}>{title}</div>
//       {clean.length === 0 ? (
//         <div style={S.helpText}>No data for this range.</div>
//       ) : (
//         <ResponsiveContainer width="100%" height={260}>
//           <PieChart>
//             <Pie data={clean} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={3}>
//               {clean.map((_, i) => (
//                 <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} stroke="none" />
//               ))}
//             </Pie>
//             <Tooltip formatter={(v) => (money ? formatMoney(v) : formatNum(v))} />
//             <Legend wrapperStyle={{ fontSize: 12, fontFamily: "Inter, sans-serif" }} />
//           </PieChart>
//         </ResponsiveContainer>
//       )}
//     </div>
//   );
// };

// const ChartTooltip = ({ active, payload, label, moneyKeys = [] }) => {
//   if (!active || !payload?.length) return null;
//   return (
//     <div style={S.tooltip}>
//       <div style={S.tooltipLabel}>{label}</div>
//       {payload.map((p, i) => (
//         <div key={i} style={S.tooltipRow}>
//           <span style={{ ...S.tooltipDot, background: p.color || p.stroke }} />
//           <span>{p.name}:</span>
//           <b>{moneyKeys.includes(p.dataKey) ? formatMoney(p.value) : formatNum(p.value)}</b>
//         </div>
//       ))}
//     </div>
//   );
// };

// const PageLoader = ({ label, compact }) => (
//   <div style={compact ? S.centerCompact : S.center}>
//     <div style={S.loaderBox}>
//       <Loader2 size={20} color="#6C5CE7" style={{ animation: "p4u-spin 0.9s linear infinite" }} />
//       <div style={S.loaderText}>{label || "Loading\u2026"}</div>
//     </div>
//   </div>
// );

// const ErrorState = ({ err, onRetry, compact }) => (
//   <div style={compact ? S.centerCompact : S.center}>
//     <div style={S.errorBox}>
//       <AlertTriangle size={22} color="#E5484D" />
//       <div style={S.errorTitle}>Something went wrong</div>
//       <div style={S.errorMsg}>{err}</div>
//       <button onClick={onRetry} style={S.retryBtn}>
//         Try again
//       </button>
//     </div>
//   </div>
// );

// /* =========================================================================
//    FONT + GLOBAL STYLE INJECTION
//    ========================================================================= */

// const useInjectFonts = () => {
//   useEffect(() => {
//     if (document.getElementById("p4u-admin-fonts")) return;

//     const link = document.createElement("link");
//     link.id = "p4u-admin-fonts";
//     link.rel = "stylesheet";
//     link.href =
//       "https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap";
//     document.head.appendChild(link);

//     const style = document.createElement("style");
//     style.id = "p4u-admin-style-tag";
//     style.innerHTML = `
//       @keyframes p4u-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
//       .p4u-row:hover { background: #F7F7FD; }
//       .p4u-icon-btn:hover { background: #EFEDFE !important; border-color: #DCD6FB !important; color: #6C5CE7 !important; }
//       input[type="date"]::-webkit-calendar-picker-indicator { opacity: 0.55; cursor: pointer; }
//       ::-webkit-scrollbar { width: 8px; height: 8px; }
//       ::-webkit-scrollbar-thumb { background: #DCD6FB; border-radius: 8px; }
//       @media (max-width: 900px) {
//         .p4u-header-top { flex-direction: column !important; align-items: flex-start !important; }
//         .p4u-top-grid { grid-template-columns: 1fr !important; }
//       }
//     `;
//     document.head.appendChild(style);
//   }, []);
// };

// /* =========================================================================
//    STYLES — single source of truth
//    ========================================================================= */

// const ACCENT = "white"; // interactive indigo/violet, primary brand action color
// const ACCENT_SOFT = "#EFEDFE"; // soft fills / highlights
// const GRADIENT = "linear-gradient(90deg, #7C6CF0 0%, #A855F7 45%, #EC4899 100%)";
// const INK = "#151A30";
// const MUTED = "#7A8399";
// const BORDER = "#EEF0F6";
// const CARD_SHADOW = "0 1px 2px rgba(23,26,53,0.04), 0 8px 24px -12px rgba(23,26,53,0.10)";

// const S = {
//   // ---------- layout ----------
//   frame: {
//     minHeight: "100vh",
//     background: GRADIENT,
//     boxSizing: "border-box",
//   },
//   shell: {
//     minHeight: "calc(100vh - 28px)",
//     background: "#F5F6FB",
//     fontFamily: "'Inter', sans-serif",
//     color: INK,
//     borderRadius: 20,
//     overflow: "hidden",
//     boxShadow: "0 20px 60px -20px rgba(23,26,53,0.35)",
//   },
//   header: {
//     position: "sticky",
//     top: 0,
//     zIndex: 30,
//     background: "#FFFFFF",
//     borderBottom: `1px solid ${BORDER}`,
//     padding: "14px 28px 0",
//   },
//   headerTop: {
//     display: "flex",
//     justifyContent: "flex-start",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: 14,
//     paddingBottom: 14,
//   },
//   searchPill: {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     background: "#F5F6FB",
//     border: `1px solid ${BORDER}`,
//     borderRadius: 10,
//     padding: "8px 14px",
//     minWidth: 220,
//     flex: "0 1 260px",
//   },
//   searchPillInput: {
//     border: "none",
//     outline: "none",
//     background: "transparent",
//     fontSize: 13,
//     fontFamily: "'Inter', sans-serif",
//     color: INK,
//     width: "100%",
//   },
//   navTextRow: { display: "flex", alignItems: "center", gap: 22, marginLeft: 4 },
//   navTextBtn: {
//     position: "relative",
//     display: "flex",
//     alignItems: "center",
//     gap: 4,
//     border: "none",
//     background: "transparent",
//     color: "#3A4152",
//     fontSize: 13.5,
//     fontWeight: 600,
//     cursor: "pointer",
//     padding: "8px 2px",
//   },
//   navTextBtnActive: { color: ACCENT },
//   navDropdown: {
//     position: "absolute",
//     top: "100%",
//     left: 0,
//     background: "#FFFFFF",
//     border: `1px solid ${BORDER}`,
//     borderRadius: 12,
//     boxShadow: "0 16px 40px -12px rgba(23,26,53,0.25)",
//     padding: 6,
//     minWidth: 190,
//     zIndex: 40,
//   },
//   navDropdownItem: {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     padding: "8px 10px",
//     borderRadius: 8,
//     fontSize: 13,
//     fontWeight: 500,
//     color: "#3A4152",
//     cursor: "pointer",
//   },
//   navDropdownItemActive: { background: ACCENT_SOFT, color: ACCENT },
//   headerRight: { display: "flex", alignItems: "center", gap: 8, marginLeft: "auto" },
//   brand: { display: "flex", alignItems: "center", gap: 10 },
//   menuBtn: {
//     width: 34,
//     height: 34,
//     borderRadius: 10,
//     border: `1px solid ${BORDER}`,
//     background: "#FFFFFF",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: MUTED,
//     cursor: "pointer",
//     marginRight: 2,
//   },
//   brandMark: {
//     width: 38,
//     height: 38,
//     borderRadius: 12,
//     background: GRADIENT,
//     color: "#fff",
//     fontFamily: "'Manrope', sans-serif",
//     fontWeight: 800,
//     fontSize: 12.5,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   brandName: { fontFamily: "'Manrope', sans-serif", fontWeight: 800, fontSize: 15.5, color: INK },
//   brandSub: { fontSize: 11, color: MUTED, marginTop: 1, fontWeight: 500 },

//   headerControls: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
//   dateRangePill: {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     background: "#FAFAFE",
//     border: `1px solid ${BORDER}`,
//     borderRadius: 999,
//     padding: "7px 14px",
//   },
//   dateInput: {
//     border: "none",
//     background: "transparent",
//     fontSize: 12.5,
//     fontFamily: "'JetBrains Mono', monospace",
//     color: INK,
//     outline: "none",
//   },
//   dateArrow: { color: "#6C5CE7", fontSize: 12 },

//   segmentGroup: { display: "flex", background: "#F5F6FB", border: `1px solid ${BORDER}`, borderRadius: 10, padding: 3 },
//   segmentBtn: { border: "none", background: "transparent", padding: "6px 12px", fontSize: 12.5, fontWeight: 600, color: MUTED, borderRadius: 8, cursor: "pointer" },
//   segmentBtnActive: { background: INK, color: "#fff" },

//   refreshBtn: {
//     display: "flex",
//     alignItems: "center",
//     gap: 7,
//     background: ACCENT,
//     color: "#fff",
//     border: "none",
//     padding: "9px 16px",
//     borderRadius: 10,
//     fontWeight: 700,
//     fontSize: 13,
//     cursor: "pointer",
//     boxShadow: "0 6px 16px -4px rgba(108,92,231,0.5)",
//   },

//   headerIcons: { display: "flex", alignItems: "center", gap: 8, marginLeft: 4 },
//   roundIconBtn: {
//     position: "relative",
//     width: 34,
//     height: 34,
//     borderRadius: "50%",
//     border: `1px solid ${BORDER}`,
//     background: "#FFFFFF",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: MUTED,
//     cursor: "pointer",
//   },
//   notifDot: {
//     position: "absolute",
//     top: -3,
//     right: -3,
//     background: "#EC4899",
//     color: "#fff",
//     fontSize: 9,
//     fontWeight: 800,
//     borderRadius: 999,
//     width: 15,
//     height: 15,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     border: "2px solid #FFFFFF",
//   },
//   avatarSm: {
//     width: 34,
//     height: 34,
//     borderRadius: "50%",
//     background: GRADIENT,
//     color: "#fff",
//     fontSize: 12,
//     fontWeight: 800,
//     fontFamily: "'Manrope', sans-serif",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },

//   navRow: {
//     display: "flex",
//     gap: 6,
//     overflowX: "auto",
//     paddingBottom: 0,
//     scrollbarWidth: "none",
//     msOverflowStyle: "none",
//   },
//   navPill: {
//     flexShrink: 0,
//     display: "flex",
//     alignItems: "center",
//     gap: 7,
//     border: "none",
//     borderBottom: "2px solid transparent",
//     background: "transparent",
//     color: MUTED,
//     padding: "10px 14px",
//     borderRadius: 0,
//     fontSize: 13.5,
//     fontWeight: 600,
//     cursor: "pointer",
//     whiteSpace: "nowrap",
//     transition: "all 150ms ease",
//   },
//   navPillActive: {
//     color: ACCENT,
//     borderBottom: `2px solid ${ACCENT}`,
//   },

//   content: { padding: "24px 28px 60px", maxWidth: 1360, width: "100%", margin: "0 auto", boxSizing: "border-box" },

//   // ---------- page head ----------
//   pageHeadRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: 14,
//     marginBottom: 20,
//     marginTop:30,
//   },
//   pageEyebrow: { fontSize: 12, fontWeight: 700, color: "#6C5CE7", textTransform: "uppercase", letterSpacing: 0.5 },
//   pageTitle: { fontFamily: "'Manrope', sans-serif", fontSize: 26, fontWeight: 800, margin: "2px 0 0", color: INK },
//   ghostPillBtn: {
//     border: `1px solid ${BORDER}`,
//     background: "#FFFFFF",
//     color: INK,
//     fontWeight: 700,
//     fontSize: 13,
//     padding: "10px 18px",
//     borderRadius: 999,
//     cursor: "pointer",
//   },
//   primaryPillBtn: {
//     border: "none",
//     background: ACCENT,
//     color: "#fff",
//     fontWeight: 700,
//     fontSize: 13,
//     padding: "10px 18px",
//     borderRadius: 999,
//     cursor: "pointer",
//     boxShadow: "0 6px 16px -4px rgba(108,92,231,0.5)",
//   },

//   // ---------- company card ----------
//   companyCard: {
//     background: "#FFFFFF",
//     border: `1px solid ${BORDER}`,
//     boxShadow: CARD_SHADOW,
//     borderRadius: 20,
//     padding: 18,
//     display: "flex",
//     justifyContent: "space-between",
//     flexWrap: "wrap",
//     gap: 14,
//     marginBottom: 4,
//   },
//   companyBadge: { width: 44, height: 44, borderRadius: 14, background: ACCENT_SOFT, display: "flex", alignItems: "center", justifyContent: "center" },
//   companyName: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15, color: INK },
//   companyAddr: { color: MUTED, fontWeight: 500, fontSize: 12.5, marginTop: 2 },
//   companyMeta: { display: "flex", flexWrap: "wrap", gap: 8 },
//   metaChip: { background: "#FAFAFE", border: `1px solid ${BORDER}`, padding: "6px 10px", borderRadius: 999, fontSize: 12 },

//   // ---------- section title ----------
//   sectionTitleWrap: { display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: "30px 0 12px" },
//   sectionEyebrow: { fontSize: 11, fontWeight: 700, color: "#6C5CE7", textTransform: "uppercase", letterSpacing: 0.4 },
//   sectionTitle: { fontFamily: "'Manrope', sans-serif", fontSize: 17, fontWeight: 800, marginTop: 2, color: INK },

//   // ---------- overview top split (2x2 KPI + big chart) ----------
//   overviewTopGrid: {
//     display: "grid",
//     gridTemplateColumns: "minmax(260px, 380px) 1fr",
//     gap: 16,
//     alignItems: "stretch",
//     marginTop: 16,
//   },
//   kpi2x2: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: 14,
//   },
//   chartCardHead: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "0 10px 6px",
//   },
//   widgetRow: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//     gap: 16,
//     marginTop: 16,
//   },
//   widgetHeadRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 },

//   // ---------- calendar widget ----------
//   calNavRow: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 },
//   calNavBtn: { border: `1px solid ${BORDER}`, background: "#FAFAFE", width: 24, height: 24, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: MUTED },
//   calMonthLabel: { fontSize: 13, fontWeight: 700, color: INK, fontFamily: "'Manrope', sans-serif" },
//   calGrid: { display: "grid", gridTemplateColumns: "repeat(7, 1fr)", rowGap: 6, columnGap: 2 },
//   calWeekday: { fontSize: 10.5, fontWeight: 700, color: "#B4BDD1", textAlign: "center", paddingBottom: 4 },
//   calCell: { fontSize: 12.5, textAlign: "center", padding: "6px 0", borderRadius: 8, color: INK, fontWeight: 500 },
//   calCellDim: { color: "#D7DBE8" },
//   calCellToday: { background: ACCENT, color: "#fff", fontWeight: 700 },

//   // ---------- live activity map widget ----------
//   mapWrap: { position: "relative", height: 170, borderRadius: 12, background: "#FAFAFE", overflow: "hidden" },
//   mapZoomGroup: { position: "absolute", top: 8, left: 8, display: "flex", flexDirection: "column", gap: 3, zIndex: 2 },
//   mapZoomBtn: { width: 20, height: 20, borderRadius: 5, border: `1px solid ${BORDER}`, background: "#FFFFFF", fontSize: 12, fontWeight: 700, color: MUTED, cursor: "pointer", lineHeight: 1 },
//   mapSvg: { width: "100%", height: "100%" },
//   mapPin: {
//     position: "absolute",
//     width: 9,
//     height: 9,
//     borderRadius: "50%",
//     background: ACCENT,
//     border: "2px solid #fff",
//     boxShadow: "0 0 0 3px rgba(108,92,231,0.25)",
//     transform: "translate(-50%, -50%)",
//   },
//   liveActivityFoot: { display: "flex", alignItems: "center", gap: 6, marginTop: 10, fontSize: 12, color: MUTED, fontWeight: 500 },

//   // ---------- donut legend widget ----------
//   donutCenter: { position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-58%)", textAlign: "center" },
//   donutCenterValue: { fontSize: 18, fontWeight: 800, color: INK, fontFamily: "'Manrope', sans-serif" },
//   donutCenterLabel: { fontSize: 10.5, color: MUTED },
//   legendRow: { display: "flex", alignItems: "center", gap: 8, padding: "6px 2px" },
//   legendDot: { width: 8, height: 8, borderRadius: "50%", flexShrink: 0 },
//   legendName: { fontSize: 12.5, color: "#3A4152", fontWeight: 600, flex: 1 },
//   legendPct: { fontSize: 11.5, fontWeight: 800 },
//   legendValue: { fontSize: 12.5, fontWeight: 700, color: INK, marginLeft: 8, minWidth: 34, textAlign: "right" },

//   // ---------- grids ----------
//   kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 16, marginTop: 18 },
//   grid5: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 },
//   grid4: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 },
//   grid3: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 14 },
//   grid2: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 14 },

//   // ---------- kpi / stat cards ----------
//   kpiCard: { background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 18, padding: 20 },
//   kpiTop: { display: "flex", justifyContent: "space-between", alignItems: "center" },
//   kpiIcon: { width: 38, height: 38, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" },
//   kpiTitleLabel: { color: MUTED, fontSize: 12.5, fontWeight: 600, marginTop: 16 },
//   kpiValue: { fontFamily: "'Manrope', sans-serif", fontSize: 27, fontWeight: 800, marginTop: 5, color: INK },
//   kpiFootRow: { display: "flex", alignItems: "center", gap: 8, marginTop: 10, flexWrap: "wrap" },
//   kpiFoot: { color: "#8A93A8", fontSize: 11.5 },
//   deltaPill: {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 2,
//     fontSize: 11,
//     fontWeight: 800,
//     padding: "2px 7px",
//     borderRadius: 999,
//   },
//   deltaPillUp: { background: "#E7FBF2", color: "#0EA968" },
//   deltaPillDown: { background: "#FEECEE", color: "#E5484D" },

//   miniStat: { background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 16, padding: 14 },
//   miniStatLabel: { fontSize: 11.5, color: MUTED, fontWeight: 600 },
//   miniStatValue: { fontFamily: "'Manrope', sans-serif", fontSize: 19, fontWeight: 700, marginTop: 4 },
//   miniStatDelta: { display: "flex", alignItems: "center", gap: 3, fontSize: 11, fontWeight: 700, marginTop: 6 },

//   card: { background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 18, padding: 18 },
//   cardTitleRow: { display: "flex", alignItems: "center", gap: 8 },
//   cardIconBadge: { width: 26, height: 26, borderRadius: 8, background: ACCENT_SOFT, display: "flex", alignItems: "center", justifyContent: "center" },
//   cardTitle: { fontSize: 14, fontWeight: 700, color: INK },

//   statRow: { display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "1px dashed #F0F1F8" },
//   statRowKey: { color: MUTED, fontSize: 13, fontWeight: 500 },
//   statRowVal: { fontWeight: 700, fontFamily: "'JetBrains Mono', monospace", fontSize: 13 },

//   // ---------- tables (single shared system) ----------
//   table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
//   th: {
//     textAlign: "left",
//     padding: "10px 14px",
//     fontSize: 11,
//     background: "#FAFAFE",
//     color: "#8A93A8",
//     fontWeight: 700,
//     textTransform: "uppercase",
//     letterSpacing: 0.3,
//     borderBottom: `1px solid ${BORDER}`,
//     whiteSpace: "nowrap",
//   },
//   td: { padding: "11px 14px", fontSize: 13, fontWeight: 500, borderTop: "1px solid #F5F6FB", color: INK, whiteSpace: "nowrap" },
//   tdEmpty: { padding: "28px 14px", textAlign: "center", color: MUTED, fontSize: 13 },
//   mono: { fontFamily: "'JetBrains Mono', monospace", fontSize: 12.5 },
//   rowClickable: { cursor: "pointer" },
//   tableScroll: { overflowX: "auto", border: `1px solid ${BORDER}`, borderRadius: 12 },
//   tableScrollBare: { overflowX: "auto" },

//   // ---------- charts ----------
//   chartCard: { background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 18, padding: "18px 8px 10px" },
//   tooltip: { background: INK, color: "#fff", borderRadius: 12, padding: "10px 12px", fontSize: 12, boxShadow: "0 10px 30px rgba(0,0,0,0.2)" },
//   tooltipLabel: { fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: "#9AA3B8", marginBottom: 6 },
//   tooltipRow: { display: "flex", alignItems: "center", gap: 6, marginTop: 2 },
//   tooltipDot: { width: 7, height: 7, borderRadius: "50%" },

//   // ---------- search ----------
//   searchBar: { display: "flex", alignItems: "center", gap: 10, background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 14, padding: "12px 16px", marginBottom: 14 },
//   searchInput: { flex: 1, border: "none", outline: "none", fontSize: 14, fontFamily: "'Inter', sans-serif", background: "transparent", color: INK },
//   inlineError: { background: "#FEECEE", color: "#E5484D", borderRadius: 12, padding: "10px 14px", fontSize: 13, marginBottom: 12, fontWeight: 600 },

//   badge: { display: "inline-block", padding: "3px 9px", borderRadius: 999, fontSize: 11, fontWeight: 700 },

//   // ---------- report tiles ----------
//   reportTile: {
//     display: "flex",
//     alignItems: "center",
//     gap: 10,
//     background: "#FFFFFF",
//     border: `1px solid ${BORDER}`,
//     boxShadow: CARD_SHADOW,
//     borderRadius: 16,
//     padding: 16,
//     cursor: "pointer",
//     fontSize: 13,
//     fontWeight: 700,
//     color: INK,
//     transition: "all 0.15s ease",
//   },
//   reportTileIcon: { width: 32, height: 32, borderRadius: 10, background: ACCENT_SOFT, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   reportTileActive: { borderColor: ACCENT, background: ACCENT_SOFT },

//   // ---------- filter bar (reports) ----------
//   filterBar: {
//     display: "flex",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: 14,
//     padding: "12px 16px",
//     marginBottom: 16,
//     background: "#FFFFFF",
//     border: `1px solid ${BORDER}`,
//     boxShadow: CARD_SHADOW,
//     borderRadius: 14,
//   },
//   segmented: { display: "flex", background: "#F5F6FB", borderRadius: 10, padding: 3, gap: 2 },
//   segmentedBtn: { border: "none", background: "transparent", padding: "6px 12px", fontSize: 12.5, fontWeight: 500, color: MUTED, borderRadius: 8, cursor: "pointer", transition: "all 150ms ease" },
//   segmentedBtnActive: { background: "#FFFFFF", color: INK, boxShadow: "0 1px 3px rgba(108,92,231,0.2)" },
//   dateGroup: { display: "flex", alignItems: "flex-end", gap: 10 },
//   dateField: { display: "flex", flexDirection: "column", gap: 4 },
//   dateLabelSm: { fontSize: 11, color: MUTED, fontWeight: 500, letterSpacing: "0.02em", textTransform: "uppercase" },
//   dateInputBox: { border: `1px solid ${BORDER}`, borderRadius: 8, padding: "6px 9px", fontSize: 13, color: INK, background: "#FFFFFF", outline: "none" },
//   dateSep: { color: "#B4BDD1", paddingBottom: 7, fontSize: 13 },
//   filterActions: { display: "flex", gap: 8, marginLeft: "auto" },
//   ghostBtn: { border: "1px solid transparent", background: "transparent", color: MUTED, fontSize: 12.5, fontWeight: 500, padding: "8px 12px", borderRadius: 8, cursor: "pointer" },
//   applyBtn: { border: "none", background: ACCENT, color: "#FFFFFF", fontSize: 12.5, fontWeight: 600, padding: "8px 16px", borderRadius: 8 },
//   emptyState: { padding: "40px 20px", textAlign: "center", fontSize: 13, color: MUTED },

//   // ---------- overlay / modal / drawer (all portal-based, always topmost) ----------
//   overlay: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(15,17,35,0.45)",
//     zIndex: 9999,
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   modal: {
//     background: "#FFFFFF",
//     borderRadius: 20,
//     boxShadow: "0 30px 60px rgba(23,26,53,0.25)",
//     overflow: "hidden",
//     display: "flex",
//     flexDirection: "column",
//   },
//   modalHead: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px" },
//   modalTitle: { margin: 0, fontFamily: "'Manrope', sans-serif", fontSize: 15, fontWeight: 700, textTransform: "capitalize" },
//   modalCount: { fontSize: 12, color: MUTED },
//   modalFooter: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 18px", borderTop: `1px solid ${BORDER}` },
//   modalFooterHint: { fontSize: 12, color: MUTED },
//   downloadBtn: { display: "flex", alignItems: "center", gap: 6, border: "none", background: "#0EA968", color: "#FFFFFF", fontSize: 12.5, fontWeight: 700, padding: "9px 16px", borderRadius: 10 },

//   iconBtn: { border: `1px solid ${BORDER}`, background: "#FFFFFF", borderRadius: 9, width: 30, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: MUTED, transition: "background 120ms ease" },

//   panel: {
//     width: 460,
//     maxWidth: "100vw",
//     height: "100vh",
//     background: "#FFFFFF",
//     boxShadow: "-16px 0 44px rgba(23,26,53,0.16)",
//     display: "flex",
//     flexDirection: "column",
//     boxSizing: "border-box",
//     marginLeft: "auto",
//   },
//   panelHead: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: `1px solid ${BORDER}`, flexShrink: 0 },
//   eyebrow: { fontSize: 11.5, fontWeight: 700, color: "#6C5CE7", letterSpacing: "0.03em", textTransform: "uppercase" },
//   panelBody: { flex: 1, overflowY: "auto", padding: 20, boxSizing: "border-box" },

//   // ---------- student identity ----------
//   hero: { display: "flex", alignItems: "center", gap: 12, marginBottom: 18 },
//   avatar: { width: 44, height: 44, flexShrink: 0, borderRadius: "50%", background: GRADIENT, color: "#FFFFFF", fontSize: 17, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" },
//   heroText: { minWidth: 0 },
//   name: { fontSize: 16, fontWeight: 700, fontFamily: "'Manrope', sans-serif", color: INK, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
//   metaLine: { fontSize: 12.5, color: MUTED, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },

//   spendRow: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18 },
//   spendCard: { border: `1px solid ${BORDER}`, borderRadius: 14, padding: "12px 14px", background: "#FAFAFE", minWidth: 0 },
//   spendCardAccent: { background: ACCENT_SOFT, borderColor: "#DCD6FB" },
//   kpiLabel: { fontSize: 11.5, color: MUTED, marginBottom: 4 },
//   kpiValueSm: { fontSize: 18, fontWeight: 700, color: INK, fontFamily: "'Manrope', sans-serif" },

//   // ---------- detail tabs ----------
//   tabBar: { display: "flex", gap: 2, background: "#F5F6FB", borderRadius: 12, padding: 3, marginBottom: 16, overflowX: "auto" },
//   tabBtn: { flexShrink: 0, display: "flex", alignItems: "center", gap: 5, border: "none", background: "transparent", padding: "7px 11px", fontSize: 12.5, fontWeight: 500, color: MUTED, borderRadius: 9, cursor: "pointer", whiteSpace: "nowrap" },
//   tabBtnActive: { background: "#FFFFFF", color: INK, boxShadow: "0 1px 3px rgba(108,92,231,0.2)" },
//   tabCount: { fontSize: 10, fontWeight: 700, color: "#6C5CE7", background: ACCENT_SOFT, borderRadius: 999, padding: "1px 6px" },
//   tabContent: { minWidth: 0 },

//   overviewGrid: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 },
//   statCard: { border: `1px solid ${BORDER}`, borderRadius: 12, padding: "12px 10px", background: "#FAFAFE", textAlign: "center" },
//   statValue: { fontSize: 19, fontWeight: 700, color: INK, fontFamily: "'Manrope', sans-serif" },
//   statLabel: { fontSize: 11, color: MUTED, marginTop: 2 },

//   // ---------- timeline ----------
//   timelineWrap: { position: "relative", paddingLeft: 18 },
//   timelineRail: { position: "absolute", left: 4, top: 4, bottom: 4, width: 1, background: BORDER },
//   timelineItem: { position: "relative", marginBottom: 14 },
//   timelineNode: { position: "absolute", left: -18, top: 4, width: 8, height: 8, borderRadius: "50%" },
//   timelineCard: { border: `1px solid ${BORDER}`, borderRadius: 12, padding: "10px 12px", background: "#FFFFFF" },
//   timelineTop: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 4, flexWrap: "wrap" },
//   timelineLabel: { display: "flex", alignItems: "center", gap: 5, fontSize: 12.5, fontWeight: 600, color: INK },
//   timelineDate: { fontSize: 11, color: MUTED, whiteSpace: "nowrap", fontFamily: "'JetBrains Mono', monospace" },
//   timelineSub: { fontSize: 12, color: MUTED, marginTop: 4, fontFamily: "'JetBrains Mono', monospace" },
//   helpText: { fontSize: 13, color: MUTED, lineHeight: 1.6, padding: "8px 0" },

//   // ---------- loaders / errors ----------
//   center: { minHeight: "50vh", display: "grid", placeItems: "center" },
//   centerCompact: { minHeight: 200, display: "grid", placeItems: "center" },
//   loaderBox: { display: "flex", gap: 10, alignItems: "center" },
//   loaderText: { fontWeight: 600, color: MUTED, fontSize: 13.5 },

//   errorBox: { textAlign: "center", maxWidth: 320 },
//   errorTitle: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15, marginTop: 10 },
//   errorMsg: { color: MUTED, fontSize: 13, marginTop: 6 },
//   retryBtn: { marginTop: 14, background: INK, color: "#fff", border: "none", padding: "9px 18px", borderRadius: 12, fontWeight: 700, cursor: "pointer" },
// };




import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import {
  Users,
  GraduationCap,
  Wallet,
  CreditCard,
  Search,
  RefreshCw,
  Download,
  X,
  Calendar,
  FileText,
  BookOpen,
  Bell,
  Landmark,
  Newspaper,
  ShieldCheck,
  ArrowUpRight,
  ArrowDownRight,
  Loader2,
  AlertTriangle,
  LayoutGrid,
  BarChart3,
  UserSearch,
  ClipboardList,
  ChevronRight,
  Video,
  HandHelping,
  CalendarClock,
  Clock,
  Minimize2,
  Maximize2,
  UserPlus,
  UploadCloud,
  Percent,
} from "lucide-react";

/* =========================================================================
   CONFIG
   ========================================================================= */

const API_BASE = process.env.REACT_APP_API_BASEURL;

const REPORT_TYPES = [
  { key: "students", label: "All Students", icon: Users },
  { key: "homeTutor", label: "Home Tutor", icon: HandHelping },
  { key: "homeWork", label: "Homework Assistance", icon: BookOpen },
  { key: "subjective", label: "Subjective Exams", icon: FileText },
  { key: "payments", label: "Payments", icon: CreditCard },
  { key: "notes", label: "Exam Notes", icon: Newspaper },
  { key: "subadmins", label: "Sub Admins", icon: ShieldCheck },
  { key: "appointments", label: "Appointments", icon: CalendarClock },
];

const TIMELINE_META = {
  assignment_subscription: { label: "Assignment subscription", color: "#6366F1", icon: ClipboardList },
  exam_notes_purchase: { label: "Exam notes purchase", color: "#10B981", icon: BookOpen },
  subjective_exam_purchase: { label: "Subjective exam purchase", color: "#F59E0B", icon: FileText },
  live_class_purchase: { label: "Live class purchase", color: "#8B5CF6", icon: Video },
  home_tutor_request: { label: "Home tutor request", color: "#3B82F6", icon: HandHelping },
  home_work_request: { label: "Homework request", color: "#0D9488", icon: BookOpen },
  appointment: { label: "Appointment", color: "#EC4899", icon: CalendarClock },
  payment: { label: "Payment", color: "#151A30", icon: CreditCard },
};

const PIE_COLORS = ["#6366F1", "#10B981", "#F59E0B", "#EC4899", "#3B82F6", "#8B5CF6", "#F43F5E", "#64748B"];

const NAV_ITEMS = [
  { key: "overview", label: "Overview", icon: LayoutGrid },
  { key: "analytics", label: "Analytics", icon: BarChart3 },
  { key: "students", label: "Students", icon: UserSearch },
  { key: "reports", label: "Reports", icon: ClipboardList },
];

/* =========================================================================
   HELPERS
   ========================================================================= */

const authHeaders = () => {
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const apiGet = async (path) => {
  const res = await fetch(`${API_BASE}${path}`, { headers: authHeaders() });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json?.success === false) {
    throw new Error(json?.message || `Request failed (${res.status})`);
  }
  return json;
};

const formatMoney = (v) => {
  const num = Number(v || 0);
  if (Number.isNaN(num)) return "\u20b90";
  if (Math.abs(num) >= 100000) return `\u20b9${(num / 100000).toFixed(2)}L`;
  return `\u20b9${num.toLocaleString("en-IN")}`;
};

const formatNum = (v) => Number(v || 0).toLocaleString("en-IN");

const formatDate = (d) => {
  if (!d) return "\u2014";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "\u2014";
  }
};

const formatDateTime = (d) => {
  if (!d) return "\u2014";
  try {
    return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "\u2014";
  }
};

const isoDate = (d) => d.toISOString().slice(0, 10);

const mergeTrends = (series) => {
  const labels = new Set();
  Object.values(series).forEach((arr) => (arr || []).forEach((p) => labels.add(p.label)));
  const sorted = Array.from(labels).sort();
  return sorted.map((label) => {
    const row = { label };
    Object.entries(series).forEach(([key, arr]) => {
      const found = (arr || []).find((p) => p.label === label);
      row[key] = found ? found.count ?? found.total ?? 0 : 0;
    });
    return row;
  });
};

const statusTone = (status) => {
  const s = (status || "").toLowerCase();
  if (["success", "completed", "approved", "active", "paid"].includes(s)) return "success";
  if (["failed", "rejected", "cancelled", "expired", "inactive"].includes(s)) return "danger";
  return "warning";
};

const downloadCSV = (data, filename) => {
  if (!data?.length) return;
  const headers = Object.keys(data[0]);
  const csv = [headers.join(","), ...data.map((row) => headers.map((h) => JSON.stringify(row[h] ?? "")).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename + ".csv";
  a.click();
  window.URL.revokeObjectURL(url);
};

const initials = (name) =>
  (name || "?").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

const AVATAR_COLORS = ["#6366F1", "#10B981", "#F59E0B", "#EC4899", "#3B82F6", "#8B5CF6"];

/* =========================================================================
   DEMO DATA — matches your real API shape. Falls back automatically if
   REACT_APP_API_BASEURL isn't set or the request fails.
   ========================================================================= */

const buildTrend = (points, seed, spread, unit) =>
  Array.from({ length: points }).map((_, i) => {
    const d = new Date();
    if (unit === "month") d.setMonth(d.getMonth() - (points - 1 - i));
    else d.setDate(d.getDate() - (points - 1 - i));
    const wobble = Math.sin(i / 2.3) * spread + Math.cos(i / 4) * (spread / 2);
    const val = Math.max(0, Math.round(seed + wobble * seed * 0.35 + i * (seed / points) * 0.6));
    return {
      label: unit === "month" ? d.toLocaleString("en-IN", { month: "short", year: "2-digit" }) : `${d.getDate()} ${d.toLocaleString("en-IN", { month: "short" })}`,
      total: val,
      count: val,
    };
  });

const DEMO_OVERVIEW = {
  company: { name: "Path4U", address: "MG Road, Bengaluru, Karnataka", phone: "+91 98765 43210", email: "hello@path4u.in", website: "path4u.in", gstin: "29ABCDE1234F1Z5" },
  users: {
    students: { total: 1102, newInRange: 245, verified: 980 },
    teachers: { total: 20, pendingApproval: 3 },
  },
  masters: { states: 28, cities: 640, boards: 6, classes: 12, subjects: 84, competitions: 14, universities: 92, courses: 210, semesters: 8, collegeSubjects: 340, niosClasses: 4, niosSubjects: 22 },
  content: { checkedExams: { total: 412, pending: 18, approved: 360, rejected: 34 }, notes: 158, subjectiveExams: 61, submittedExams: 288 },
  services: {
    homeTutorRequests: { total: 44, pending: 6 },
    homeWorkAssistance: { total: 33, pending: 4 },
    appointments: { total: 27, pending: 3 },
    liveClasses: { total: 19, purchases: 76, newInRange: 12 },
  },
  cms: {
    sliders: 6,
    notifications: 214,
    coupons: { total: 22, active: 9 },
    councils: 5,
    jobs: { total: 38, active: 14 },
    scholarships: 11,
    chooseCareer: { categories: 16, blogs: 47 },
  },
  purchases: {
    assignmentSubscriptions: { total: 92, newInRange: 12 },
    examNotesPurchases: { total: 61, newInRange: 8 },
    homeTutorSubscriptions: { total: 44, newInRange: 5 },
    homeWorkPurchases: 33,
    subjectiveExamSubscriptions: { total: 18, newInRange: 2 },
  },
  revenue: { totalInRange: 376000, totalAllTime: 4820000 },
  payments: { totalInRange: 106, success: 79, failed: 27 },
  today: { newAdmissions: 14, paymentsToday: 8, teacherRequests: 3, newStudents: 5 },
  recent: {
    students: [
      { fullName: "Rahul Kumar", course: "BCA", mobile: "98765 43210", email: "rahul@mail.com", createdAt: "2026-07-17", status: "Active", feeStatus: "Paid" },
      { fullName: "Anjali Verma", course: "MBA", mobile: "98765 22345", email: "anjali@mail.com", createdAt: "2026-07-16", status: "Pending", feeStatus: "Pending" },
      { fullName: "Pooja Sharma", course: "B.Tech", mobile: "98123 45678", email: "pooja@mail.com", createdAt: "2026-07-16", status: "Active", feeStatus: "Paid" },
      { fullName: "Naina Singh", course: "B.Sc", mobile: "97123 45671", email: "naina@mail.com", createdAt: "2026-07-15", status: "Inactive", feeStatus: "Pending" },
      { fullName: "Aditya Raj", course: "B.Com", mobile: "96123 45672", email: "aditya@mail.com", createdAt: "2026-07-15", status: "Active", feeStatus: "Paid" },
    ],
    teachers: [
      { mobile: "99887 66554", approvalStatus: "Approved", isVerified: true, createdAt: "2026-07-16" },
      { mobile: "99887 11223", approvalStatus: "Pending", isVerified: false, createdAt: "2026-07-14" },
    ],
    jobs: [
      { jobTitle: "Math Tutor", companyName: "Path4U", status: "Active", lastDateToApply: "2026-08-10" },
      { jobTitle: "Content Reviewer", companyName: "Path4U", status: "Closed", lastDateToApply: "2026-07-01" },
    ],
    payments: [
      { purpose: "Assignment subscription", studentName: "Rahul Kumar", gateway: "UPI", amount: 15000, status: "Success", createdAt: "2026-07-17" },
      { purpose: "Exam notes", studentName: "Anjali Verma", gateway: "Card", amount: 8500, status: "Success", createdAt: "2026-07-16" },
      { purpose: "Home tutor", studentName: "Pooja Sharma", gateway: "UPI", amount: 12500, status: "Pending", createdAt: "2026-07-16" },
      { purpose: "Live class", studentName: "Neha Singh", gateway: "Net Banking", amount: 7000, status: "Failed", createdAt: "2026-07-15" },
      { purpose: "Subjective exam", studentName: "Aditya Raj", gateway: "Card", amount: 9000, status: "Success", createdAt: "2026-07-15" },
    ],
  },
};

const DEMO_ANALYTICS_DAY = {
  revenueTrend: buildTrend(30, 12500, 1, "day"),
  signups: { students: buildTrend(30, 36, 1, "day"), teachers: buildTrend(30, 2, 1.4, "day") },
  purchaseTrends: {
    assignmentSubscriptions: buildTrend(30, 3, 1, "day"),
    examNotesPurchases: buildTrend(30, 2, 1, "day"),
    subjectiveExamPurchases: buildTrend(30, 1, 1.2, "day"),
    liveClassPurchases: buildTrend(30, 1.5, 1, "day"),
  },
  revenueByPurpose: [
    { _id: "Assignment subscription", total: 148000 },
    { _id: "Home tutor", total: 92000 },
    { _id: "Exam notes", total: 61000 },
    { _id: "Live class", total: 45000 },
    { _id: "Subjective exam", total: 30000 },
  ],
  revenueByGateway: [
    { _id: "UPI", total: 210000 },
    { _id: "Card", total: 120000 },
    { _id: "Net Banking", total: 46000 },
  ],
  paymentStatusBreakdown: [
    { _id: "Success", count: 79 },
    { _id: "Failed", count: 27 },
  ],
  paymentsWeekly: [
    { label: "1 Jul", success: 14, failed: 4 },
    { label: "7 Jul", success: 18, failed: 6 },
    { label: "14 Jul", success: 11, failed: 3 },
    { label: "21 Jul", success: 20, failed: 8 },
    { label: "28 Jul", success: 16, failed: 6 },
  ],
};

const DEMO_ANALYTICS_MONTH = {
  ...DEMO_ANALYTICS_DAY,
  revenueTrend: buildTrend(12, 12500 * 6, 1, "month"),
  signups: { students: buildTrend(12, 36 * 8, 1, "month"), teachers: buildTrend(12, 2 * 8, 1.4, "month") },
};

const DEMO_STUDENTS = DEMO_OVERVIEW.recent.students.map((s, i) => ({ _id: `demo-${i}`, ...s, isVerified: s.status === "Active", createdAt: s.createdAt }));

/* =========================================================================
   ROOT COMPONENT
   ========================================================================= */

export default function AdminDashboardStats() {
  useInjectFonts();

  const [tab, setTab] = useState("overview");

  const today = useMemo(() => new Date(), []);
  const monthAgo = useMemo(() => new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000), [today]);
  const [from, setFrom] = useState(isoDate(monthAgo));
  const [to, setTo] = useState(isoDate(today));
  const [granularity, setGranularity] = useState("day");

  const [overview, setOverview] = useState(DEMO_OVERVIEW);
  const [overviewLoading, setOverviewLoading] = useState(false);
  const [overviewErr, setOverviewErr] = useState("");

  const [analytics, setAnalytics] = useState(DEMO_ANALYTICS_DAY);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [analyticsErr, setAnalyticsErr] = useState("");
  const [usingDemo, setUsingDemo] = useState(true);

  const qs = useMemo(() => `?from=${from}&to=${to}`, [from, to]);

  const fetchOverview = useCallback(async () => {
    if (!API_BASE) return;
    setOverviewLoading(true);
    setOverviewErr("");
    try {
      const json = await apiGet(`/admin/overview${qs}`);
      setOverview(json.data);
      setUsingDemo(false);
    } catch (e) {
      setOverviewErr("");
      setOverview(DEMO_OVERVIEW);
    } finally {
      setOverviewLoading(false);
    }
  }, [qs]);

  const fetchAnalytics = useCallback(async () => {
    if (!API_BASE) {
      setAnalytics(granularity === "month" ? DEMO_ANALYTICS_MONTH : DEMO_ANALYTICS_DAY);
      return;
    }
    setAnalyticsLoading(true);
    setAnalyticsErr("");
    try {
      const json = await apiGet(`/admin/analytics${qs}&granularity=${granularity}`);
      setAnalytics(json.data);
      setUsingDemo(false);
    } catch (e) {
      setAnalyticsErr("");
      setAnalytics(granularity === "month" ? DEMO_ANALYTICS_MONTH : DEMO_ANALYTICS_DAY);
    } finally {
      setAnalyticsLoading(false);
    }
  }, [qs, granularity]);

  useEffect(() => {
    fetchOverview();
    fetchAnalytics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchOverview, fetchAnalytics]);

  const refreshAll = () => {
    fetchOverview();
    fetchAnalytics();
  };

  const loading = overviewLoading || analyticsLoading;

  return (
    <div style={S.shell}>
      <header style={S.header}>
        <div style={S.headerTop} className="p4u-header-top">
          {/* <nav style={S.navRow}>
            {NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              const active = tab === item.key;
              return (
                <button key={item.key} onClick={() => setTab(item.key)} style={{ ...S.navPill, ...(active ? S.navPillActive : {}) }}>
                  <Icon size={15} strokeWidth={2} />
                  {item.label}
                </button>
              );
            })}
          </nav> */}

          <nav style={S.navRow}>
            {NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              const active = tab === item.key;
              const color = item.accent || '#F17800'; // Fallback color

              return (
                <button
                  key={item.key}
                  onClick={() => setTab(item.key)}
                  style={{
                    ...S.navPill,
                    borderColor: active ? color : 'transparent',
                    backgroundColor: active ? `${color}15` : 'transparent', // 15 = ~8% opacity
                    color: active ? color : '#6B7280',
                    ...(active ? S.navPillActive : {}),
                  }}
                >
                  <div
                    style={{
                      ...S.iconWrapper,
                      backgroundColor: active ? `${color}25` : '#F3F4F6',
                      color: active ? color : '#9CA3AF',
                    }}
                  >
                    <Icon size={16} strokeWidth={active ? 2.5 : 2} />
                  </div>
                  <span style={{ fontWeight: active ? 600 : 500 }}>{item.label}</span>
                </button>
              );
            })}
          </nav>

          <div style={S.headerControls}>
            <div style={S.dateRangePill}>
              <Calendar size={13} color="#6366F1" />
              <input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} style={S.dateInput} />
              <span style={S.dateArrow}>&rarr;</span>
              <input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} style={S.dateInput} />
            </div>

            <div style={S.segmentGroup}>
              {["day", "month"].map((g) => (
                <button key={g} onClick={() => setGranularity(g)} style={{ ...S.segmentBtn, ...(granularity === g ? S.segmentBtnActive : {}) }}>
                  {g === "day" ? "Daily" : "Monthly"}
                </button>
              ))}
            </div>

            <button onClick={refreshAll} style={S.refreshBtn} disabled={loading}>
              <RefreshCw size={14} style={{ animation: loading ? "p4u-spin 0.9s linear infinite" : "none" }} />
              Refresh
            </button>
          </div>
        </div>
      </header>

      <main style={S.content}>
        {tab === "overview" && (
          <OverviewTab overview={overview} loading={overviewLoading} err={overviewErr} onRetry={fetchOverview} analytics={analytics} />
        )}
        {tab === "analytics" && (
          <AnalyticsTab analytics={analytics} loading={analyticsLoading} err={analyticsErr} onRetry={fetchAnalytics} />
        )}
        {tab === "students" && <StudentsTab from={from} to={to} />}
        {tab === "reports" && <ReportsTab />}

        {usingDemo && (
          <div style={S.demoNote}>
            Showing sample data \u2014 set <code>REACT_APP_API_BASEURL</code> to load live numbers from your API.
          </div>
        )}
      </main>
    </div>
  );
}

/* =========================================================================
   OVERVIEW TAB
   ========================================================================= */

const OverviewTab = ({ overview, loading, err, onRetry, analytics }) => {
  if (loading) return <PageLoader label="Loading overview\u2026" />;
  if (err) return <ErrorState err={err} onRetry={onRetry} />;
  const o = overview || DEMO_OVERVIEW;
  const a = analytics || DEMO_ANALYTICS_DAY;

  const { users, masters, content, services, cms, purchases, revenue, payments, recent } = o;

  const revenueSpark = (a.revenueTrend || []).map((p) => p.total ?? 0);
  const studentSpark = (a.signups?.students || []).map((p) => p.count ?? 0);
  const paymentsWeekly = a.paymentsWeekly || DEMO_ANALYTICS_DAY.paymentsWeekly;

  const subsData = [
    { name: "Assignment Subs", value: purchases?.assignmentSubscriptions?.total || 0, color: "#6366F1" },
    { name: "Exam Notes", value: purchases?.examNotesPurchases?.total || 0, color: "#10B981" },
    { name: "Home Tutor Subs", value: purchases?.homeTutorSubscriptions?.total || 0, color: "#F59E0B" },
    { name: "Homework Assistance", value: purchases?.homeWorkPurchases || 0, color: "#EC4899" },
    { name: "Subjective Exam Subs", value: purchases?.subjectiveExamSubscriptions?.total || 0, color: "#3B82F6" },
  ];
  const subsTotal = subsData.reduce((s, r) => s + r.value, 0);

  return (
    <>
      <WelcomeHeader o={o} />

      <div style={S.kpiRow}>
        <KpiCard icon={Wallet} gradient="linear-gradient(135deg,#6366F1,#4338CA)" title="Revenue (All Time)" value={formatMoney(revenue?.totalAllTime)} deltaLabel="vs last month" deltaValue={24.5} spark={revenueSpark} />
        <KpiCard icon={Users} gradient="linear-gradient(135deg,#34D399,#059669)" title="Students" value={formatNum(users?.students?.total)} deltaLabel="vs last month" deltaValue={users?.students?.newInRange} deltaIsCount spark={studentSpark} />
        <KpiCard icon={GraduationCap} gradient="linear-gradient(135deg,#FB923C,#EA580C)" title="Teachers" value={formatNum(users?.teachers?.total)} plainFoot={`${formatNum(users?.teachers?.pendingApproval)} Pending Approval`} spark={studentSpark.map((v) => Math.round(v / 12))} />
        <KpiCard icon={CreditCard} gradient="linear-gradient(135deg,#FB7185,#E11D48)" title="Payments" value={formatNum(payments?.totalInRange)} plainFoot={`${formatNum(payments?.success)} Success \u00b7 ${formatNum(payments?.failed)} Failed`} spark={revenueSpark.map((v) => Math.round(v / 400))} />
      </div>

      <div style={S.chartsGrid} className="p4u-charts-grid">
        <div style={S.card}>
          <div style={S.cardTitleRow}><span style={S.cardTitle}>Revenue Overview</span></div>
          <div style={S.chartHeadline}>
            <span style={S.chartHeadlineValue}>{formatMoney(revenue?.totalInRange)}</span>
            <span style={S.chartHeadlineDelta}><ArrowUpRight size={12} /> 24.5%</span>
          </div>
          <ResponsiveContainer width="100%" height={150}>
            <AreaChart data={a.revenueTrend || []} margin={{ top: 4, right: 4, left: -18, bottom: 0 }}>
              <defs>
                <linearGradient id="ovRevFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#6366F1" stopOpacity={0.35} />
                  <stop offset="95%" stopColor="#6366F1" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#A3A9BD" }} axisLine={false} tickLine={false} interval="preserveStartEnd" />
              <YAxis hide />
              <Tooltip content={<MiniTooltip money />} />
              <Area type="monotone" dataKey="total" stroke="#6366F1" strokeWidth={2.5} fill="url(#ovRevFill)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div style={S.card}>
          <div style={S.cardTitleRow}><span style={S.cardTitle}>Students Growth</span></div>
          <div style={S.chartHeadline}>
            <span style={S.chartHeadlineValue}>{formatNum(users?.students?.total)}</span>
            <span style={S.chartHeadlineDelta}><ArrowUpRight size={12} /> {formatNum(users?.students?.newInRange)}</span>
          </div>
          <ResponsiveContainer width="100%" height={150}>
            <AreaChart data={a.signups?.students || []} margin={{ top: 4, right: 4, left: -18, bottom: 0 }}>
              <defs>
                <linearGradient id="ovStuFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#10B981" stopOpacity={0.35} />
                  <stop offset="95%" stopColor="#10B981" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#A3A9BD" }} axisLine={false} tickLine={false} interval="preserveStartEnd" />
              <YAxis hide />
              <Tooltip content={<MiniTooltip />} />
              <Area type="monotone" dataKey="count" stroke="#10B981" strokeWidth={2.5} fill="url(#ovStuFill)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div style={S.card}>
          <div style={S.cardTitleRow}><span style={S.cardTitle}>Payments Overview</span></div>
          <div style={S.legendRowSm}>
            <span style={S.legendChip}><i style={{ ...S.legendDotSm, background: "#3B82F6" }} />Success</span>
            <span style={S.legendChip}><i style={{ ...S.legendDotSm, background: "#F43F5E" }} />Failed</span>
          </div>
          <ResponsiveContainer width="100%" height={150}>
            <BarChart data={paymentsWeekly} margin={{ top: 8, right: 4, left: -18, bottom: 0 }} barGap={3}>
              <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#A3A9BD" }} axisLine={false} tickLine={false} />
              <YAxis hide />
              <Tooltip content={<MiniTooltip />} />
              <Bar dataKey="success" fill="#3B82F6" radius={[3, 3, 0, 0]} />
              <Bar dataKey="failed" fill="#F43F5E" radius={[3, 3, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div style={S.card}>
          <div style={S.cardTitleRow}><span style={S.cardTitle}>Subscriptions</span></div>
          <div style={{ position: "relative", marginTop: 4 }}>
            <ResponsiveContainer width="100%" height={140}>
              <PieChart>
                <Pie data={subsData} dataKey="value" nameKey="name" innerRadius={44} outerRadius={62} paddingAngle={3} stroke="none">
                  {subsData.map((d, i) => <Cell key={i} fill={d.color} />)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div style={S.donutCenter}>
              <div style={S.donutCenterValue}>{formatNum(subsTotal)}</div>
              <div style={S.donutCenterLabel}>Total</div>
            </div>
          </div>
          <div style={{ marginTop: 6 }}>
            {subsData.map((d, i) => (
              <div key={i} style={S.subsLegendRow}>
                <span style={{ ...S.legendDotSm, background: d.color }} />
                <span style={S.subsLegendName}>{d.name}</span>
                <span style={S.subsLegendValue}>{formatNum(d.value)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={S.bottomGrid} className="p4u-bottom-grid">
        <LatestStudentsCard students={recent?.students || []} />
        <RecentPaymentsCard payments={recent?.payments || []} />
        <QuickActionsCard />
      </div>

      <SectionTitle title="Purchases" eyebrow="Subscriptions across every product line" />
      <div style={S.grid5}>
        <MiniStat label="Assignment subs" value={purchases?.assignmentSubscriptions?.total} delta={purchases?.assignmentSubscriptions?.newInRange} />
        <MiniStat label="Exam notes" value={purchases?.examNotesPurchases?.total} delta={purchases?.examNotesPurchases?.newInRange} />
        <MiniStat label="Home tutor subs" value={purchases?.homeTutorSubscriptions?.total} delta={purchases?.homeTutorSubscriptions?.newInRange} />
        <MiniStat label="Homework purchases" value={purchases?.homeWorkPurchases} />
        <MiniStat label="Subjective exam subs" value={purchases?.subjectiveExamSubscriptions?.total} delta={purchases?.subjectiveExamSubscriptions?.newInRange} />
      </div>

      <SectionTitle title="Services" eyebrow="Requests awaiting action" />
      <div style={S.grid3}>
        <StatCard title="Home tutor" icon={HandHelping} rows={[["Total", services?.homeTutorRequests?.total], ["Pending", services?.homeTutorRequests?.pending]]} />
        <StatCard title="Homework assistance" icon={BookOpen} rows={[["Total", services?.homeWorkAssistance?.total], ["Pending", services?.homeWorkAssistance?.pending]]} />
        <StatCard title="Appointments" icon={CalendarClock} rows={[["Total", services?.appointments?.total], ["Pending", services?.appointments?.pending]]} />
      </div>

      <SectionTitle title="Content moderation" eyebrow="Exam checking pipeline" />
      <div style={S.grid3}>
        <StatCard title="Checked exams" icon={FileText} rows={[["Total", content?.checkedExams?.total], ["Pending", content?.checkedExams?.pending], ["Approved", content?.checkedExams?.approved], ["Rejected", content?.checkedExams?.rejected]]} />
        <StatCard title="Notes & exams" icon={BookOpen} rows={[["Notes", content?.notes], ["Subjective exams", content?.subjectiveExams], ["Submitted exams", content?.submittedExams]]} />
        <StatCard title="Live classes" icon={Video} rows={[["Total", services?.liveClasses?.total], ["Purchases", services?.liveClasses?.purchases], ["New in range", services?.liveClasses?.newInRange]]} />
      </div>

      <SectionTitle title="Masters & CMS" eyebrow="Reference data and content" />
      <div style={S.grid2}>
        <StatCard title="Master data" icon={Landmark} rows={[["States", masters?.states], ["Cities", masters?.cities], ["Boards", masters?.boards], ["Classes", masters?.classes], ["Subjects", masters?.subjects], ["Competitions", masters?.competitions], ["Universities", masters?.universities], ["Courses", masters?.courses], ["Semesters", masters?.semesters], ["College subjects", masters?.collegeSubjects], ["NIOS classes", masters?.niosClasses], ["NIOS subjects", masters?.niosSubjects]]} />
        <StatCard title="CMS" icon={Bell} rows={[["Sliders", cms?.sliders], ["Notifications", cms?.notifications], ["Coupons (total)", cms?.coupons?.total], ["Coupons (active)", cms?.coupons?.active], ["Councils", cms?.councils], ["Jobs (total)", cms?.jobs?.total], ["Jobs (active)", cms?.jobs?.active], ["Scholarships", cms?.scholarships], ["Career categories", cms?.chooseCareer?.categories], ["Blogs", cms?.chooseCareer?.blogs]]} />
      </div>

      <SectionTitle title="Recent activity" eyebrow="Newest entries first" />
      <div style={S.grid2}>
        <RecentTable title="Recent students" columns={["Name", "Mobile", "Email", "Joined"]} rows={(recent?.students || []).map((s) => [s.fullName || "\u2014", s.mobile || "\u2014", s.email || "\u2014", formatDateTime(s.createdAt)])} />
        <RecentTable title="Recent teachers" columns={["Mobile", "Approval", "Verified", "Joined"]} rows={(recent?.teachers || []).map((t) => [t.mobile || "\u2014", t.approvalStatus || "\u2014", String(t.isVerified ?? false), formatDateTime(t.createdAt)])} />
      </div>
      <div style={S.grid2}>
        <RecentTable title="Recent jobs" columns={["Job", "Company", "Status", "Apply till"]} rows={(recent?.jobs || []).map((j) => [j.jobTitle || "\u2014", j.companyName || "\u2014", j.status || "\u2014", formatDate(j.lastDateToApply)])} />
        <RecentTable title="Recent payments" columns={["Purpose", "Gateway", "Amount", "Status", "When"]} rows={(recent?.payments || []).map((p) => [p.purpose || "\u2014", p.gateway || "\u2014", formatMoney(p.amount), p.status || "\u2014", formatDateTime(p.createdAt)])} />
      </div>

      <div style={{ height: 8 }} />
    </>
  );
};

/* =========================================================================
   WELCOME HEADER + KPI + CHART CARDS (new visual language)
   ========================================================================= */

const WelcomeHeader = ({ o }) => {
  const chips = [
    { icon: GraduationCap, label: "New Admissions", value: o.today?.newAdmissions ?? 0, color: "#8B5CF6", soft: "#F1EEFE" },
    { icon: Wallet, label: "Payments Today", value: o.today?.paymentsToday ?? 0, color: "#10B981", soft: "#E4F9F0" },
    { icon: HandHelping, label: "Teacher Requests", value: o.today?.teacherRequests ?? 0, color: "#F59E0B", soft: "#FEF3DC" },
    { icon: Users, label: "New Students", value: o.today?.newStudents ?? 0, color: "#3B82F6", soft: "#E4EDFE" },
  ];
  return (
    <div style={S.welcomeRow}>
      <div>
        <div style={S.welcomeTitle}>Welcome back, Admin! </div>
        <div style={S.welcomeSub}>Here's what's happening with your platform today.</div>
      </div>
      <div style={S.chipRow}>
        {chips.map((c, i) => {
          const Icon = c.icon;
          return (
            <div key={i} style={{ ...S.chip, ...(i === chips.length - 1 ? { borderRight: "none" } : {}) }}>
              <span style={{ ...S.chipIcon, background: c.soft, color: c.color }}><Icon size={15} strokeWidth={2.25} /></span>
              <div>
                <div style={S.chipValue}>{c.value}</div>
                <div style={S.chipLabel}>{c.label}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const KpiCard = ({ icon: Icon, gradient, title, value, deltaLabel, deltaValue, deltaIsCount, plainFoot, spark }) => (
  <div style={{ ...S.kpiCard, background: gradient }}>
    <div style={S.kpiTopRow}>
      <span style={S.kpiIconWrap}><Icon size={17} strokeWidth={2.25} /></span>
    </div>
    <div style={S.kpiTitle}>{title}</div>
    <div style={S.kpiValue}>{value}</div>
    <div style={S.kpiFootRow}>
      {typeof deltaValue === "number" && (
        <span style={S.kpiDeltaPill}><ArrowUpRight size={11} /> {deltaIsCount ? formatNum(deltaValue) : `${deltaValue}%`} {deltaLabel}</span>
      )}
      {plainFoot && <span style={S.kpiPlainFoot}>{plainFoot}</span>}
    </div>
    {spark && spark.length > 1 && (
      <div style={S.kpiSparkWrap}>
        <ResponsiveContainer width="100%" height={40}>
          <AreaChart data={spark.map((v, i) => ({ i, v }))} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id={`spark-${title}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#fff" stopOpacity={0.55} />
                <stop offset="100%" stopColor="#fff" stopOpacity={0} />
              </linearGradient>
            </defs>
            <Area type="monotone" dataKey="v" stroke="#fff" strokeWidth={2} fill={`url(#spark-${title})`} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    )}
  </div>
);

const MiniTooltip = ({ active, payload, label, money }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={S.miniTooltip}>
      <div style={S.miniTooltipLabel}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={S.miniTooltipRow}>
          <span style={{ ...S.legendDotSm, background: p.color || p.fill || p.stroke }} />
          <b>{money ? formatMoney(p.value) : formatNum(p.value)}</b>
        </div>
      ))}
    </div>
  );
};

const Avatar = ({ name, idx }) => (
  <span style={{ ...S.avatar, background: AVATAR_COLORS[idx % AVATAR_COLORS.length] }}>{initials(name)}</span>
);

const StatusPill = ({ value }) => {
  const tone = statusTone(value);
  const tones = { success: { bg: "#E4F9F0", fg: "#10B981" }, danger: { bg: "#FDEAEA", fg: "#F43F5E" }, warning: { bg: "#FEF3DC", fg: "#F59E0B" } };
  const t = tones[tone];
  return <span style={{ ...S.badge, background: t.bg, color: t.fg }}>{value}</span>;
};

const LatestStudentsCard = ({ students }) => (
  <div style={S.card}>
    <div style={S.cardTitleRow}>
      <span style={S.cardTitle}>Latest Students</span>
      <button style={S.viewAllLink}>View All</button>
    </div>
    <div style={S.tableScroll}>
      <table style={S.table}>
        <thead>
          <tr><th style={S.th}>#</th><th style={S.th}>Name</th><th style={S.th}>Course</th><th style={S.th}>Date</th><th style={S.th}>Status</th><th style={S.th}>Fee</th></tr>
        </thead>
        <tbody>
          {students.length === 0 ? (
            <tr><td style={S.tdEmpty} colSpan={6}>No students yet.</td></tr>
          ) : (
            students.map((s, i) => (
              <tr key={i}>
                <td style={S.td}>{String(i + 1).padStart(2, "0")}</td>
                <td style={S.td}><span style={S.nameCell}><Avatar name={s.fullName} idx={i} />{s.fullName || "\u2014"}</span></td>
                <td style={S.td}>{s.course || "\u2014"}</td>
                <td style={S.td}>{formatDate(s.createdAt)}</td>
                <td style={S.td}><StatusPill value={s.status || "Pending"} /></td>
                <td style={S.td}><StatusPill value={s.feeStatus || "Pending"} /></td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);

const RecentPaymentsCard = ({ payments }) => (
  <div style={S.card}>
    <div style={S.cardTitleRow}>
      <span style={S.cardTitle}>Recent Payments</span>
      <button style={S.viewAllLink}>View All</button>
    </div>
    <div style={S.tableScroll}>
      <table style={S.table}>
        <thead>
          <tr><th style={S.th}>#</th><th style={S.th}>Student</th><th style={S.th}>Amount</th><th style={S.th}>Method</th><th style={S.th}>Status</th><th style={S.th}>Date</th></tr>
        </thead>
        <tbody>
          {payments.length === 0 ? (
            <tr><td style={S.tdEmpty} colSpan={6}>No payments yet.</td></tr>
          ) : (
            payments.map((p, i) => (
              <tr key={i}>
                <td style={S.td}>{String(i + 1).padStart(2, "0")}</td>
                <td style={S.td}><span style={S.nameCell}><Avatar name={p.studentName} idx={i + 2} />{p.studentName || "\u2014"}</span></td>
                <td style={{ ...S.td, ...S.mono }}>{formatMoney(p.amount)}</td>
                <td style={S.td}>{p.gateway || "\u2014"}</td>
                <td style={S.td}><StatusPill value={p.status || "Pending"} /></td>
                <td style={S.td}>{formatDate(p.createdAt)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);

const QUICK_ACTIONS = [
  { label: "Add Student", icon: UserPlus, gradient: "linear-gradient(135deg,#8B5CF6,#6D28D9)" },
  { label: "Add Teacher", icon: GraduationCap, gradient: "linear-gradient(135deg,#34D399,#059669)" },
  { label: "Start Live Class", icon: Video, gradient: "linear-gradient(135deg,#FB923C,#EA580C)" },
  { label: "Upload Notes", icon: UploadCloud, gradient: "linear-gradient(135deg,#60A5FA,#2563EB)" },
  { label: "Create Coupon", icon: Percent, gradient: "linear-gradient(135deg,#F472B6,#DB2777)" },
  { label: "View Reports", icon: BarChart3, gradient: "linear-gradient(135deg,#818CF8,#4F46E5)" },
];

const QuickActionsCard = () => (
  <div style={S.card}>
    <div style={S.cardTitleRow}><span style={S.cardTitle}>Quick Actions</span></div>
    <div style={S.actionsGrid}>
      {QUICK_ACTIONS.map((a, i) => {
        const Icon = a.icon;
        return (
          <button key={i} style={{ ...S.actionBtn, background: a.gradient }}>
            <Icon size={18} strokeWidth={2} />
            <span>{a.label}</span>
          </button>
        );
      })}
    </div>
  </div>
);

/* =========================================================================
   ANALYTICS TAB
   ========================================================================= */

const AnalyticsTab = ({ analytics, loading, err, onRetry }) => {
  if (loading) return <PageLoader label="Crunching analytics\u2026" />;
  if (err) return <ErrorState err={err} onRetry={onRetry} />;
  const a = analytics || DEMO_ANALYTICS_DAY;

  const signupData = mergeTrends({ students: a.signups?.students, teachers: a.signups?.teachers });
  const purchaseData = mergeTrends(a.purchaseTrends || {});

  return (
    <>
      <SectionTitle title="Revenue" eyebrow="Successful payments over time" />
      <div style={S.chartCard}>
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={a.revenueTrend || []} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="revFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#6366F1" stopOpacity={0.28} />
                <stop offset="95%" stopColor="#6366F1" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 4" stroke="#EEF0F8" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#8A93A8" }} axisLine={{ stroke: "#EEF0F8" }} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "#8A93A8" }} axisLine={false} tickLine={false} tickFormatter={(v) => formatMoney(v)} width={70} />
            <Tooltip content={<ChartTooltip moneyKeys={["total"]} />} />
            <Area type="monotone" dataKey="total" stroke="#6366F1" strokeWidth={2.75} fill="url(#revFill)" name="Revenue" />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div style={S.grid2}>
        <DonutCard title="Revenue by purpose" data={a.revenueByPurpose} valueKey="total" nameKey="_id" money />
        <DonutCard title="Revenue by gateway" data={a.revenueByGateway} valueKey="total" nameKey="_id" money />
      </div>

      <SectionTitle title="Growth" eyebrow="Signups over time" />
      <div style={S.chartCard}>
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={signupData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 4" stroke="#EEF0F8" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#8A93A8" }} axisLine={{ stroke: "#EEF0F8" }} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "#8A93A8" }} axisLine={false} tickLine={false} width={40} />
            <Tooltip content={<ChartTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="students" stroke="#3B82F6" strokeWidth={2.75} dot={false} name="Students" />
            <Line type="monotone" dataKey="teachers" stroke="#10B981" strokeWidth={2.75} dot={false} name="Teachers" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <SectionTitle title="Purchases" eyebrow="Volume by product line, over time" />
      <div style={S.chartCard}>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={purchaseData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 4" stroke="#EEF0F8" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#8A93A8" }} axisLine={{ stroke: "#EEF0F8" }} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "#8A93A8" }} axisLine={false} tickLine={false} width={40} />
            <Tooltip content={<ChartTooltip />} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line type="monotone" dataKey="assignmentSubscriptions" stroke="#6366F1" strokeWidth={2} dot={false} name="Assignment subs" />
            <Line type="monotone" dataKey="examNotesPurchases" stroke="#10B981" strokeWidth={2} dot={false} name="Exam notes" />
            <Line type="monotone" dataKey="subjectiveExamPurchases" stroke="#F59E0B" strokeWidth={2} dot={false} name="Subjective exams" />
            <Line type="monotone" dataKey="liveClassPurchases" stroke="#8B5CF6" strokeWidth={2} dot={false} name="Live classes" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <SectionTitle title="Payment health" eyebrow="Status breakdown across the range" />
      <div style={S.grid2}>
        <DonutCard title="Payment status" data={a.paymentStatusBreakdown} valueKey="count" nameKey="_id" />
        <div style={S.card}>
          <div style={S.cardTitleRow}><AlertTriangle size={15} color="#8A93A8" /><span style={S.cardTitle}>Reading this data</span></div>
          <p style={S.helpText}>
            Revenue only counts payments with status <b>SUCCESS</b>. Failed and pending attempts show up in the status
            breakdown but are excluded from revenue totals. Switch the range or granularity from the header \u2014 every
            chart on this tab reacts to it.
          </p>
        </div>
      </div>
    </>
  );
};

/* =========================================================================
   STUDENTS TAB
   ========================================================================= */

const StudentsTab = ({ from, to }) => {
  const [q, setQ] = useState("");
  const [students, setStudents] = useState(DEMO_STUDENTS);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [selected, setSelected] = useState(null);
  const debounceRef = useRef(null);

  const runSearch = useCallback(async (query) => {
    if (!API_BASE) {
      const ql = (query || "").toLowerCase();
      setStudents(ql ? DEMO_STUDENTS.filter((s) => (s.fullName || "").toLowerCase().includes(ql)) : DEMO_STUDENTS);
      return;
    }
    setLoading(true);
    setErr("");
    try {
      const json = await apiGet(`/admin/students/search?q=${encodeURIComponent(query || "")}&limit=25`);
      setStudents(json.data.students || []);
    } catch (e) {
      setErr(e.message || "Search failed");
      setStudents(DEMO_STUDENTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    runSearch("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeQuery = (val) => {
    setQ(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => runSearch(val), 350);
  };

  return (
    <>
      <SectionTitle title="Find a student" eyebrow="Search by name, email or mobile" />

      <div style={S.searchBar}>
        <Search size={16} color="#8A93A8" />
        <input value={q} onChange={(e) => onChangeQuery(e.target.value)} placeholder="Search students\u2026" style={S.searchInput} />
        {loading && <Loader2 size={16} color="#8A93A8" style={{ animation: "p4u-spin 0.9s linear infinite" }} />}
      </div>

      {err && <div style={S.inlineError}>{err}</div>}

      <div style={S.card}>
        <div style={S.tableScroll}>
          <table style={S.table}>
            <thead>
              <tr><th style={S.th}>Name</th><th style={S.th}>Mobile</th><th style={S.th}>Email</th><th style={S.th}>Verified</th><th style={S.th}>Joined</th><th style={S.th}></th></tr>
            </thead>
            <tbody>
              {students.length === 0 ? (
                <tr><td style={S.tdEmpty} colSpan={6}>No students found.</td></tr>
              ) : (
                students.map((s, i) => (
                  <tr key={s._id || i} className="p4u-row" onClick={() => setSelected(s)} style={S.rowClickable}>
                    <td style={S.td}><span style={S.nameCell}><Avatar name={s.fullName} idx={i} />{s.fullName || "\u2014"}</span></td>
                    <td style={{ ...S.td, ...S.mono }}>{s.mobile || "\u2014"}</td>
                    <td style={S.td}>{s.email || "\u2014"}</td>
                    <td style={S.td}><StatusPill value={s.isVerified ? "Verified" : "Pending"} /></td>
                    <td style={{ ...S.td, ...S.mono }}>{formatDate(s.createdAt)}</td>
                    <td style={{ ...S.td, textAlign: "right" }}><ChevronRight size={16} color="#B4BDD1" /></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {selected && <StudentDrawer student={selected} from={from} to={to} onClose={() => setSelected(null)} />}
    </>
  );
};

const DETAIL_TABS = [
  { key: "overview", label: "Overview" },
  { key: "purchases", label: "Purchases", countKey: "purchases" },
  { key: "requests", label: "Requests", countKey: "serviceRequests" },
  { key: "payments", label: "Payments", countKey: "payments" },
  { key: "timeline", label: "Timeline", countKey: "timeline" },
];

const DEMO_DETAIL = {
  profile: { fullName: "Rahul Kumar", mobile: "98765 43210", email: "rahul@mail.com" },
  joinedOn: "2026-06-01",
  counts: { purchases: 3, serviceRequests: 2, payments: 3, timeline: 5 },
  purchasesFlat: [
    { id: 1, category: "Assignment subscription", title: "Class 10 Maths pack", amount: 1500, status: "Active", date: "2026-07-10" },
    { id: 2, category: "Exam notes", title: "Physics unit notes", amount: 800, status: "Active", date: "2026-07-05" },
  ],
  serviceRequestsFlat: [{ id: 1, category: "Home tutor", title: "Weekend chemistry tutor", status: "Pending", date: "2026-07-12" }],
  payments: [
    { _id: 1, purpose: "Assignment subscription", gateway: "UPI", amount: 1500, status: "Success", createdAt: "2026-07-10" },
    { _id: 2, purpose: "Exam notes", gateway: "Card", amount: 800, status: "Success", createdAt: "2026-07-05" },
  ],
  timeline: [
    { type: "assignment_subscription", status: "Success", date: "2026-07-10" },
    { type: "exam_notes_purchase", status: "Success", date: "2026-07-05" },
    { type: "home_tutor_request", status: "Pending", date: "2026-07-12" },
  ],
};

const StudentDrawer = ({ student, from, to, onClose }) => {
  const [detail, setDetail] = useState(DEMO_DETAIL);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState("overview");

  useEffect(() => {
    let cancelled = false;
    if (!API_BASE || !student?._id) {
      setDetail({ ...DEMO_DETAIL, profile: { fullName: student?.fullName, mobile: student?.mobile, email: student?.email } });
      return;
    }
    setLoading(true);
    setErr("");
    apiGet(`/admin/students/${student._id}/detail?from=${from || ""}&to=${to || ""}`)
      .then((json) => !cancelled && setDetail(json.data))
      .catch((e) => !cancelled && setErr(e.message || "Failed to load student"))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [student, from, to]);

  const counts = detail?.counts || {};

  return createPortal(
    <div style={S.overlay} onClick={onClose}>
      <div style={S.panel} onClick={(e) => e.stopPropagation()}>
        <div style={S.panelHead}>
          <span style={S.eyebrow}>Student profile</span>
          <button onClick={onClose} style={S.iconBtn} className="p4u-icon-btn"><X size={16} /></button>
        </div>

        <div style={S.panelBody}>
          {loading && <PageLoader label="Loading student\u2026" compact />}
          {!loading && err && <ErrorState err={err} onRetry={() => { }} compact />}

          {!loading && !err && detail && (
            <>
              <div style={S.hero}>
                <div style={S.avatarLg}>{(detail.profile?.fullName || "?").slice(0, 1).toUpperCase()}</div>
                <div style={S.heroText}>
                  <div style={S.name}>{detail.profile?.fullName || "Unnamed student"}</div>
                  <div style={S.metaLine}>{detail.profile?.mobile || "\u2014"} \u00b7 {detail.profile?.email || "\u2014"}</div>
                  <div style={S.metaLine}>Joined {formatDate(detail.joinedOn)}</div>
                </div>
              </div>

              <div style={S.tabBar}>
                {DETAIL_TABS.map((t) => (
                  <button key={t.key} onClick={() => setTab(t.key)} style={{ ...S.tabBtn, ...(tab === t.key ? S.tabBtnActive : {}) }}>
                    {t.label}
                    {t.countKey && counts[t.countKey] != null && <span style={S.tabCount}>{counts[t.countKey]}</span>}
                  </button>
                ))}
              </div>

              <div>
                {tab === "overview" && (
                  <div style={S.overviewGrid}>
                    <SummaryStat label="Purchases" value={counts.purchases ?? 0} />
                    <SummaryStat label="Service requests" value={counts.serviceRequests ?? 0} />
                    <SummaryStat label="Payments" value={counts.payments ?? 0} />
                  </div>
                )}

                {tab === "purchases" && <CategoryTable rows={detail.purchasesFlat || []} emptyText="No purchases in this range." showAmount />}
                {tab === "requests" && <CategoryTable rows={detail.serviceRequestsFlat || []} emptyText="No service requests in this range." />}

                {tab === "payments" && (
                  <div style={S.tableScroll}>
                    <table style={S.table}>
                      <thead><tr><th style={S.th}>Purpose</th><th style={S.th}>Gateway</th><th style={S.th}>Amount</th><th style={S.th}>Status</th><th style={S.th}>Date</th></tr></thead>
                      <tbody>
                        {(detail.payments || []).length === 0 ? (
                          <tr><td style={S.tdEmpty} colSpan={5}>No payments in this range.</td></tr>
                        ) : (
                          detail.payments.map((p) => (
                            <tr key={p._id}>
                              <td style={S.td}>{p.purpose}</td>
                              <td style={S.td}>{p.gateway}</td>
                              <td style={{ ...S.td, ...S.mono }}>{formatMoney(p.amount)}</td>
                              <td style={S.td}><StatusPill value={p.status} /></td>
                              <td style={{ ...S.td, ...S.mono }}>{formatDateTime(p.createdAt)}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                {tab === "timeline" && (
                  <div style={S.timelineWrap}>
                    <div style={S.timelineRail} />
                    {(detail.timeline || []).length === 0 && <div style={S.helpText}>No activity in this range.</div>}
                    {(detail.timeline || []).map((entry, i) => {
                      const meta = TIMELINE_META[entry.type] || { label: entry.type, color: "#8A93A8", icon: Clock };
                      const Icon = meta.icon;
                      return (
                        <div key={i} style={S.timelineItem}>
                          <span style={{ ...S.timelineNode, background: meta.color }} />
                          <div style={S.timelineCard}>
                            <div style={S.timelineTop}>
                              <span style={S.timelineLabel}><Icon size={13} color={meta.color} /> {meta.label}</span>
                              <span style={S.timelineDate}>{formatDateTime(entry.date)}</span>
                            </div>
                            {entry.status && <StatusPill value={entry.status} />}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

const SummaryStat = ({ label, value }) => (
  <div style={S.statCard}><div style={S.statValue}>{value}</div><div style={S.statLabel}>{label}</div></div>
);

const CategoryTable = ({ rows, emptyText, showAmount = false }) => (
  <div style={S.tableScroll}>
    <table style={S.table}>
      <thead><tr><th style={S.th}>Category</th><th style={S.th}>Detail</th>{showAmount && <th style={S.th}>Amount</th>}<th style={S.th}>Status</th><th style={S.th}>Date</th></tr></thead>
      <tbody>
        {rows.length === 0 ? (
          <tr><td style={S.tdEmpty} colSpan={showAmount ? 5 : 4}>{emptyText}</td></tr>
        ) : (
          rows.map((r) => (
            <tr key={r.id}>
              <td style={S.td}>{r.category}</td>
              <td style={S.td}>{r.title}</td>
              {showAmount && <td style={{ ...S.td, ...S.mono }}>{formatMoney(r.amount)}</td>}
              <td style={S.td}>{r.status ? <StatusPill value={r.status} /> : "\u2014"}</td>
              <td style={{ ...S.td, ...S.mono }}>{formatDateTime(r.date)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

/* =========================================================================
   REPORTS TAB
   ========================================================================= */

const DEMO_REPORT_ROWS = {
  students: DEMO_STUDENTS.map(({ fullName, mobile, email, createdAt }) => ({ Name: fullName, Mobile: mobile, Email: email, Joined: formatDate(createdAt) })),
};

// const ReportsTab = () => {
//   const [reportType, setReportType] = useState(null);
//   const [reportData, setReportData] = useState([]);
//   const [show, setShow] = useState(false);
//   const [full, setFull] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [err, setErr] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [singleDate, setSingleDate] = useState("");
//   const [filterMode, setFilterMode] = useState("range");

//   const buildParams = () => {
//     const params = new URLSearchParams();
//     if (filterMode === "single" && singleDate) params.append("date", singleDate);
//     if (filterMode === "range") {
//       if (fromDate) params.append("from", fromDate);
//       if (toDate) params.append("to", toDate);
//     }
//     return params;
//   };

//   const openReport = async (type) => {
//     if (!API_BASE) {
//       setReportType(type);
//       setReportData(DEMO_REPORT_ROWS[type] || [{ Note: "No demo rows for this report \u2014 connect your API to see real data." }]);
//       setShow(true);
//       return;
//     }
//     setLoading(true);
//     setErr("");
//     try {
//       let url = `/admin/report/${type}`;
//       const params = buildParams();
//       if (params.toString()) url += `?${params.toString()}`;
//       const json = await apiGet(url);
//       setReportType(type);
//       setReportData(json.data || []);
//       setShow(true);
//     } catch (e) {
//       setErr(e.message || "Failed to load report");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const applyFilters = () => { if (reportType) openReport(reportType); };
//   const clearFilters = () => {
//     setFromDate(""); setToDate(""); setSingleDate("");
//     if (reportType) setTimeout(() => openReport(reportType), 0);
//   };
//   const hasActiveFilter = (filterMode === "single" && singleDate) || (filterMode === "range" && (fromDate || toDate));

//   return (
//     <>
//       <SectionTitle title="Export reports" eyebrow="Pull a full table and download it as CSV" />

//       <div style={S.filterBar}>
//         <div style={S.segmented}>
//           <button type="button" onClick={() => setFilterMode("range")} style={{ ...S.segmentedBtn, ...(filterMode === "range" ? S.segmentedBtnActive : {}) }}>Range</button>
//           <button type="button" onClick={() => setFilterMode("single")} style={{ ...S.segmentedBtn, ...(filterMode === "single" ? S.segmentedBtnActive : {}) }}>Single date</button>
//         </div>

//         {filterMode === "range" ? (
//           <div style={S.dateGroup}>
//             <label style={S.dateField}><span style={S.dateLabelSm}>From</span><input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={S.dateInputBox} /></label>
//             <span style={S.dateSep}>\u2013</span>
//             <label style={S.dateField}><span style={S.dateLabelSm}>To</span><input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={S.dateInputBox} /></label>
//           </div>
//         ) : (
//           <div style={S.dateGroup}>
//             <label style={S.dateField}><span style={S.dateLabelSm}>Date</span><input type="date" value={singleDate} onChange={(e) => setSingleDate(e.target.value)} style={S.dateInputBox} /></label>
//           </div>
//         )}

//         <div style={S.filterActions}>
//           {hasActiveFilter && <button type="button" onClick={clearFilters} style={S.ghostBtn}>Clear</button>}
//           <button type="button" onClick={applyFilters} disabled={!reportType || loading} style={{ ...S.applyBtn, opacity: !reportType || loading ? 0.4 : 1, cursor: !reportType || loading ? "not-allowed" : "pointer" }}>Apply</button>
//         </div>
//       </div>

//       <div style={S.grid4}>
//         {REPORT_TYPES.map(({ key, label, icon: Icon }) => (
//           <button key={key} onClick={() => openReport(key)} style={{ ...S.reportTile, ...(reportType === key && show ? S.reportTileActive : {}) }}>
//             <span style={S.reportTileIcon}><Icon size={18} color="#6366F1" strokeWidth={1.75} /></span>
//             <span>{label}</span>
//           </button>
//         ))}
//       </div>

//       {loading && <PageLoader label="Fetching report\u2026" />}
//       {err && <div style={S.inlineError}>{err}</div>}

//       {show && createPortal(
//         <div style={S.overlay} onClick={() => setShow(false)}>
//           <div style={{ ...S.modal, width: full ? "94vw" : "min(800px, 94vw)", height: full ? "88vh" : "auto" }} onClick={(e) => e.stopPropagation()}>
//             <div style={S.modalHead}>
//               <div>
//                 <h3 style={S.modalTitle}>{reportType} report</h3>
//                 <span style={S.modalCount}>{reportData.length} record{reportData.length === 1 ? "" : "s"}</span>
//               </div>
//               <div style={{ display: "flex", gap: 6 }}>
//                 <button onClick={() => setFull((f) => !f)} style={S.iconBtn} className="p4u-icon-btn">{full ? <Minimize2 size={15} /> : <Maximize2 size={15} />}</button>
//                 <button onClick={() => setShow(false)} style={S.iconBtn} className="p4u-icon-btn"><X size={15} /></button>
//               </div>
//             </div>

//             <div style={{ maxHeight: full ? "70vh" : 420, overflow: "auto", borderTop: "1px solid #EEF0F8" }}>
//               {reportData.length === 0 ? (
//                 <div style={S.emptyState}>No records match the current filters.</div>
//               ) : (
//                 <div style={S.tableScroll}>
//                   <table style={S.table}>
//                     <thead><tr>{Object.keys(reportData[0]).map((col) => <th key={col} style={S.th}>{col}</th>)}</tr></thead>
//                     <tbody>
//                       {reportData.map((row, i) => (
//                         <tr key={i}>{Object.values(row).map((val, j) => <td key={j} style={S.td}>{String(val)}</td>)}</tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>

//             <div style={S.modalFooter}>
//               <span style={S.modalFooterHint}>{hasActiveFilter ? "Filtered results" : "Showing all records"}</span>
//               <button onClick={() => downloadCSV(reportData, reportType)} disabled={reportData.length === 0} style={{ ...S.downloadBtn, opacity: reportData.length === 0 ? 0.4 : 1, cursor: reportData.length === 0 ? "not-allowed" : "pointer" }}>
//                 <Download size={14} /> Download CSV
//               </button>
//             </div>
//           </div>
//         </div>,
//         document.body
//       )}
//     </>
//   );
// };

const TILE_COLORS = [
  { bg: "rgba(99, 102, 241, 0.10)",  border: "#6366F1", icon: "#6366F1" }, // indigo
  { bg: "rgba(236, 72, 153, 0.10)",  border: "#EC4899", icon: "#EC4899" }, // pink
  { bg: "rgba(16, 185, 129, 0.10)",  border: "#10B981", icon: "#10B981" }, // emerald
  { bg: "rgba(245, 158, 11, 0.10)",  border: "#F59E0B", icon: "#B45309" }, // amber
  { bg: "rgba(59, 130, 246, 0.10)",  border: "#3B82F6", icon: "#3B82F6" }, // blue
  { bg: "rgba(139, 92, 246, 0.10)",  border: "#8B5CF6", icon: "#8B5CF6" }, // violet
  { bg: "rgba(239, 68, 68, 0.10)",   border: "#EF4444", icon: "#EF4444" }, // red
  { bg: "rgba(20, 184, 166, 0.10)",  border: "#14B8A6", icon: "#0F766E" }, // teal
];

const ReportsTab = () => {
  const [reportType, setReportType] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [show, setShow] = useState(false);
  const [full, setFull] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [singleDate, setSingleDate] = useState("");
  const [filterMode, setFilterMode] = useState("range");

  const buildParams = () => {
    const params = new URLSearchParams();
    if (filterMode === "single" && singleDate) params.append("date", singleDate);
    if (filterMode === "range") {
      if (fromDate) params.append("from", fromDate);
      if (toDate) params.append("to", toDate);
    }
    return params;
  };

  const openReport = async (type) => {
    if (!API_BASE) {
      setReportType(type);
      setReportData(DEMO_REPORT_ROWS[type] || [{ Note: "No demo rows for this report — connect your API to see real data." }]);
      setShow(true);
      return;
    }
    setLoading(true);
    setErr("");
    try {
      let url = `/admin/report/${type}`;
      const params = buildParams();
      if (params.toString()) url += `?${params.toString()}`;
      const json = await apiGet(url);
      setReportType(type);
      setReportData(json.data || []);
      setShow(true);
    } catch (e) {
      setErr(e.message || "Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => { if (reportType) openReport(reportType); };
  const clearFilters = () => {
    setFromDate(""); setToDate(""); setSingleDate("");
    if (reportType) setTimeout(() => openReport(reportType), 0);
  };
  const hasActiveFilter = (filterMode === "single" && singleDate) || (filterMode === "range" && (fromDate || toDate));

  return (
    <>
      <SectionTitle title="Export reports" eyebrow="Pull a full table and download it as CSV" />

      <div style={S.filterBar}>
        <div style={S.segmented}>
          <button type="button" onClick={() => setFilterMode("range")} style={{ ...S.segmentedBtn, ...(filterMode === "range" ? S.segmentedBtnActive : {}) }}>Range</button>
          <button type="button" onClick={() => setFilterMode("single")} style={{ ...S.segmentedBtn, ...(filterMode === "single" ? S.segmentedBtnActive : {}) }}>Single date</button>
        </div>

        {filterMode === "range" ? (
          <div style={S.dateGroup}>
            <label style={S.dateField}><span style={S.dateLabelSm}>From</span><input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={S.dateInputBox} /></label>
            <span style={S.dateSep}>–</span>
            <label style={S.dateField}><span style={S.dateLabelSm}>To</span><input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={S.dateInputBox} /></label>
          </div>
        ) : (
          <div style={S.dateGroup}>
            <label style={S.dateField}><span style={S.dateLabelSm}>Date</span><input type="date" value={singleDate} onChange={(e) => setSingleDate(e.target.value)} style={S.dateInputBox} /></label>
          </div>
        )}

        <div style={S.filterActions}>
          {hasActiveFilter && <button type="button" onClick={clearFilters} style={S.ghostBtn}>Clear</button>}
          <button type="button" onClick={applyFilters} disabled={!reportType || loading} style={{ ...S.applyBtn, opacity: !reportType || loading ? 0.4 : 1, cursor: !reportType || loading ? "not-allowed" : "pointer" }}>Apply</button>
        </div>
      </div>

      <div style={S.grid4}>
        {REPORT_TYPES.map(({ key, label, icon: Icon }, i) => {
          const c = TILE_COLORS[i % TILE_COLORS.length];
          const active = reportType === key && show;
          return (
            <button
              key={key}
              onClick={() => openReport(key)}
              style={{
                ...S.reportTile,
                backgroundColor: c.bg,
                border: `1.5px solid ${active ? c.border : "transparent"}`,
                borderLeft: `4px solid ${c.border}`,
                boxShadow: active ? `0 4px 14px ${c.bg}` : S.reportTile?.boxShadow,
                transition: "transform 0.15s ease, box-shadow 0.15s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <span style={{ ...S.reportTileIcon, backgroundColor: `${c.icon}22` }}>
                <Icon size={18} color={c.icon} strokeWidth={1.75} />
              </span>
              <span style={{ color: c.icon, fontWeight: 600 }}>{label}</span>
            </button>
          );
        })}
      </div>

      {loading && <PageLoader label="Fetching report…" />}
      {err && <div style={S.inlineError}>{err}</div>}

      {show && createPortal(
        <div style={S.overlay} onClick={() => setShow(false)}>
          <div style={{ ...S.modal, width: full ? "94vw" : "min(800px, 94vw)", height: full ? "88vh" : "auto" }} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHead}>
              <div>
                <h3 style={S.modalTitle}>{reportType} report</h3>
                <span style={S.modalCount}>{reportData.length} record{reportData.length === 1 ? "" : "s"}</span>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button onClick={() => setFull((f) => !f)} style={S.iconBtn} className="p4u-icon-btn">{full ? <Minimize2 size={15} /> : <Maximize2 size={15} />}</button>
                <button onClick={() => setShow(false)} style={S.iconBtn} className="p4u-icon-btn"><X size={15} /></button>
              </div>
            </div>

            <div style={{ maxHeight: full ? "70vh" : 420, overflow: "auto", borderTop: "1px solid #EEF0F8" }}>
              {reportData.length === 0 ? (
                <div style={S.emptyState}>No records match the current filters.</div>
              ) : (
                <div style={S.tableScroll}>
                  <table style={S.table}>
                    <thead><tr>{Object.keys(reportData[0]).map((col) => <th key={col} style={S.th}>{col}</th>)}</tr></thead>
                    <tbody>
                      {reportData.map((row, i) => (
                        <tr key={i}>{Object.values(row).map((val, j) => <td key={j} style={S.td}>{String(val)}</td>)}</tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div style={S.modalFooter}>
              <span style={S.modalFooterHint}>{hasActiveFilter ? "Filtered results" : "Showing all records"}</span>
              <button onClick={() => downloadCSV(reportData, reportType)} disabled={reportData.length === 0} style={{ ...S.downloadBtn, opacity: reportData.length === 0 ? 0.4 : 1, cursor: reportData.length === 0 ? "not-allowed" : "pointer" }}>
                <Download size={14} /> Download CSV
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

/* =========================================================================
   SHARED UI PIECES
   ========================================================================= */

const SectionTitle = ({ title, eyebrow }) => (
  <div style={S.sectionTitleWrap}>
    <div>
      <div style={S.sectionEyebrow}>{eyebrow}</div>
      <div style={S.sectionTitle}>{title}</div>
    </div>
  </div>
);

const MiniStat = ({ label, value, delta }) => (
  <div style={S.miniStat}>
    <div style={S.miniStatLabel}>{label}</div>
    <div style={S.miniStatValue}>{formatNum(value)}</div>
    {typeof delta === "number" && (
      <div style={{ ...S.miniStatDelta, color: delta >= 0 ? "#10B981" : "#F43F5E" }}>
        {delta >= 0 ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
        {formatNum(Math.abs(delta))} in range
      </div>
    )}
  </div>
);

const StatCard = ({ title, icon: Icon, rows }) => (
  <div style={S.card}>
    <div style={S.cardTitleRow}>
      {Icon && <span style={S.cardIconBadge}><Icon size={15} color="#6366F1" /></span>}
      <span style={S.cardTitle}>{title}</span>
    </div>
    <div style={{ marginTop: 10, display: "grid", gap: 2 }}>
      {rows.map(([k, v], idx) => (
        <div key={idx} style={S.statRow}>
          <div style={S.statRowKey}>{k}</div>
          <div style={S.statRowVal}>{formatNum(v)}</div>
        </div>
      ))}
    </div>
  </div>
);

const RecentTable = ({ title, columns, rows }) => (
  <div style={S.card}>
    <div style={S.cardTitle}>{title}</div>
    <div style={{ ...S.tableScroll, marginTop: 10 }}>
      <table style={S.table}>
        <thead><tr>{columns.map((c) => <th key={c} style={S.th}>{c}</th>)}</tr></thead>
        <tbody>
          {rows.length === 0 ? (
            <tr><td style={S.tdEmpty} colSpan={columns.length}>No data</td></tr>
          ) : (
            rows.map((r, i) => <tr key={i}>{r.map((cell, j) => <td key={j} style={S.td}>{cell}</td>)}</tr>)
          )}
        </tbody>
      </table>
    </div>
  </div>
);

const DonutCard = ({ title, data, valueKey, nameKey, money }) => {
  const clean = (data || []).map((d) => ({ name: d[nameKey] || "Unknown", value: d[valueKey] || 0 }));
  return (
    <div style={S.card}>
      <div style={S.cardTitle}>{title}</div>
      {clean.length === 0 ? (
        <div style={S.helpText}>No data for this range.</div>
      ) : (
        <ResponsiveContainer width="100%" height={260}>
          <PieChart>
            <Pie data={clean} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={3}>
              {clean.map((_, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} stroke="none" />)}
            </Pie>
            <Tooltip formatter={(v) => (money ? formatMoney(v) : formatNum(v))} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const ChartTooltip = ({ active, payload, label, moneyKeys = [] }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={S.tooltip}>
      <div style={S.tooltipLabel}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={S.tooltipRow}>
          <span style={{ ...S.tooltipDot, background: p.color || p.stroke }} />
          <span>{p.name}:</span>
          <b>{moneyKeys.includes(p.dataKey) ? formatMoney(p.value) : formatNum(p.value)}</b>
        </div>
      ))}
    </div>
  );
};

const PageLoader = ({ label, compact }) => (
  <div style={compact ? S.centerCompact : S.center}>
    <div style={S.loaderBox}>
      <Loader2 size={20} color="#6366F1" style={{ animation: "p4u-spin 0.9s linear infinite" }} />
      <div style={S.loaderText}>{label || "Loading\u2026"}</div>
    </div>
  </div>
);

const ErrorState = ({ err, onRetry, compact }) => (
  <div style={compact ? S.centerCompact : S.center}>
    <div style={S.errorBox}>
      <AlertTriangle size={22} color="#F43F5E" />
      <div style={S.errorTitle}>Something went wrong</div>
      <div style={S.errorMsg}>{err}</div>
      <button onClick={onRetry} style={S.retryBtn}>Try again</button>
    </div>
  </div>
);

/* =========================================================================
   FONT + GLOBAL STYLE INJECTION
   ========================================================================= */

const useInjectFonts = () => {
  useEffect(() => {
    if (document.getElementById("p4u-admin-fonts")) return;
    const link = document.createElement("link");
    link.id = "p4u-admin-fonts";
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Inter:wght@400;500;600;700&display=swap";
    document.head.appendChild(link);

    const style = document.createElement("style");
    style.id = "p4u-admin-style-tag";
    style.innerHTML = `
      @keyframes p4u-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      .p4u-row:hover { background: #F7F7FD; cursor: pointer; }
      .p4u-icon-btn:hover { background: #EEF0FE !important; border-color: #D9DCFB !important; color: #6366F1 !important; }
      input[type="date"]::-webkit-calendar-picker-indicator { opacity: 0.55; cursor: pointer; }
      ::-webkit-scrollbar { width: 8px; height: 8px; }
      ::-webkit-scrollbar-thumb { background: #DEE1F5; border-radius: 8px; }

      @media (max-width: 980px) {
        .p4u-header-top { flex-direction: column !important; align-items: stretch !important; }
        .p4u-charts-grid { grid-template-columns: 1fr 1fr !important; }
        .p4u-bottom-grid { grid-template-columns: 1fr !important; }
      }
      @media (max-width: 640px) {
        .p4u-charts-grid { grid-template-columns: 1fr !important; }
      }
    `;
    document.head.appendChild(style);
  }, []);
};

/* =========================================================================
   STYLES
   ========================================================================= */

const INK = "#151A30";
const MUTED = "#8A93A8";
const BORDER = "#EEF0F8";
const ACCENT = "#6366F1";
const ACCENT_SOFT = "#EEF0FE";
const CARD_SHADOW = "0 1px 2px rgba(23,26,53,0.04), 0 10px 24px -14px rgba(23,26,53,0.14)";

const S = {
  shell: { minHeight: "100vh", background: "#F3F4FB", fontFamily: "'Inter', sans-serif", color: INK },
  header: { position: "sticky", top: 0, zIndex: 30, background: "#FFFFFF", borderBottom: `1px solid ${BORDER}`, padding: "12px clamp(12px,4vw,28px)" },
  headerTop: { display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 },
  headerControls: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },

  // navRow: { display: "flex", gap: 6, overflowX: "auto", scrollbarWidth: "none", msOverflowStyle: "none" },
  // navPill: { flexShrink: 0, display: "flex", alignItems: "center", gap: 7, border: "1px solid transparent", background: "transparent", color: MUTED, padding: "8px 14px", borderRadius: 999, fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", transition: "all 150ms ease" },
  // navPillActive: { background: ACCENT_SOFT, borderColor: "#D9DCFB", color: ACCENT },

  navRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px',
    backgroundColor: '#F9FAFB',
    borderRadius: '14px',
    border: '1px solid #E5E7EB',
    width: 'fit-content',
  },

  navPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 14px 6px 8px',
    borderRadius: '10px',
    border: '1.5px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    outline: 'none',
    userSelect: 'none',
  },

  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '7px',
    transition: 'all 0.25s ease',
  },

  navPillActive: {
    boxShadow: '0 2px 8px -2px rgba(0, 0, 0, 0.05)',
  },

  dateRangePill: { display: "flex", alignItems: "center", gap: 8, background: "#FAFAFE", border: `1px solid ${BORDER}`, borderRadius: 999, padding: "7px 14px" },
  dateInput: { border: "none", background: "transparent", fontSize: 12.5, color: INK, outline: "none" },
  dateArrow: { color: ACCENT, fontSize: 12 },

  segmentGroup: { display: "flex", background: "#F5F6FB", border: `1px solid ${BORDER}`, borderRadius: 10, padding: 3 },
  segmentBtn: { border: "none", background: "transparent", padding: "6px 12px", fontSize: 12.5, fontWeight: 600, color: MUTED, borderRadius: 8, cursor: "pointer" },
  segmentBtnActive: { background: INK, color: "#fff" },

  refreshBtn: { display: "flex", alignItems: "center", gap: 7, background: ACCENT, color: "#fff", border: "none", padding: "9px 16px", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: "pointer", boxShadow: "0 6px 16px -4px rgba(99,102,241,0.5)" },

  content: { padding: "clamp(12px,4vw,22px)", maxWidth: 1400, width: "100%", margin: "0 auto", boxSizing: "border-box" },

  welcomeRow: { display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 14, marginBottom: 18 },
  welcomeTitle: { fontFamily: "'Manrope', sans-serif", fontSize: "clamp(18px,4vw,21px)", fontWeight: 800, color: INK },
  welcomeSub: { fontSize: 13, color: MUTED, marginTop: 3 },
  chipRow: { display: "flex", gap: 10, flexWrap: "wrap", background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 16, padding: "10px 16px" },
  chip: { display: "flex", alignItems: "center", gap: 8, paddingRight: 14, borderRight: `1px solid ${BORDER}` },
  chipIcon: { width: 30, height: 30, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  chipValue: { fontSize: 14.5, fontWeight: 800, fontFamily: "'Manrope', sans-serif", lineHeight: 1.1 },
  chipLabel: { fontSize: 10.5, color: MUTED, fontWeight: 500, whiteSpace: "nowrap" },

  kpiRow: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16, marginBottom: 18 },
  kpiCard: { borderRadius: 18, padding: "18px 20px", color: "#fff", position: "relative", overflow: "hidden", boxShadow: "0 14px 30px -14px rgba(50,50,93,0.35)" },
  kpiTopRow: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  kpiIconWrap: { width: 34, height: 34, borderRadius: "50%", background: "rgba(255,255,255,0.22)", display: "flex", alignItems: "center", justifyContent: "center" },
  kpiTitle: { fontSize: 12.5, fontWeight: 600, opacity: 0.9, marginTop: 14 },
  kpiValue: { fontFamily: "'Manrope', sans-serif", fontSize: "clamp(20px,5vw,25px)", fontWeight: 800, marginTop: 3 },
  kpiFootRow: { display: "flex", alignItems: "center", gap: 8, marginTop: 8, flexWrap: "wrap", minHeight: 20 },
  kpiDeltaPill: { display: "inline-flex", alignItems: "center", gap: 3, fontSize: 11, fontWeight: 700, background: "rgba(255,255,255,0.22)", padding: "2px 8px", borderRadius: 999 },
  kpiPlainFoot: { fontSize: 11.5, opacity: 0.92, fontWeight: 500 },
  kpiSparkWrap: { marginTop: 10, marginLeft: -4, marginRight: -4 },

  chartsGrid: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 18 },
  card: { background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 18, padding: 16, minWidth: 0 },
  cardTitleRow: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8, gap: 8, flexWrap: "wrap" },
  cardTitle: { fontSize: 13.5, fontWeight: 700, color: INK },
  cardIconBadge: { width: 26, height: 26, borderRadius: 8, background: ACCENT_SOFT, display: "flex", alignItems: "center", justifyContent: "center" },

  chartHeadline: { display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap", marginBottom: 2 },
  chartHeadlineValue: { fontFamily: "'Manrope', sans-serif", fontSize: "clamp(16px,4vw,19px)", fontWeight: 800, color: INK },
  chartHeadlineDelta: { display: "inline-flex", alignItems: "center", gap: 2, fontSize: 11, fontWeight: 700, color: "#10B981" },

  legendRowSm: { display: "flex", gap: 12, marginBottom: 4 },
  legendChip: { display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: MUTED, fontWeight: 600 },
  legendDotSm: { width: 7, height: 7, borderRadius: "50%", display: "inline-block" },

  donutCenter: { position: "absolute", top: "44%", left: "50%", transform: "translate(-50%,-50%)", textAlign: "center" },
  donutCenterValue: { fontSize: 16, fontWeight: 800, color: INK, fontFamily: "'Manrope', sans-serif" },
  donutCenterLabel: { fontSize: 9.5, color: MUTED },
  subsLegendRow: { display: "flex", alignItems: "center", gap: 7, padding: "3px 0" },
  subsLegendName: { fontSize: 11, color: "#3A4152", fontWeight: 500, flex: 1 },
  subsLegendValue: { fontSize: 11.5, fontWeight: 700, color: INK },

  bottomGrid: { display: "grid", gridTemplateColumns: "1.3fr 1.3fr 1fr", gap: 16, marginBottom: 18 },
  viewAllLink: { border: "none", background: "transparent", color: ACCENT, fontSize: 12, fontWeight: 700, cursor: "pointer" },

  actionsGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 },
  actionBtn: { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 14, border: "none", borderRadius: 14, padding: "14px 12px", color: "#fff", fontSize: 11.5, fontWeight: 700, cursor: "pointer", textAlign: "left" },

  sectionTitleWrap: { display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: "30px 0 12px" },
  sectionEyebrow: { fontSize: 11, fontWeight: 700, color: ACCENT, textTransform: "uppercase", letterSpacing: 0.4 },
  sectionTitle: { fontFamily: "'Manrope', sans-serif", fontSize: 17, fontWeight: 800, marginTop: 2, color: INK },

  grid5: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12 },
  grid4: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 14 },
  grid3: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 14 },
  grid2: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 14 },

  miniStat: { background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 16, padding: 14 },
  miniStatLabel: { fontSize: 11.5, color: MUTED, fontWeight: 600 },
  miniStatValue: { fontFamily: "'Manrope', sans-serif", fontSize: 19, fontWeight: 700, marginTop: 4 },
  miniStatDelta: { display: "flex", alignItems: "center", gap: 3, fontSize: 11, fontWeight: 700, marginTop: 6 },

  statRow: { display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "1px dashed #F0F1F8" },
  statRowKey: { color: MUTED, fontSize: 13, fontWeight: 500 },
  statRowVal: { fontWeight: 700, fontFamily: "monospace", fontSize: 13 },

  table: { width: "100%", borderCollapse: "collapse", fontSize: 12.5 },
  th: { textAlign: "left", padding: "9px 12px", fontSize: 10.5, background: "#FAFAFE", color: MUTED, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.3, borderBottom: `1px solid ${BORDER}`, whiteSpace: "nowrap" },
  td: { padding: "10px 12px", fontWeight: 500, borderTop: "1px solid #F5F6FC", color: INK, whiteSpace: "nowrap" },
  tdEmpty: { padding: "24px 12px", textAlign: "center", color: MUTED, fontSize: 13 },
  mono: { fontFamily: "monospace", fontSize: 12 },
  rowClickable: { cursor: "pointer" },
  tableScroll: { overflowX: "auto", WebkitOverflowScrolling: "touch" },
  nameCell: { display: "flex", alignItems: "center", gap: 8 },
  avatar: { width: 24, height: 24, borderRadius: "50%", color: "#fff", fontSize: 9.5, fontWeight: 800, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  avatarLg: { width: 44, height: 44, flexShrink: 0, borderRadius: "50%", background: "linear-gradient(135deg,#6366F1,#8B5CF6)", color: "#FFFFFF", fontSize: 17, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" },
  badge: { display: "inline-block", padding: "3px 9px", borderRadius: 999, fontSize: 10.5, fontWeight: 700, whiteSpace: "nowrap" },

  chartCard: { background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 18, padding: "18px 8px 10px" },
  tooltip: { background: INK, color: "#fff", borderRadius: 12, padding: "10px 12px", fontSize: 12, boxShadow: "0 10px 30px rgba(0,0,0,0.2)" },
  tooltipLabel: { fontSize: 11, color: "#9AA3B8", marginBottom: 6 },
  tooltipRow: { display: "flex", alignItems: "center", gap: 6, marginTop: 2 },
  tooltipDot: { width: 7, height: 7, borderRadius: "50%" },

  miniTooltip: { background: INK, color: "#fff", borderRadius: 10, padding: "8px 10px", fontSize: 11, boxShadow: "0 10px 24px rgba(0,0,0,0.2)" },
  miniTooltipLabel: { fontSize: 10, color: "#9AA3B8", marginBottom: 3 },
  miniTooltipRow: { display: "flex", alignItems: "center", gap: 6 },

  searchBar: { display: "flex", alignItems: "center", gap: 10, background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 14, padding: "12px 16px", marginBottom: 14 },
  searchInput: { flex: 1, border: "none", outline: "none", fontSize: 14, background: "transparent", color: INK, minWidth: 0 },
  inlineError: { background: "#FDEAEA", color: "#F43F5E", borderRadius: 12, padding: "10px 14px", fontSize: 13, marginBottom: 12, fontWeight: 600 },

  reportTile: { display: "flex", alignItems: "center", gap: 10, background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 16, padding: 16, cursor: "pointer", fontSize: 13, fontWeight: 700, color: INK, transition: "all 0.15s ease" },
  reportTileIcon: { width: 32, height: 32, borderRadius: 10, background: ACCENT_SOFT, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  reportTileActive: { borderColor: ACCENT, background: ACCENT_SOFT },

  filterBar: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 14, padding: "12px 16px", marginBottom: 16, background: "#FFFFFF", border: `1px solid ${BORDER}`, boxShadow: CARD_SHADOW, borderRadius: 14 },
  segmented: { display: "flex", background: "#F5F6FB", borderRadius: 10, padding: 3, gap: 2 },
  segmentedBtn: { border: "none", background: "transparent", padding: "6px 12px", fontSize: 12.5, fontWeight: 500, color: MUTED, borderRadius: 8, cursor: "pointer" },
  segmentedBtnActive: { background: "#FFFFFF", color: INK, boxShadow: "0 1px 3px rgba(99,102,241,0.2)" },
  dateGroup: { display: "flex", alignItems: "flex-end", gap: 10, flexWrap: "wrap" },
  dateField: { display: "flex", flexDirection: "column", gap: 4 },
  dateLabelSm: { fontSize: 11, color: MUTED, fontWeight: 500, letterSpacing: "0.02em", textTransform: "uppercase" },
  dateInputBox: { border: `1px solid ${BORDER}`, borderRadius: 8, padding: "6px 9px", fontSize: 13, color: INK, background: "#FFFFFF", outline: "none" },
  dateSep: { color: "#B4BDD1", paddingBottom: 7, fontSize: 13 },
  filterActions: { display: "flex", gap: 8, marginLeft: "auto" },
  ghostBtn: { border: "1px solid transparent", background: "transparent", color: MUTED, fontSize: 12.5, fontWeight: 500, padding: "8px 12px", borderRadius: 8, cursor: "pointer" },
  applyBtn: { border: "none", background: ACCENT, color: "#FFFFFF", fontSize: 12.5, fontWeight: 600, padding: "8px 16px", borderRadius: 8 },
  emptyState: { padding: "40px 20px", textAlign: "center", fontSize: 13, color: MUTED },

  overlay: { position: "fixed", inset: 0, background: "rgba(15,17,35,0.45)", zIndex: 9999, display: "flex", justifyContent: "center", alignItems: "center", padding: 12, boxSizing: "border-box" },
  modal: { background: "#FFFFFF", borderRadius: 20, boxShadow: "0 30px 60px rgba(23,26,53,0.25)", overflow: "hidden", display: "flex", flexDirection: "column", maxWidth: "94vw" },
  modalHead: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px" },
  modalTitle: { margin: 0, fontFamily: "'Manrope', sans-serif", fontSize: 15, fontWeight: 700, textTransform: "capitalize" },
  modalCount: { fontSize: 12, color: MUTED },
  modalFooter: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 18px", borderTop: `1px solid ${BORDER}`, flexWrap: "wrap", gap: 8 },
  modalFooterHint: { fontSize: 12, color: MUTED },
  downloadBtn: { display: "flex", alignItems: "center", gap: 6, border: "none", background: "#10B981", color: "#FFFFFF", fontSize: 12.5, fontWeight: 700, padding: "9px 16px", borderRadius: 10, cursor: "pointer" },

  iconBtn: { border: `1px solid ${BORDER}`, background: "#FFFFFF", borderRadius: 9, width: 30, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: MUTED },

  panel: { width: "min(460px, 100vw)", height: "100vh", background: "#FFFFFF", boxShadow: "-16px 0 44px rgba(23,26,53,0.16)", display: "flex", flexDirection: "column", boxSizing: "border-box", marginLeft: "auto" },
  panelHead: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: `1px solid ${BORDER}`, flexShrink: 0 },
  eyebrow: { fontSize: 11.5, fontWeight: 700, color: ACCENT, letterSpacing: "0.03em", textTransform: "uppercase" },
  panelBody: { flex: 1, overflowY: "auto", padding: 20, boxSizing: "border-box" },

  hero: { display: "flex", alignItems: "center", gap: 12, marginBottom: 18 },
  heroText: { minWidth: 0 },
  name: { fontSize: 16, fontWeight: 700, fontFamily: "'Manrope', sans-serif", color: INK, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  metaLine: { fontSize: 12.5, color: MUTED, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },

  tabBar: { display: "flex", gap: 2, background: "#F5F6FB", borderRadius: 12, padding: 3, marginBottom: 16, overflowX: "auto" },
  tabBtn: { flexShrink: 0, display: "flex", alignItems: "center", gap: 5, border: "none", background: "transparent", padding: "7px 11px", fontSize: 12.5, fontWeight: 500, color: MUTED, borderRadius: 9, cursor: "pointer", whiteSpace: "nowrap" },
  tabBtnActive: { background: "#FFFFFF", color: INK, boxShadow: "0 1px 3px rgba(99,102,241,0.2)" },
  tabCount: { fontSize: 10, fontWeight: 700, color: ACCENT, background: ACCENT_SOFT, borderRadius: 999, padding: "1px 6px" },

  overviewGrid: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 },
  statCard: { border: `1px solid ${BORDER}`, borderRadius: 12, padding: "12px 10px", background: "#FAFAFE", textAlign: "center" },
  statValue: { fontSize: 19, fontWeight: 700, color: INK, fontFamily: "'Manrope', sans-serif" },
  statLabel: { fontSize: 11, color: MUTED, marginTop: 2 },

  timelineWrap: { position: "relative", paddingLeft: 18 },
  timelineRail: { position: "absolute", left: 4, top: 4, bottom: 4, width: 1, background: BORDER },
  timelineItem: { position: "relative", marginBottom: 14 },
  timelineNode: { position: "absolute", left: -18, top: 4, width: 8, height: 8, borderRadius: "50%" },
  timelineCard: { border: `1px solid ${BORDER}`, borderRadius: 12, padding: "10px 12px", background: "#FFFFFF" },
  timelineTop: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 4, flexWrap: "wrap" },
  timelineLabel: { display: "flex", alignItems: "center", gap: 5, fontSize: 12.5, fontWeight: 600, color: INK },
  timelineDate: { fontSize: 11, color: MUTED, whiteSpace: "nowrap" },
  helpText: { fontSize: 13, color: MUTED, lineHeight: 1.6, padding: "8px 0" },

  center: { minHeight: "50vh", display: "grid", placeItems: "center" },
  centerCompact: { minHeight: 200, display: "grid", placeItems: "center" },
  loaderBox: { display: "flex", gap: 10, alignItems: "center" },
  loaderText: { fontWeight: 600, color: MUTED, fontSize: 13.5 },

  errorBox: { textAlign: "center", maxWidth: 320 },
  errorTitle: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15, marginTop: 10 },
  errorMsg: { color: MUTED, fontSize: 13, marginTop: 6 },
  retryBtn: { marginTop: 14, background: INK, color: "#fff", border: "none", padding: "9px 18px", borderRadius: 12, fontWeight: 700, cursor: "pointer" },

  demoNote: { marginTop: 16, fontSize: 11.5, color: MUTED, textAlign: "center" },
};